module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "fb15");
/******/ })
/************************************************************************/
/******/ ({

/***/ "00ee":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';


/***/ }),

/***/ "01b4":
/***/ (function(module, exports) {

var Queue = function () {
  this.head = null;
  this.tail = null;
};

Queue.prototype = {
  add: function (item) {
    var entry = { item: item, next: null };
    if (this.head) this.tail.next = entry;
    else this.head = entry;
    this.tail = entry;
  },
  get: function () {
    var entry = this.head;
    if (entry) {
      this.head = entry.next;
      if (this.tail === entry) this.tail = null;
      return entry.item;
    }
  }
};

module.exports = Queue;


/***/ }),

/***/ "0366":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");
var aCallable = __webpack_require__("59ed");
var NATIVE_BIND = __webpack_require__("40d5");

var bind = uncurryThis(uncurryThis.bind);

// optional / simple context binding
module.exports = function (fn, that) {
  aCallable(fn);
  return that === undefined ? fn : NATIVE_BIND ? bind(fn, that) : function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "04f8":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable es/no-symbol -- required for testing */
var V8_VERSION = __webpack_require__("2d00");
var fails = __webpack_require__("d039");

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});


/***/ }),

/***/ "057f":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable es/no-object-getownpropertynames -- safe */
var classof = __webpack_require__("c6b6");
var toIndexedObject = __webpack_require__("fc6a");
var $getOwnPropertyNames = __webpack_require__("241c").f;
var arraySlice = __webpack_require__("4dae");

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return $getOwnPropertyNames(it);
  } catch (error) {
    return arraySlice(windowNames);
  }
};

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && classof(it) == 'Window'
    ? getWindowNames(it)
    : $getOwnPropertyNames(toIndexedObject(it));
};


/***/ }),

/***/ "06cf":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var call = __webpack_require__("c65b");
var propertyIsEnumerableModule = __webpack_require__("d1e7");
var createPropertyDescriptor = __webpack_require__("5c6c");
var toIndexedObject = __webpack_require__("fc6a");
var toPropertyKey = __webpack_require__("a04b");
var hasOwn = __webpack_require__("1a2d");
var IE8_DOM_DEFINE = __webpack_require__("0cfb");

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPropertyKey(P);
  if (IE8_DOM_DEFINE) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn(O, P)) return createPropertyDescriptor(!call(propertyIsEnumerableModule.f, O, P), O[P]);
};


/***/ }),

/***/ "07fa":
/***/ (function(module, exports, __webpack_require__) {

var toLength = __webpack_require__("50c4");

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
module.exports = function (obj) {
  return toLength(obj.length);
};


/***/ }),

/***/ "0b42":
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__("e8b5");
var isConstructor = __webpack_require__("68ee");
var isObject = __webpack_require__("861d");
var wellKnownSymbol = __webpack_require__("b622");

var SPECIES = wellKnownSymbol('species');
var $Array = Array;

// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (isConstructor(C) && (C === $Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? $Array : C;
};


/***/ }),

/***/ "0b43":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_SYMBOL = __webpack_require__("04f8");

/* eslint-disable es/no-symbol -- safe */
module.exports = NATIVE_SYMBOL && !!Symbol['for'] && !!Symbol.keyFor;


/***/ }),

/***/ "0c47":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var setToStringTag = __webpack_require__("d44e");

// JSON[@@toStringTag] property
// https://tc39.es/ecma262/#sec-json-@@tostringtag
setToStringTag(global.JSON, 'JSON', true);


/***/ }),

/***/ "0cfb":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var fails = __webpack_require__("d039");
var createElement = __webpack_require__("cc12");

// Thanks to IE8 for its funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});


/***/ }),

/***/ "0d26":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");

var $Error = Error;
var replace = uncurryThis(''.replace);

var TEST = (function (arg) { return String($Error(arg).stack); })('zxcasd');
var V8_OR_CHAKRA_STACK_ENTRY = /\n\s*at [^:]*:[^\n]*/;
var IS_V8_OR_CHAKRA_STACK = V8_OR_CHAKRA_STACK_ENTRY.test(TEST);

module.exports = function (stack, dropEntries) {
  if (IS_V8_OR_CHAKRA_STACK && typeof stack == 'string' && !$Error.prepareStackTrace) {
    while (dropEntries--) stack = replace(stack, V8_OR_CHAKRA_STACK_ENTRY, '');
  } return stack;
};


/***/ }),

/***/ "0d51":
/***/ (function(module, exports) {

var $String = String;

module.exports = function (argument) {
  try {
    return $String(argument);
  } catch (error) {
    return 'Object';
  }
};


/***/ }),

/***/ "131a":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var setPrototypeOf = __webpack_require__("d2bb");

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
$({ target: 'Object', stat: true }, {
  setPrototypeOf: setPrototypeOf
});


/***/ }),

/***/ "13d2":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var isCallable = __webpack_require__("1626");
var hasOwn = __webpack_require__("1a2d");
var DESCRIPTORS = __webpack_require__("83ab");
var CONFIGURABLE_FUNCTION_NAME = __webpack_require__("5e77").CONFIGURABLE;
var inspectSource = __webpack_require__("8925");
var InternalStateModule = __webpack_require__("69f3");

var enforceInternalState = InternalStateModule.enforce;
var getInternalState = InternalStateModule.get;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;

var CONFIGURABLE_LENGTH = DESCRIPTORS && !fails(function () {
  return defineProperty(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn = module.exports = function (value, name, options) {
  if (String(name).slice(0, 7) === 'Symbol(') {
    name = '[' + String(name).replace(/^Symbol\(([^)]*)\)/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwn(value, 'name') || (CONFIGURABLE_FUNCTION_NAME && value.name !== name)) {
    if (DESCRIPTORS) defineProperty(value, 'name', { value: name, configurable: true });
    else value.name = name;
  }
  if (CONFIGURABLE_LENGTH && options && hasOwn(options, 'arity') && value.length !== options.arity) {
    defineProperty(value, 'length', { value: options.arity });
  }
  try {
    if (options && hasOwn(options, 'constructor') && options.constructor) {
      if (DESCRIPTORS) defineProperty(value, 'prototype', { writable: false });
    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
    } else if (value.prototype) value.prototype = undefined;
  } catch (error) { /* empty */ }
  var state = enforceInternalState(value);
  if (!hasOwn(state, 'source')) {
    state.source = TEMPLATE.join(typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn(function toString() {
  return isCallable(this) && getInternalState(this).source || inspectSource(this);
}, 'toString');


/***/ }),

/***/ "14d9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var toObject = __webpack_require__("7b0b");
var lengthOfArrayLike = __webpack_require__("07fa");
var setArrayLength = __webpack_require__("3a34");
var doesNotExceedSafeInteger = __webpack_require__("3511");
var fails = __webpack_require__("d039");

var INCORRECT_TO_LENGTH = fails(function () {
  return [].push.call({ length: 0x100000000 }, 1) !== 4294967297;
});

// V8 and Safari <= 15.4, FF < 23 throws InternalError
// https://bugs.chromium.org/p/v8/issues/detail?id=12681
var SILENT_ON_NON_WRITABLE_LENGTH = !function () {
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty([], 'length', { writable: false }).push();
  } catch (error) {
    return error instanceof TypeError;
  }
}();

// `Array.prototype.push` method
// https://tc39.es/ecma262/#sec-array.prototype.push
$({ target: 'Array', proto: true, arity: 1, forced: INCORRECT_TO_LENGTH || SILENT_ON_NON_WRITABLE_LENGTH }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  push: function push(item) {
    var O = toObject(this);
    var len = lengthOfArrayLike(O);
    var argCount = arguments.length;
    doesNotExceedSafeInteger(len + argCount);
    for (var i = 0; i < argCount; i++) {
      O[len] = arguments[i];
      len++;
    }
    setArrayLength(O, len);
    return len;
  }
});


/***/ }),

/***/ "14e5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var call = __webpack_require__("c65b");
var aCallable = __webpack_require__("59ed");
var newPromiseCapabilityModule = __webpack_require__("f069");
var perform = __webpack_require__("e667");
var iterate = __webpack_require__("2266");
var PROMISE_STATICS_INCORRECT_ITERATION = __webpack_require__("5eed");

// `Promise.all` method
// https://tc39.es/ecma262/#sec-promise.all
$({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION }, {
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        remaining++;
        call($promiseResolve, C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});


/***/ }),

/***/ "159b":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var DOMIterables = __webpack_require__("fdbc");
var DOMTokenListPrototype = __webpack_require__("785a");
var forEach = __webpack_require__("17c2");
var createNonEnumerableProperty = __webpack_require__("9112");

var handlePrototype = function (CollectionPrototype) {
  // some Chrome versions have non-configurable methods on DOMTokenList
  if (CollectionPrototype && CollectionPrototype.forEach !== forEach) try {
    createNonEnumerableProperty(CollectionPrototype, 'forEach', forEach);
  } catch (error) {
    CollectionPrototype.forEach = forEach;
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  if (DOMIterables[COLLECTION_NAME]) {
    handlePrototype(global[COLLECTION_NAME] && global[COLLECTION_NAME].prototype);
  }
}

handlePrototype(DOMTokenListPrototype);


/***/ }),

/***/ "1626":
/***/ (function(module, exports, __webpack_require__) {

var $documentAll = __webpack_require__("8ea1");

var documentAll = $documentAll.all;

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
module.exports = $documentAll.IS_HTMLDDA ? function (argument) {
  return typeof argument == 'function' || argument === documentAll;
} : function (argument) {
  return typeof argument == 'function';
};


/***/ }),

/***/ "17c2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $forEach = __webpack_require__("b727").forEach;
var arrayMethodIsStrict = __webpack_require__("a640");

var STRICT_METHOD = arrayMethodIsStrict('forEach');

// `Array.prototype.forEach` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.foreach
module.exports = !STRICT_METHOD ? function forEach(callbackfn /* , thisArg */) {
  return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
} : [].forEach;


/***/ }),

/***/ "19aa":
/***/ (function(module, exports, __webpack_require__) {

var isPrototypeOf = __webpack_require__("3a9b");

var $TypeError = TypeError;

module.exports = function (it, Prototype) {
  if (isPrototypeOf(Prototype, it)) return it;
  throw $TypeError('Incorrect invocation');
};


/***/ }),

/***/ "1a2d":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");
var toObject = __webpack_require__("7b0b");

var hasOwnProperty = uncurryThis({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
module.exports = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject(it), key);
};


/***/ }),

/***/ "1be4":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("d066");

module.exports = getBuiltIn('document', 'documentElement');


/***/ }),

/***/ "1c7e":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");

var ITERATOR = wellKnownSymbol('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR] = function () {
    return this;
  };
  // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

module.exports = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};


/***/ }),

/***/ "1cdc":
/***/ (function(module, exports, __webpack_require__) {

var userAgent = __webpack_require__("342f");

module.exports = /(?:ipad|iphone|ipod).*applewebkit/i.test(userAgent);


/***/ }),

/***/ "1d80":
/***/ (function(module, exports, __webpack_require__) {

var isNullOrUndefined = __webpack_require__("7234");

var $TypeError = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (isNullOrUndefined(it)) throw $TypeError("Can't call method on " + it);
  return it;
};


/***/ }),

/***/ "1dde":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var wellKnownSymbol = __webpack_require__("b622");
var V8_VERSION = __webpack_require__("2d00");

var SPECIES = wellKnownSymbol('species');

module.exports = function (METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return V8_VERSION >= 51 || !fails(function () {
    var array = [];
    var constructor = array.constructor = {};
    constructor[SPECIES] = function () {
      return { foo: 1 };
    };
    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};


/***/ }),

/***/ "1f68":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__("83ab");
var defineBuiltInAccessor = __webpack_require__("edd0");
var isObject = __webpack_require__("861d");
var toObject = __webpack_require__("7b0b");
var requireObjectCoercible = __webpack_require__("1d80");

// eslint-disable-next-line es/no-object-getprototypeof -- safe
var getPrototypeOf = Object.getPrototypeOf;
// eslint-disable-next-line es/no-object-setprototypeof -- safe
var setPrototypeOf = Object.setPrototypeOf;
var ObjectPrototype = Object.prototype;
var PROTO = '__proto__';

// `Object.prototype.__proto__` accessor
// https://tc39.es/ecma262/#sec-object.prototype.__proto__
if (DESCRIPTORS && getPrototypeOf && setPrototypeOf && !(PROTO in ObjectPrototype)) try {
  defineBuiltInAccessor(ObjectPrototype, PROTO, {
    configurable: true,
    get: function __proto__() {
      return getPrototypeOf(toObject(this));
    },
    set: function __proto__(proto) {
      var O = requireObjectCoercible(this);
      if (!isObject(proto) && proto !== null || !isObject(O)) return;
      setPrototypeOf(O, proto);
    }
  });
} catch (error) { /* empty */ }


/***/ }),

/***/ "2266":
/***/ (function(module, exports, __webpack_require__) {

var bind = __webpack_require__("0366");
var call = __webpack_require__("c65b");
var anObject = __webpack_require__("825a");
var tryToString = __webpack_require__("0d51");
var isArrayIteratorMethod = __webpack_require__("e95a");
var lengthOfArrayLike = __webpack_require__("07fa");
var isPrototypeOf = __webpack_require__("3a9b");
var getIterator = __webpack_require__("9a1f");
var getIteratorMethod = __webpack_require__("35a1");
var iteratorClose = __webpack_require__("2a62");

var $TypeError = TypeError;

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

var ResultPrototype = Result.prototype;

module.exports = function (iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_RECORD = !!(options && options.IS_RECORD);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = bind(unboundFunction, that);
  var iterator, iterFn, index, length, result, next, step;

  var stop = function (condition) {
    if (iterator) iteratorClose(iterator, 'normal', condition);
    return new Result(true, condition);
  };

  var callFn = function (value) {
    if (AS_ENTRIES) {
      anObject(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    } return INTERRUPTED ? fn(value, stop) : fn(value);
  };

  if (IS_RECORD) {
    iterator = iterable.iterator;
  } else if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (!iterFn) throw $TypeError(tryToString(iterable) + ' is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = lengthOfArrayLike(iterable); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && isPrototypeOf(ResultPrototype, result)) return result;
      } return new Result(false);
    }
    iterator = getIterator(iterable, iterFn);
  }

  next = IS_RECORD ? iterable.next : iterator.next;
  while (!(step = call(next, iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose(iterator, 'throw', error);
    }
    if (typeof result == 'object' && result && isPrototypeOf(ResultPrototype, result)) return result;
  } return new Result(false);
};


/***/ }),

/***/ "23cb":
/***/ (function(module, exports, __webpack_require__) {

var toIntegerOrInfinity = __webpack_require__("5926");

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toIntegerOrInfinity(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),

/***/ "23dc":
/***/ (function(module, exports, __webpack_require__) {

var setToStringTag = __webpack_require__("d44e");

// Math[@@toStringTag] property
// https://tc39.es/ecma262/#sec-math-@@tostringtag
setToStringTag(Math, 'Math', true);


/***/ }),

/***/ "23e7":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var getOwnPropertyDescriptor = __webpack_require__("06cf").f;
var createNonEnumerableProperty = __webpack_require__("9112");
var defineBuiltIn = __webpack_require__("cb2d");
var defineGlobalProperty = __webpack_require__("6374");
var copyConstructorProperties = __webpack_require__("e893");
var isForced = __webpack_require__("94ca");

/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global;
  } else if (STATIC) {
    target = global[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = (global[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    defineBuiltIn(target, key, sourceProperty, options);
  }
};


/***/ }),

/***/ "241c":
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__("ca84");
var enumBugKeys = __webpack_require__("7839");

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),

/***/ "2626":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__("d066");
var definePropertyModule = __webpack_require__("9bf2");
var wellKnownSymbol = __webpack_require__("b622");
var DESCRIPTORS = __webpack_require__("83ab");

var SPECIES = wellKnownSymbol('species');

module.exports = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn(CONSTRUCTOR_NAME);
  var defineProperty = definePropertyModule.f;

  if (DESCRIPTORS && Constructor && !Constructor[SPECIES]) {
    defineProperty(Constructor, SPECIES, {
      configurable: true,
      get: function () { return this; }
    });
  }
};


/***/ }),

/***/ "2a62":
/***/ (function(module, exports, __webpack_require__) {

var call = __webpack_require__("c65b");
var anObject = __webpack_require__("825a");
var getMethod = __webpack_require__("dc4a");

module.exports = function (iterator, kind, value) {
  var innerResult, innerError;
  anObject(iterator);
  try {
    innerResult = getMethod(iterator, 'return');
    if (!innerResult) {
      if (kind === 'throw') throw value;
      return value;
    }
    innerResult = call(innerResult, iterator);
  } catch (error) {
    innerError = true;
    innerResult = error;
  }
  if (kind === 'throw') throw value;
  if (innerError) throw innerResult;
  anObject(innerResult);
  return value;
};


/***/ }),

/***/ "2ba4":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_BIND = __webpack_require__("40d5");

var FunctionPrototype = Function.prototype;
var apply = FunctionPrototype.apply;
var call = FunctionPrototype.call;

// eslint-disable-next-line es/no-reflect -- safe
module.exports = typeof Reflect == 'object' && Reflect.apply || (NATIVE_BIND ? call.bind(apply) : function () {
  return call.apply(apply, arguments);
});


/***/ }),

/***/ "2cf4":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var apply = __webpack_require__("2ba4");
var bind = __webpack_require__("0366");
var isCallable = __webpack_require__("1626");
var hasOwn = __webpack_require__("1a2d");
var fails = __webpack_require__("d039");
var html = __webpack_require__("1be4");
var arraySlice = __webpack_require__("f36a");
var createElement = __webpack_require__("cc12");
var validateArgumentsLength = __webpack_require__("d6d6");
var IS_IOS = __webpack_require__("1cdc");
var IS_NODE = __webpack_require__("605d");

var set = global.setImmediate;
var clear = global.clearImmediate;
var process = global.process;
var Dispatch = global.Dispatch;
var Function = global.Function;
var MessageChannel = global.MessageChannel;
var String = global.String;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var $location, defer, channel, port;

try {
  // Deno throws a ReferenceError on `location` access without `--location` flag
  $location = global.location;
} catch (error) { /* empty */ }

var run = function (id) {
  if (hasOwn(queue, id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};

var runner = function (id) {
  return function () {
    run(id);
  };
};

var listener = function (event) {
  run(event.data);
};

var post = function (id) {
  // old engines have not location.origin
  global.postMessage(String(id), $location.protocol + '//' + $location.host);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set || !clear) {
  set = function setImmediate(handler) {
    validateArgumentsLength(arguments.length, 1);
    var fn = isCallable(handler) ? handler : Function(handler);
    var args = arraySlice(arguments, 1);
    queue[++counter] = function () {
      apply(fn, undefined, args);
    };
    defer(counter);
    return counter;
  };
  clear = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (IS_NODE) {
    defer = function (id) {
      process.nextTick(runner(id));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(runner(id));
    };
  // Browsers with MessageChannel, includes WebWorkers
  // except iOS - https://github.com/zloirock/core-js/issues/624
  } else if (MessageChannel && !IS_IOS) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = bind(port.postMessage, port);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (
    global.addEventListener &&
    isCallable(global.postMessage) &&
    !global.importScripts &&
    $location && $location.protocol !== 'file:' &&
    !fails(post)
  ) {
    defer = post;
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in createElement('script')) {
    defer = function (id) {
      html.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(runner(id), 0);
    };
  }
}

module.exports = {
  set: set,
  clear: clear
};


/***/ }),

/***/ "2d00":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var userAgent = __webpack_require__("342f");

var process = global.process;
var Deno = global.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

module.exports = version;


/***/ }),

/***/ "3410":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var fails = __webpack_require__("d039");
var toObject = __webpack_require__("7b0b");
var nativeGetPrototypeOf = __webpack_require__("e163");
var CORRECT_PROTOTYPE_GETTER = __webpack_require__("e177");

var FAILS_ON_PRIMITIVES = fails(function () { nativeGetPrototypeOf(1); });

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES, sham: !CORRECT_PROTOTYPE_GETTER }, {
  getPrototypeOf: function getPrototypeOf(it) {
    return nativeGetPrototypeOf(toObject(it));
  }
});



/***/ }),

/***/ "342f":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("d066");

module.exports = getBuiltIn('navigator', 'userAgent') || '';


/***/ }),

/***/ "3511":
/***/ (function(module, exports) {

var $TypeError = TypeError;
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991

module.exports = function (it) {
  if (it > MAX_SAFE_INTEGER) throw $TypeError('Maximum allowed index exceeded');
  return it;
};


/***/ }),

/***/ "3529":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var call = __webpack_require__("c65b");
var aCallable = __webpack_require__("59ed");
var newPromiseCapabilityModule = __webpack_require__("f069");
var perform = __webpack_require__("e667");
var iterate = __webpack_require__("2266");
var PROMISE_STATICS_INCORRECT_ITERATION = __webpack_require__("5eed");

// `Promise.race` method
// https://tc39.es/ecma262/#sec-promise.race
$({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION }, {
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule.f(C);
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable(C.resolve);
      iterate(iterable, function (promise) {
        call($promiseResolve, C, promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});


/***/ }),

/***/ "35a1":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("f5df");
var getMethod = __webpack_require__("dc4a");
var isNullOrUndefined = __webpack_require__("7234");
var Iterators = __webpack_require__("3f8c");
var wellKnownSymbol = __webpack_require__("b622");

var ITERATOR = wellKnownSymbol('iterator');

module.exports = function (it) {
  if (!isNullOrUndefined(it)) return getMethod(it, ITERATOR)
    || getMethod(it, '@@iterator')
    || Iterators[classof(it)];
};


/***/ }),

/***/ "37e8":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__("aed9");
var definePropertyModule = __webpack_require__("9bf2");
var anObject = __webpack_require__("825a");
var toIndexedObject = __webpack_require__("fc6a");
var objectKeys = __webpack_require__("df75");

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
exports.f = DESCRIPTORS && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var props = toIndexedObject(Properties);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], props[key]);
  return O;
};


/***/ }),

/***/ "3a34":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__("83ab");
var isArray = __webpack_require__("e8b5");

var $TypeError = TypeError;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Safari < 13 does not throw an error in this case
var SILENT_ON_NON_WRITABLE_LENGTH_SET = DESCRIPTORS && !function () {
  // makes no sense without proper strict mode support
  if (this !== undefined) return true;
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty([], 'length', { writable: false }).length = 1;
  } catch (error) {
    return error instanceof TypeError;
  }
}();

module.exports = SILENT_ON_NON_WRITABLE_LENGTH_SET ? function (O, length) {
  if (isArray(O) && !getOwnPropertyDescriptor(O, 'length').writable) {
    throw $TypeError('Cannot set read only .length');
  } return O.length = length;
} : function (O, length) {
  return O.length = length;
};


/***/ }),

/***/ "3a9b":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");

module.exports = uncurryThis({}.isPrototypeOf);


/***/ }),

/***/ "3bbe":
/***/ (function(module, exports, __webpack_require__) {

var isCallable = __webpack_require__("1626");

var $String = String;
var $TypeError = TypeError;

module.exports = function (argument) {
  if (typeof argument == 'object' || isCallable(argument)) return argument;
  throw $TypeError("Can't set " + $String(argument) + ' as a prototype');
};


/***/ }),

/***/ "3ca3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var charAt = __webpack_require__("6547").charAt;
var toString = __webpack_require__("577e");
var InternalStateModule = __webpack_require__("69f3");
var defineIterator = __webpack_require__("c6d2");
var createIterResultObject = __webpack_require__("4754");

var STRING_ITERATOR = 'String Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, 'String', function (iterated) {
  setInternalState(this, {
    type: STRING_ITERATOR,
    string: toString(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return createIterResultObject(undefined, true);
  point = charAt(string, index);
  state.index += point.length;
  return createIterResultObject(point, false);
});


/***/ }),

/***/ "3dc2":
/***/ (function(module, exports, __webpack_require__) {

if (true) {
  module.exports = __webpack_require__("c097");
} else {}

/***/ }),

/***/ "3f8c":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "40d5":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

module.exports = !fails(function () {
  // eslint-disable-next-line es/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});


/***/ }),

/***/ "428f":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");

module.exports = global;


/***/ }),

/***/ "44ad":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");
var fails = __webpack_require__("d039");
var classof = __webpack_require__("c6b6");

var $Object = Object;
var split = uncurryThis(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split(it, '') : $Object(it);
} : $Object;


/***/ }),

/***/ "44d2":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");
var create = __webpack_require__("7c73");
var defineProperty = __webpack_require__("9bf2").f;

var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] == undefined) {
  defineProperty(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create(null)
  });
}

// add a key to Array.prototype[@@unscopables]
module.exports = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};


/***/ }),

/***/ "44de":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");

module.exports = function (a, b) {
  var console = global.console;
  if (console && console.error) {
    arguments.length == 1 ? console.error(a) : console.error(a, b);
  }
};


/***/ }),

/***/ "4738":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var NativePromiseConstructor = __webpack_require__("d256");
var isCallable = __webpack_require__("1626");
var isForced = __webpack_require__("94ca");
var inspectSource = __webpack_require__("8925");
var wellKnownSymbol = __webpack_require__("b622");
var IS_BROWSER = __webpack_require__("6069");
var IS_DENO = __webpack_require__("6c59");
var IS_PURE = __webpack_require__("c430");
var V8_VERSION = __webpack_require__("2d00");

var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;
var SPECIES = wellKnownSymbol('species');
var SUBCLASSING = false;
var NATIVE_PROMISE_REJECTION_EVENT = isCallable(global.PromiseRejectionEvent);

var FORCED_PROMISE_CONSTRUCTOR = isForced('Promise', function () {
  var PROMISE_CONSTRUCTOR_SOURCE = inspectSource(NativePromiseConstructor);
  var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(NativePromiseConstructor);
  // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
  // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
  // We can't detect it synchronously, so just check versions
  if (!GLOBAL_CORE_JS_PROMISE && V8_VERSION === 66) return true;
  // We need Promise#{ catch, finally } in the pure version for preventing prototype pollution
  if (IS_PURE && !(NativePromisePrototype['catch'] && NativePromisePrototype['finally'])) return true;
  // We can't use @@species feature detection in V8 since it causes
  // deoptimization and performance degradation
  // https://github.com/zloirock/core-js/issues/679
  if (!V8_VERSION || V8_VERSION < 51 || !/native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) {
    // Detect correctness of subclassing with @@species support
    var promise = new NativePromiseConstructor(function (resolve) { resolve(1); });
    var FakePromise = function (exec) {
      exec(function () { /* empty */ }, function () { /* empty */ });
    };
    var constructor = promise.constructor = {};
    constructor[SPECIES] = FakePromise;
    SUBCLASSING = promise.then(function () { /* empty */ }) instanceof FakePromise;
    if (!SUBCLASSING) return true;
  // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
  } return !GLOBAL_CORE_JS_PROMISE && (IS_BROWSER || IS_DENO) && !NATIVE_PROMISE_REJECTION_EVENT;
});

module.exports = {
  CONSTRUCTOR: FORCED_PROMISE_CONSTRUCTOR,
  REJECTION_EVENT: NATIVE_PROMISE_REJECTION_EVENT,
  SUBCLASSING: SUBCLASSING
};


/***/ }),

/***/ "4754":
/***/ (function(module, exports) {

// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
module.exports = function (value, done) {
  return { value: value, done: done };
};


/***/ }),

/***/ "4840":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");
var aConstructor = __webpack_require__("5087");
var isNullOrUndefined = __webpack_require__("7234");
var wellKnownSymbol = __webpack_require__("b622");

var SPECIES = wellKnownSymbol('species');

// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
module.exports = function (O, defaultConstructor) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || isNullOrUndefined(S = anObject(C)[SPECIES]) ? defaultConstructor : aConstructor(S);
};


/***/ }),

/***/ "485a":
/***/ (function(module, exports, __webpack_require__) {

var call = __webpack_require__("c65b");
var isCallable = __webpack_require__("1626");
var isObject = __webpack_require__("861d");

var $TypeError = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
module.exports = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  if (isCallable(fn = input.valueOf) && !isObject(val = call(fn, input))) return val;
  if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  throw $TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "4c53":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var createHTML = __webpack_require__("857a");
var forcedStringHTMLMethod = __webpack_require__("af03");

// `String.prototype.sub` method
// https://tc39.es/ecma262/#sec-string.prototype.sub
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('sub') }, {
  sub: function sub() {
    return createHTML(this, 'sub', '', '');
  }
});


/***/ }),

/***/ "4d64":
/***/ (function(module, exports, __webpack_require__) {

var toIndexedObject = __webpack_require__("fc6a");
var toAbsoluteIndex = __webpack_require__("23cb");
var lengthOfArrayLike = __webpack_require__("07fa");

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = lengthOfArrayLike(O);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),

/***/ "4dae":
/***/ (function(module, exports, __webpack_require__) {

var toAbsoluteIndex = __webpack_require__("23cb");
var lengthOfArrayLike = __webpack_require__("07fa");
var createProperty = __webpack_require__("8418");

var $Array = Array;
var max = Math.max;

module.exports = function (O, start, end) {
  var length = lengthOfArrayLike(O);
  var k = toAbsoluteIndex(start, length);
  var fin = toAbsoluteIndex(end === undefined ? length : end, length);
  var result = $Array(max(fin - k, 0));
  for (var n = 0; k < fin; k++, n++) createProperty(result, n, O[k]);
  result.length = n;
  return result;
};


/***/ }),

/***/ "4de4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $filter = __webpack_require__("b727").filter;
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('filter');

// `Array.prototype.filter` method
// https://tc39.es/ecma262/#sec-array.prototype.filter
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "5087":
/***/ (function(module, exports, __webpack_require__) {

var isConstructor = __webpack_require__("68ee");
var tryToString = __webpack_require__("0d51");

var $TypeError = TypeError;

// `Assert: IsConstructor(argument) is true`
module.exports = function (argument) {
  if (isConstructor(argument)) return argument;
  throw $TypeError(tryToString(argument) + ' is not a constructor');
};


/***/ }),

/***/ "50c4":
/***/ (function(module, exports, __webpack_require__) {

var toIntegerOrInfinity = __webpack_require__("5926");

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),

/***/ "5692":
/***/ (function(module, exports, __webpack_require__) {

var IS_PURE = __webpack_require__("c430");
var store = __webpack_require__("c6cd");

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.26.0',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2014-2022 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.26.0/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});


/***/ }),

/***/ "56ef":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("d066");
var uncurryThis = __webpack_require__("e330");
var getOwnPropertyNamesModule = __webpack_require__("241c");
var getOwnPropertySymbolsModule = __webpack_require__("7418");
var anObject = __webpack_require__("825a");

var concat = uncurryThis([].concat);

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
};


/***/ }),

/***/ "577e":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("f5df");

var $String = String;

module.exports = function (argument) {
  if (classof(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
  return $String(argument);
};


/***/ }),

/***/ "57b9":
/***/ (function(module, exports, __webpack_require__) {

var call = __webpack_require__("c65b");
var getBuiltIn = __webpack_require__("d066");
var wellKnownSymbol = __webpack_require__("b622");
var defineBuiltIn = __webpack_require__("cb2d");

module.exports = function () {
  var Symbol = getBuiltIn('Symbol');
  var SymbolPrototype = Symbol && Symbol.prototype;
  var valueOf = SymbolPrototype && SymbolPrototype.valueOf;
  var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

  if (SymbolPrototype && !SymbolPrototype[TO_PRIMITIVE]) {
    // `Symbol.prototype[@@toPrimitive]` method
    // https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
    // eslint-disable-next-line no-unused-vars -- required for .length
    defineBuiltIn(SymbolPrototype, TO_PRIMITIVE, function (hint) {
      return call(valueOf, this);
    }, { arity: 1 });
  }
};


/***/ }),

/***/ "5926":
/***/ (function(module, exports, __webpack_require__) {

var trunc = __webpack_require__("b42e");

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
module.exports = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : trunc(number);
};


/***/ }),

/***/ "59ed":
/***/ (function(module, exports, __webpack_require__) {

var isCallable = __webpack_require__("1626");
var tryToString = __webpack_require__("0d51");

var $TypeError = TypeError;

// `Assert: IsCallable(argument) is true`
module.exports = function (argument) {
  if (isCallable(argument)) return argument;
  throw $TypeError(tryToString(argument) + ' is not a function');
};


/***/ }),

/***/ "5a47":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var NATIVE_SYMBOL = __webpack_require__("04f8");
var fails = __webpack_require__("d039");
var getOwnPropertySymbolsModule = __webpack_require__("7418");
var toObject = __webpack_require__("7b0b");

// V8 ~ Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FORCED = !NATIVE_SYMBOL || fails(function () { getOwnPropertySymbolsModule.f(1); });

// `Object.getOwnPropertySymbols` method
// https://tc39.es/ecma262/#sec-object.getownpropertysymbols
$({ target: 'Object', stat: true, forced: FORCED }, {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    var $getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
    return $getOwnPropertySymbols ? $getOwnPropertySymbols(toObject(it)) : [];
  }
});


/***/ }),

/***/ "5c6c":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "5e77":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var hasOwn = __webpack_require__("1a2d");

var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn(FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS || (DESCRIPTORS && getDescriptor(FunctionPrototype, 'name').configurable));

module.exports = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};


/***/ }),

/***/ "5e7e":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var IS_PURE = __webpack_require__("c430");
var IS_NODE = __webpack_require__("605d");
var global = __webpack_require__("da84");
var call = __webpack_require__("c65b");
var defineBuiltIn = __webpack_require__("cb2d");
var setPrototypeOf = __webpack_require__("d2bb");
var setToStringTag = __webpack_require__("d44e");
var setSpecies = __webpack_require__("2626");
var aCallable = __webpack_require__("59ed");
var isCallable = __webpack_require__("1626");
var isObject = __webpack_require__("861d");
var anInstance = __webpack_require__("19aa");
var speciesConstructor = __webpack_require__("4840");
var task = __webpack_require__("2cf4").set;
var microtask = __webpack_require__("b575");
var hostReportErrors = __webpack_require__("44de");
var perform = __webpack_require__("e667");
var Queue = __webpack_require__("01b4");
var InternalStateModule = __webpack_require__("69f3");
var NativePromiseConstructor = __webpack_require__("d256");
var PromiseConstructorDetection = __webpack_require__("4738");
var newPromiseCapabilityModule = __webpack_require__("f069");

var PROMISE = 'Promise';
var FORCED_PROMISE_CONSTRUCTOR = PromiseConstructorDetection.CONSTRUCTOR;
var NATIVE_PROMISE_REJECTION_EVENT = PromiseConstructorDetection.REJECTION_EVENT;
var NATIVE_PROMISE_SUBCLASSING = PromiseConstructorDetection.SUBCLASSING;
var getInternalPromiseState = InternalStateModule.getterFor(PROMISE);
var setInternalState = InternalStateModule.set;
var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;
var PromiseConstructor = NativePromiseConstructor;
var PromisePrototype = NativePromisePrototype;
var TypeError = global.TypeError;
var document = global.document;
var process = global.process;
var newPromiseCapability = newPromiseCapabilityModule.f;
var newGenericPromiseCapability = newPromiseCapability;

var DISPATCH_EVENT = !!(document && document.createEvent && global.dispatchEvent);
var UNHANDLED_REJECTION = 'unhandledrejection';
var REJECTION_HANDLED = 'rejectionhandled';
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;

var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && isCallable(then = it.then) ? then : false;
};

var callReaction = function (reaction, state) {
  var value = state.value;
  var ok = state.state == FULFILLED;
  var handler = ok ? reaction.ok : reaction.fail;
  var resolve = reaction.resolve;
  var reject = reaction.reject;
  var domain = reaction.domain;
  var result, then, exited;
  try {
    if (handler) {
      if (!ok) {
        if (state.rejection === UNHANDLED) onHandleUnhandled(state);
        state.rejection = HANDLED;
      }
      if (handler === true) result = value;
      else {
        if (domain) domain.enter();
        result = handler(value); // can throw
        if (domain) {
          domain.exit();
          exited = true;
        }
      }
      if (result === reaction.promise) {
        reject(TypeError('Promise-chain cycle'));
      } else if (then = isThenable(result)) {
        call(then, result, resolve, reject);
      } else resolve(result);
    } else reject(value);
  } catch (error) {
    if (domain && !exited) domain.exit();
    reject(error);
  }
};

var notify = function (state, isReject) {
  if (state.notified) return;
  state.notified = true;
  microtask(function () {
    var reactions = state.reactions;
    var reaction;
    while (reaction = reactions.get()) {
      callReaction(reaction, state);
    }
    state.notified = false;
    if (isReject && !state.rejection) onUnhandled(state);
  });
};

var dispatchEvent = function (name, promise, reason) {
  var event, handler;
  if (DISPATCH_EVENT) {
    event = document.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    global.dispatchEvent(event);
  } else event = { promise: promise, reason: reason };
  if (!NATIVE_PROMISE_REJECTION_EVENT && (handler = global['on' + name])) handler(event);
  else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
};

var onUnhandled = function (state) {
  call(task, global, function () {
    var promise = state.facade;
    var value = state.value;
    var IS_UNHANDLED = isUnhandled(state);
    var result;
    if (IS_UNHANDLED) {
      result = perform(function () {
        if (IS_NODE) {
          process.emit('unhandledRejection', value, promise);
        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
      if (result.error) throw result.value;
    }
  });
};

var isUnhandled = function (state) {
  return state.rejection !== HANDLED && !state.parent;
};

var onHandleUnhandled = function (state) {
  call(task, global, function () {
    var promise = state.facade;
    if (IS_NODE) {
      process.emit('rejectionHandled', promise);
    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
  });
};

var bind = function (fn, state, unwrap) {
  return function (value) {
    fn(state, value, unwrap);
  };
};

var internalReject = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED;
  notify(state, true);
};

var internalResolve = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  try {
    if (state.facade === value) throw TypeError("Promise can't be resolved itself");
    var then = isThenable(value);
    if (then) {
      microtask(function () {
        var wrapper = { done: false };
        try {
          call(then, value,
            bind(internalResolve, wrapper, state),
            bind(internalReject, wrapper, state)
          );
        } catch (error) {
          internalReject(wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED;
      notify(state, false);
    }
  } catch (error) {
    internalReject({ done: false }, error, state);
  }
};

// constructor polyfill
if (FORCED_PROMISE_CONSTRUCTOR) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor = function Promise(executor) {
    anInstance(this, PromisePrototype);
    aCallable(executor);
    call(Internal, this);
    var state = getInternalPromiseState(this);
    try {
      executor(bind(internalResolve, state), bind(internalReject, state));
    } catch (error) {
      internalReject(state, error);
    }
  };

  PromisePrototype = PromiseConstructor.prototype;

  // eslint-disable-next-line no-unused-vars -- required for `.length`
  Internal = function Promise(executor) {
    setInternalState(this, {
      type: PROMISE,
      done: false,
      notified: false,
      parent: false,
      reactions: new Queue(),
      rejection: false,
      state: PENDING,
      value: undefined
    });
  };

  // `Promise.prototype.then` method
  // https://tc39.es/ecma262/#sec-promise.prototype.then
  Internal.prototype = defineBuiltIn(PromisePrototype, 'then', function then(onFulfilled, onRejected) {
    var state = getInternalPromiseState(this);
    var reaction = newPromiseCapability(speciesConstructor(this, PromiseConstructor));
    state.parent = true;
    reaction.ok = isCallable(onFulfilled) ? onFulfilled : true;
    reaction.fail = isCallable(onRejected) && onRejected;
    reaction.domain = IS_NODE ? process.domain : undefined;
    if (state.state == PENDING) state.reactions.add(reaction);
    else microtask(function () {
      callReaction(reaction, state);
    });
    return reaction.promise;
  });

  OwnPromiseCapability = function () {
    var promise = new Internal();
    var state = getInternalPromiseState(promise);
    this.promise = promise;
    this.resolve = bind(internalResolve, state);
    this.reject = bind(internalReject, state);
  };

  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === PromiseConstructor || C === PromiseWrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };

  if (!IS_PURE && isCallable(NativePromiseConstructor) && NativePromisePrototype !== Object.prototype) {
    nativeThen = NativePromisePrototype.then;

    if (!NATIVE_PROMISE_SUBCLASSING) {
      // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
      defineBuiltIn(NativePromisePrototype, 'then', function then(onFulfilled, onRejected) {
        var that = this;
        return new PromiseConstructor(function (resolve, reject) {
          call(nativeThen, that, resolve, reject);
        }).then(onFulfilled, onRejected);
      // https://github.com/zloirock/core-js/issues/640
      }, { unsafe: true });
    }

    // make `.constructor === Promise` work for native promise-based APIs
    try {
      delete NativePromisePrototype.constructor;
    } catch (error) { /* empty */ }

    // make `instanceof Promise` work for native promise-based APIs
    if (setPrototypeOf) {
      setPrototypeOf(NativePromisePrototype, PromisePrototype);
    }
  }
}

$({ global: true, constructor: true, wrap: true, forced: FORCED_PROMISE_CONSTRUCTOR }, {
  Promise: PromiseConstructor
});

setToStringTag(PromiseConstructor, PROMISE, false, true);
setSpecies(PROMISE);


/***/ }),

/***/ "5eed":
/***/ (function(module, exports, __webpack_require__) {

var NativePromiseConstructor = __webpack_require__("d256");
var checkCorrectnessOfIteration = __webpack_require__("1c7e");
var FORCED_PROMISE_CONSTRUCTOR = __webpack_require__("4738").CONSTRUCTOR;

module.exports = FORCED_PROMISE_CONSTRUCTOR || !checkCorrectnessOfIteration(function (iterable) {
  NativePromiseConstructor.all(iterable).then(undefined, function () { /* empty */ });
});


/***/ }),

/***/ "605d":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("c6b6");
var global = __webpack_require__("da84");

module.exports = classof(global.process) == 'process';


/***/ }),

/***/ "6069":
/***/ (function(module, exports, __webpack_require__) {

var IS_DENO = __webpack_require__("6c59");
var IS_NODE = __webpack_require__("605d");

module.exports = !IS_DENO && !IS_NODE
  && typeof window == 'object'
  && typeof document == 'object';


/***/ }),

/***/ "6374":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;

module.exports = function (key, value) {
  try {
    defineProperty(global, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global[key] = value;
  } return value;
};


/***/ }),

/***/ "6547":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");
var toIntegerOrInfinity = __webpack_require__("5926");
var toString = __webpack_require__("577e");
var requireObjectCoercible = __webpack_require__("1d80");

var charAt = uncurryThis(''.charAt);
var charCodeAt = uncurryThis(''.charCodeAt);
var stringSlice = uncurryThis(''.slice);

var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = toString(requireObjectCoercible($this));
    var position = toIntegerOrInfinity(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = charCodeAt(S, position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING
          ? charAt(S, position)
          : first
        : CONVERT_TO_STRING
          ? stringSlice(S, position, position + 2)
          : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

module.exports = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};


/***/ }),

/***/ "65f0":
/***/ (function(module, exports, __webpack_require__) {

var arraySpeciesConstructor = __webpack_require__("0b42");

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray, length) {
  return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};


/***/ }),

/***/ "68ee":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");
var fails = __webpack_require__("d039");
var isCallable = __webpack_require__("1626");
var classof = __webpack_require__("f5df");
var getBuiltIn = __webpack_require__("d066");
var inspectSource = __webpack_require__("8925");

var noop = function () { /* empty */ };
var empty = [];
var construct = getBuiltIn('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec = uncurryThis(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.exec(noop);

var isConstructorModern = function isConstructor(argument) {
  if (!isCallable(argument)) return false;
  try {
    construct(noop, empty, argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy = function isConstructor(argument) {
  if (!isCallable(argument)) return false;
  switch (classof(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction': return false;
  }
  try {
    // we can't check .prototype since constructors produced by .bind haven't it
    // `Function#toString` throws on some built-it function in some legacy engines
    // (for example, `DOMQuad` and similar in FF41-)
    return INCORRECT_TO_STRING || !!exec(constructorRegExp, inspectSource(argument));
  } catch (error) {
    return true;
  }
};

isConstructorLegacy.sham = true;

// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
module.exports = !construct || fails(function () {
  var called;
  return isConstructorModern(isConstructorModern.call)
    || !isConstructorModern(Object)
    || !isConstructorModern(function () { called = true; })
    || called;
}) ? isConstructorLegacy : isConstructorModern;


/***/ }),

/***/ "69f3":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_WEAK_MAP = __webpack_require__("cdce");
var global = __webpack_require__("da84");
var isObject = __webpack_require__("861d");
var createNonEnumerableProperty = __webpack_require__("9112");
var hasOwn = __webpack_require__("1a2d");
var shared = __webpack_require__("c6cd");
var sharedKey = __webpack_require__("f772");
var hiddenKeys = __webpack_require__("d012");

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError = global.TypeError;
var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  /* eslint-disable no-self-assign -- prototype methods protection */
  store.get = store.get;
  store.has = store.has;
  store.set = store.set;
  /* eslint-enable no-self-assign -- prototype methods protection */
  set = function (it, metadata) {
    if (store.has(it)) throw TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    store.set(it, metadata);
    return metadata;
  };
  get = function (it) {
    return store.get(it) || {};
  };
  has = function (it) {
    return store.has(it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    if (hasOwn(it, STATE)) throw TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),

/***/ "6c59":
/***/ (function(module, exports) {

/* global Deno -- Deno case */
module.exports = typeof Deno == 'object' && Deno && typeof Deno.version == 'object';


/***/ }),

/***/ "7149":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var getBuiltIn = __webpack_require__("d066");
var IS_PURE = __webpack_require__("c430");
var NativePromiseConstructor = __webpack_require__("d256");
var FORCED_PROMISE_CONSTRUCTOR = __webpack_require__("4738").CONSTRUCTOR;
var promiseResolve = __webpack_require__("cdf9");

var PromiseConstructorWrapper = getBuiltIn('Promise');
var CHECK_WRAPPER = IS_PURE && !FORCED_PROMISE_CONSTRUCTOR;

// `Promise.resolve` method
// https://tc39.es/ecma262/#sec-promise.resolve
$({ target: 'Promise', stat: true, forced: IS_PURE || FORCED_PROMISE_CONSTRUCTOR }, {
  resolve: function resolve(x) {
    return promiseResolve(CHECK_WRAPPER && this === PromiseConstructorWrapper ? NativePromiseConstructor : this, x);
  }
});


/***/ }),

/***/ "7156":
/***/ (function(module, exports, __webpack_require__) {

var isCallable = __webpack_require__("1626");
var isObject = __webpack_require__("861d");
var setPrototypeOf = __webpack_require__("d2bb");

// makes subclassing work correct for wrapped built-ins
module.exports = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    setPrototypeOf &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    isCallable(NewTarget = dummy.constructor) &&
    NewTarget !== Wrapper &&
    isObject(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) setPrototypeOf($this, NewTargetPrototype);
  return $this;
};


/***/ }),

/***/ "7234":
/***/ (function(module, exports) {

// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
module.exports = function (it) {
  return it === null || it === undefined;
};


/***/ }),

/***/ "7418":
/***/ (function(module, exports) {

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "7839":
/***/ (function(module, exports) {

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),

/***/ "785a":
/***/ (function(module, exports, __webpack_require__) {

// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement = __webpack_require__("cc12");

var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype = classList && classList.constructor && classList.constructor.prototype;

module.exports = DOMTokenListPrototype === Object.prototype ? undefined : DOMTokenListPrototype;


/***/ }),

/***/ "7b0b":
/***/ (function(module, exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__("1d80");

var $Object = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function (argument) {
  return $Object(requireObjectCoercible(argument));
};


/***/ }),

/***/ "7c73":
/***/ (function(module, exports, __webpack_require__) {

/* global ActiveXObject -- old IE, WSH */
var anObject = __webpack_require__("825a");
var definePropertiesModule = __webpack_require__("37e8");
var enumBugKeys = __webpack_require__("7839");
var hiddenKeys = __webpack_require__("d012");
var html = __webpack_require__("1be4");
var documentCreateElement = __webpack_require__("cc12");
var sharedKey = __webpack_require__("f772");

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
};


/***/ }),

/***/ "7d7e":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_BIND = __webpack_require__("40d5");

var FunctionPrototype = Function.prototype;
var call = FunctionPrototype.call;
var uncurryThisWithBind = NATIVE_BIND && FunctionPrototype.bind.bind(call, call);

module.exports = NATIVE_BIND ? uncurryThisWithBind : function (fn) {
  return function () {
    return call.apply(fn, arguments);
  };
};


/***/ }),

/***/ "825a":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");

var $String = String;
var $TypeError = TypeError;

// `Assert: Type(argument) is Object`
module.exports = function (argument) {
  if (isObject(argument)) return argument;
  throw $TypeError($String(argument) + ' is not an object');
};


/***/ }),

/***/ "83ab":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

// Detect IE8's incomplete defineProperty implementation
module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});


/***/ }),

/***/ "8418":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toPropertyKey = __webpack_require__("a04b");
var definePropertyModule = __webpack_require__("9bf2");
var createPropertyDescriptor = __webpack_require__("5c6c");

module.exports = function (object, key, value) {
  var propertyKey = toPropertyKey(key);
  if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));
  else object[propertyKey] = value;
};


/***/ }),

/***/ "857a":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");
var requireObjectCoercible = __webpack_require__("1d80");
var toString = __webpack_require__("577e");

var quot = /"/g;
var replace = uncurryThis(''.replace);

// `CreateHTML` abstract operation
// https://tc39.es/ecma262/#sec-createhtml
module.exports = function (string, tag, attribute, value) {
  var S = toString(requireObjectCoercible(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + replace(toString(value), quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};


/***/ }),

/***/ "861d":
/***/ (function(module, exports, __webpack_require__) {

var isCallable = __webpack_require__("1626");
var $documentAll = __webpack_require__("8ea1");

var documentAll = $documentAll.all;

module.exports = $documentAll.IS_HTMLDDA ? function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it) || it === documentAll;
} : function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it);
};


/***/ }),

/***/ "8713":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "8875":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// addapted from the document.currentScript polyfill by Adam Miller
// MIT license
// source: https://github.com/amiller-gh/currentScript-polyfill

// added support for Firefox https://bugzilla.mozilla.org/show_bug.cgi?id=1620505

(function (root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
}(typeof self !== 'undefined' ? self : this, function () {
  function getCurrentScript () {
    var descriptor = Object.getOwnPropertyDescriptor(document, 'currentScript')
    // for chrome
    if (!descriptor && 'currentScript' in document && document.currentScript) {
      return document.currentScript
    }

    // for other browsers with native support for currentScript
    if (descriptor && descriptor.get !== getCurrentScript && document.currentScript) {
      return document.currentScript
    }
  
    // IE 8-10 support script readyState
    // IE 11+ & Firefox support stack trace
    try {
      throw new Error();
    }
    catch (err) {
      // Find the second match for the "at" string to get file src url from stack.
      var ieStackRegExp = /.*at [^(]*\((.*):(.+):(.+)\)$/ig,
        ffStackRegExp = /@([^@]*):(\d+):(\d+)\s*$/ig,
        stackDetails = ieStackRegExp.exec(err.stack) || ffStackRegExp.exec(err.stack),
        scriptLocation = (stackDetails && stackDetails[1]) || false,
        line = (stackDetails && stackDetails[2]) || false,
        currentLocation = document.location.href.replace(document.location.hash, ''),
        pageSource,
        inlineScriptSourceRegExp,
        inlineScriptSource,
        scripts = document.getElementsByTagName('script'); // Live NodeList collection
  
      if (scriptLocation === currentLocation) {
        pageSource = document.documentElement.outerHTML;
        inlineScriptSourceRegExp = new RegExp('(?:[^\\n]+?\\n){0,' + (line - 2) + '}[^<]*<script>([\\d\\D]*?)<\\/script>[\\d\\D]*', 'i');
        inlineScriptSource = pageSource.replace(inlineScriptSourceRegExp, '$1').trim();
      }
  
      for (var i = 0; i < scripts.length; i++) {
        // If ready state is interactive, return the script tag
        if (scripts[i].readyState === 'interactive') {
          return scripts[i];
        }
  
        // If src matches, return the script tag
        if (scripts[i].src === scriptLocation) {
          return scripts[i];
        }
  
        // If inline source matches, return the script tag
        if (
          scriptLocation === currentLocation &&
          scripts[i].innerHTML &&
          scripts[i].innerHTML.trim() === inlineScriptSource
        ) {
          return scripts[i];
        }
      }
  
      // If no match, return null
      return null;
    }
  };

  return getCurrentScript
}));


/***/ }),

/***/ "8925":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");
var isCallable = __webpack_require__("1626");
var store = __webpack_require__("c6cd");

var functionToString = uncurryThis(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable(store.inspectSource)) {
  store.inspectSource = function (it) {
    return functionToString(it);
  };
}

module.exports = store.inspectSource;


/***/ }),

/***/ "8ea1":
/***/ (function(module, exports) {

var documentAll = typeof document == 'object' && document.all;

// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var IS_HTMLDDA = typeof documentAll == 'undefined' && documentAll !== undefined;

module.exports = {
  all: documentAll,
  IS_HTMLDDA: IS_HTMLDDA
};


/***/ }),

/***/ "90e3":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");

var id = 0;
var postfix = Math.random();
var toString = uncurryThis(1.0.toString);

module.exports = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
};


/***/ }),

/***/ "9112":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var definePropertyModule = __webpack_require__("9bf2");
var createPropertyDescriptor = __webpack_require__("5c6c");

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "944a":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("d066");
var defineWellKnownSymbol = __webpack_require__("e065");
var setToStringTag = __webpack_require__("d44e");

// `Symbol.toStringTag` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.tostringtag
defineWellKnownSymbol('toStringTag');

// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag(getBuiltIn('Symbol'), 'Symbol');


/***/ }),

/***/ "94ca":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var isCallable = __webpack_require__("1626");

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : isCallable(detection) ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),

/***/ "99af":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var fails = __webpack_require__("d039");
var isArray = __webpack_require__("e8b5");
var isObject = __webpack_require__("861d");
var toObject = __webpack_require__("7b0b");
var lengthOfArrayLike = __webpack_require__("07fa");
var doesNotExceedSafeInteger = __webpack_require__("3511");
var createProperty = __webpack_require__("8418");
var arraySpeciesCreate = __webpack_require__("65f0");
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");
var wellKnownSymbol = __webpack_require__("b622");
var V8_VERSION = __webpack_require__("2d00");

var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');

// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails(function () {
  var array = [];
  array[IS_CONCAT_SPREADABLE] = false;
  return array.concat()[0] !== array;
});

var SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('concat');

var isConcatSpreadable = function (O) {
  if (!isObject(O)) return false;
  var spreadable = O[IS_CONCAT_SPREADABLE];
  return spreadable !== undefined ? !!spreadable : isArray(O);
};

var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT;

// `Array.prototype.concat` method
// https://tc39.es/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
$({ target: 'Array', proto: true, arity: 1, forced: FORCED }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  concat: function concat(arg) {
    var O = toObject(this);
    var A = arraySpeciesCreate(O, 0);
    var n = 0;
    var i, k, length, len, E;
    for (i = -1, length = arguments.length; i < length; i++) {
      E = i === -1 ? O : arguments[i];
      if (isConcatSpreadable(E)) {
        len = lengthOfArrayLike(E);
        doesNotExceedSafeInteger(n + len);
        for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
      } else {
        doesNotExceedSafeInteger(n + 1);
        createProperty(A, n++, E);
      }
    }
    A.length = n;
    return A;
  }
});


/***/ }),

/***/ "9a1f":
/***/ (function(module, exports, __webpack_require__) {

var call = __webpack_require__("c65b");
var aCallable = __webpack_require__("59ed");
var anObject = __webpack_require__("825a");
var tryToString = __webpack_require__("0d51");
var getIteratorMethod = __webpack_require__("35a1");

var $TypeError = TypeError;

module.exports = function (argument, usingIterator) {
  var iteratorMethod = arguments.length < 2 ? getIteratorMethod(argument) : usingIterator;
  if (aCallable(iteratorMethod)) return anObject(call(iteratorMethod, argument));
  throw $TypeError(tryToString(argument) + ' is not iterable');
};


/***/ }),

/***/ "9bf2":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var IE8_DOM_DEFINE = __webpack_require__("0cfb");
var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__("aed9");
var anObject = __webpack_require__("825a");
var toPropertyKey = __webpack_require__("a04b");

var $TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? V8_PROTOTYPE_DEFINE_BUG ? function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE in Attributes ? Attributes[CONFIGURABLE] : current[CONFIGURABLE],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw $TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "a04b":
/***/ (function(module, exports, __webpack_require__) {

var toPrimitive = __webpack_require__("c04e");
var isSymbol = __webpack_require__("d9b5");

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
module.exports = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};


/***/ }),

/***/ "a4b4":
/***/ (function(module, exports, __webpack_require__) {

var userAgent = __webpack_require__("342f");

module.exports = /web0s(?!.*chrome)/i.test(userAgent);


/***/ }),

/***/ "a4d3":
/***/ (function(module, exports, __webpack_require__) {

// TODO: Remove this module from `core-js@4` since it's split to modules listed below
__webpack_require__("d9f5");
__webpack_require__("b4f8");
__webpack_require__("c513");
__webpack_require__("e9c4");
__webpack_require__("5a47");


/***/ }),

/***/ "a640":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__("d039");

module.exports = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call -- required for testing
    method.call(null, argument || function () { return 1; }, 1);
  });
};


/***/ }),

/***/ "ab36":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");
var createNonEnumerableProperty = __webpack_require__("9112");

// `InstallErrorCause` abstract operation
// https://tc39.es/proposal-error-cause/#sec-errorobjects-install-error-cause
module.exports = function (O, options) {
  if (isObject(options) && 'cause' in options) {
    createNonEnumerableProperty(O, 'cause', options.cause);
  }
};


/***/ }),

/***/ "ae93":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__("d039");
var isCallable = __webpack_require__("1626");
var isObject = __webpack_require__("861d");
var create = __webpack_require__("7c73");
var getPrototypeOf = __webpack_require__("e163");
var defineBuiltIn = __webpack_require__("cb2d");
var wellKnownSymbol = __webpack_require__("b622");
var IS_PURE = __webpack_require__("c430");

var ITERATOR = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = !isObject(IteratorPrototype) || fails(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype[ITERATOR].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype = {};
else if (IS_PURE) IteratorPrototype = create(IteratorPrototype);

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable(IteratorPrototype[ITERATOR])) {
  defineBuiltIn(IteratorPrototype, ITERATOR, function () {
    return this;
  });
}

module.exports = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};


/***/ }),

/***/ "aeb0":
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__("9bf2").f;

module.exports = function (Target, Source, key) {
  key in Target || defineProperty(Target, key, {
    configurable: true,
    get: function () { return Source[key]; },
    set: function (it) { Source[key] = it; }
  });
};


/***/ }),

/***/ "aed9":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var fails = __webpack_require__("d039");

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
module.exports = DESCRIPTORS && fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype != 42;
});


/***/ }),

/***/ "af03":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

// check the existence of a method, lowercase
// of a tag and escaping quotes in arguments
module.exports = function (METHOD_NAME) {
  return fails(function () {
    var test = ''[METHOD_NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  });
};


/***/ }),

/***/ "b041":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__("00ee");
var classof = __webpack_require__("f5df");

// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
module.exports = TO_STRING_TAG_SUPPORT ? {}.toString : function toString() {
  return '[object ' + classof(this) + ']';
};


/***/ }),

/***/ "b0c0":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var FUNCTION_NAME_EXISTS = __webpack_require__("5e77").EXISTS;
var uncurryThis = __webpack_require__("e330");
var defineProperty = __webpack_require__("9bf2").f;

var FunctionPrototype = Function.prototype;
var functionToString = uncurryThis(FunctionPrototype.toString);
var nameRE = /function\b(?:\s|\/\*[\S\s]*?\*\/|\/\/[^\n\r]*[\n\r]+)*([^\s(/]*)/;
var regExpExec = uncurryThis(nameRE.exec);
var NAME = 'name';

// Function instances `.name` property
// https://tc39.es/ecma262/#sec-function-instances-name
if (DESCRIPTORS && !FUNCTION_NAME_EXISTS) {
  defineProperty(FunctionPrototype, NAME, {
    configurable: true,
    get: function () {
      try {
        return regExpExec(nameRE, functionToString(this))[1];
      } catch (error) {
        return '';
      }
    }
  });
}


/***/ }),

/***/ "b42e":
/***/ (function(module, exports) {

var ceil = Math.ceil;
var floor = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
module.exports = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor : ceil)(n);
};


/***/ }),

/***/ "b4f8":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var getBuiltIn = __webpack_require__("d066");
var hasOwn = __webpack_require__("1a2d");
var toString = __webpack_require__("577e");
var shared = __webpack_require__("5692");
var NATIVE_SYMBOL_REGISTRY = __webpack_require__("0b43");

var StringToSymbolRegistry = shared('string-to-symbol-registry');
var SymbolToStringRegistry = shared('symbol-to-string-registry');

// `Symbol.for` method
// https://tc39.es/ecma262/#sec-symbol.for
$({ target: 'Symbol', stat: true, forced: !NATIVE_SYMBOL_REGISTRY }, {
  'for': function (key) {
    var string = toString(key);
    if (hasOwn(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
    var symbol = getBuiltIn('Symbol')(string);
    StringToSymbolRegistry[string] = symbol;
    SymbolToStringRegistry[symbol] = string;
    return symbol;
  }
});


/***/ }),

/***/ "b575":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var bind = __webpack_require__("0366");
var getOwnPropertyDescriptor = __webpack_require__("06cf").f;
var macrotask = __webpack_require__("2cf4").set;
var IS_IOS = __webpack_require__("1cdc");
var IS_IOS_PEBBLE = __webpack_require__("d4c3");
var IS_WEBOS_WEBKIT = __webpack_require__("a4b4");
var IS_NODE = __webpack_require__("605d");

var MutationObserver = global.MutationObserver || global.WebKitMutationObserver;
var document = global.document;
var process = global.process;
var Promise = global.Promise;
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var queueMicrotaskDescriptor = getOwnPropertyDescriptor(global, 'queueMicrotask');
var queueMicrotask = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;

var flush, head, last, notify, toggle, node, promise, then;

// modern engines have queueMicrotask method
if (!queueMicrotask) {
  flush = function () {
    var parent, fn;
    if (IS_NODE && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (error) {
        if (head) notify();
        else last = undefined;
        throw error;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
  if (!IS_IOS && !IS_NODE && !IS_WEBOS_WEBKIT && MutationObserver && document) {
    toggle = true;
    node = document.createTextNode('');
    new MutationObserver(flush).observe(node, { characterData: true });
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (!IS_IOS_PEBBLE && Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise = Promise.resolve(undefined);
    // workaround of WebKit ~ iOS Safari 10.1 bug
    promise.constructor = Promise;
    then = bind(promise.then, promise);
    notify = function () {
      then(flush);
    };
  // Node.js without promises
  } else if (IS_NODE) {
    notify = function () {
      process.nextTick(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessage
  // - onreadystatechange
  // - setTimeout
  } else {
    // strange IE + webpack dev server bug - use .bind(global)
    macrotask = bind(macrotask, global);
    notify = function () {
      macrotask(flush);
    };
  }
}

module.exports = queueMicrotask || function (fn) {
  var task = { fn: fn, next: undefined };
  if (last) last.next = task;
  if (!head) {
    head = task;
    notify();
  } last = task;
};


/***/ }),

/***/ "b622":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var shared = __webpack_require__("5692");
var hasOwn = __webpack_require__("1a2d");
var uid = __webpack_require__("90e3");
var NATIVE_SYMBOL = __webpack_require__("04f8");
var USE_SYMBOL_AS_UID = __webpack_require__("fdbf");

var WellKnownSymbolsStore = shared('wks');
var Symbol = global.Symbol;
var symbolFor = Symbol && Symbol['for'];
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!hasOwn(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == 'string')) {
    var description = 'Symbol.' + name;
    if (NATIVE_SYMBOL && hasOwn(Symbol, name)) {
      WellKnownSymbolsStore[name] = Symbol[name];
    } else if (USE_SYMBOL_AS_UID && symbolFor) {
      WellKnownSymbolsStore[name] = symbolFor(description);
    } else {
      WellKnownSymbolsStore[name] = createWellKnownSymbol(description);
    }
  } return WellKnownSymbolsStore[name];
};


/***/ }),

/***/ "b636":
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__("e065");

// `Symbol.asyncIterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.asynciterator
defineWellKnownSymbol('asyncIterator');


/***/ }),

/***/ "b64b":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var toObject = __webpack_require__("7b0b");
var nativeKeys = __webpack_require__("df75");
var fails = __webpack_require__("d039");

var FAILS_ON_PRIMITIVES = fails(function () { nativeKeys(1); });

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
  keys: function keys(it) {
    return nativeKeys(toObject(it));
  }
});


/***/ }),

/***/ "b727":
/***/ (function(module, exports, __webpack_require__) {

var bind = __webpack_require__("0366");
var uncurryThis = __webpack_require__("e330");
var IndexedObject = __webpack_require__("44ad");
var toObject = __webpack_require__("7b0b");
var lengthOfArrayLike = __webpack_require__("07fa");
var arraySpeciesCreate = __webpack_require__("65f0");

var push = uncurryThis([].push);

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var createMethod = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var IS_FILTER_REJECT = TYPE == 7;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = IndexedObject(O);
    var boundFunction = bind(callbackfn, that);
    var length = lengthOfArrayLike(self);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push(target, value);      // filter
        } else switch (TYPE) {
          case 4: return false;             // every
          case 7: push(target, value);      // filterReject
        }
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

module.exports = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: createMethod(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: createMethod(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: createMethod(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: createMethod(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: createMethod(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: createMethod(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod(6),
  // `Array.prototype.filterReject` method
  // https://github.com/tc39/proposal-array-filtering
  filterReject: createMethod(7)
};


/***/ }),

/***/ "b980":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var createPropertyDescriptor = __webpack_require__("5c6c");

module.exports = !fails(function () {
  var error = Error('a');
  if (!('stack' in error)) return true;
  // eslint-disable-next-line es/no-object-defineproperty -- safe
  Object.defineProperty(error, 'stack', createPropertyDescriptor(1, 7));
  return error.stack !== 7;
});


/***/ }),

/***/ "c04e":
/***/ (function(module, exports, __webpack_require__) {

var call = __webpack_require__("c65b");
var isObject = __webpack_require__("861d");
var isSymbol = __webpack_require__("d9b5");
var getMethod = __webpack_require__("dc4a");
var ordinaryToPrimitive = __webpack_require__("485a");
var wellKnownSymbol = __webpack_require__("b622");

var $TypeError = TypeError;
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
module.exports = function (input, pref) {
  if (!isObject(input) || isSymbol(input)) return input;
  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call(exoticToPrim, input, pref);
    if (!isObject(result) || isSymbol(result)) return result;
    throw $TypeError("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};


/***/ }),

/***/ "c097":
/***/ (function(module, exports) {

module.exports = require("oidc-client");

/***/ }),

/***/ "c430":
/***/ (function(module, exports) {

module.exports = false;


/***/ }),

/***/ "c513":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var hasOwn = __webpack_require__("1a2d");
var isSymbol = __webpack_require__("d9b5");
var tryToString = __webpack_require__("0d51");
var shared = __webpack_require__("5692");
var NATIVE_SYMBOL_REGISTRY = __webpack_require__("0b43");

var SymbolToStringRegistry = shared('symbol-to-string-registry');

// `Symbol.keyFor` method
// https://tc39.es/ecma262/#sec-symbol.keyfor
$({ target: 'Symbol', stat: true, forced: !NATIVE_SYMBOL_REGISTRY }, {
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(tryToString(sym) + ' is not a symbol');
    if (hasOwn(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
  }
});


/***/ }),

/***/ "c65b":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_BIND = __webpack_require__("40d5");

var call = Function.prototype.call;

module.exports = NATIVE_BIND ? call.bind(call) : function () {
  return call.apply(call, arguments);
};


/***/ }),

/***/ "c6b6":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThisRaw = __webpack_require__("7d7e");

var toString = uncurryThisRaw({}.toString);
var stringSlice = uncurryThisRaw(''.slice);

module.exports = function (it) {
  return stringSlice(toString(it), 8, -1);
};


/***/ }),

/***/ "c6cd":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var defineGlobalProperty = __webpack_require__("6374");

var SHARED = '__core-js_shared__';
var store = global[SHARED] || defineGlobalProperty(SHARED, {});

module.exports = store;


/***/ }),

/***/ "c6d2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var call = __webpack_require__("c65b");
var IS_PURE = __webpack_require__("c430");
var FunctionName = __webpack_require__("5e77");
var isCallable = __webpack_require__("1626");
var createIteratorConstructor = __webpack_require__("dcc3");
var getPrototypeOf = __webpack_require__("e163");
var setPrototypeOf = __webpack_require__("d2bb");
var setToStringTag = __webpack_require__("d44e");
var createNonEnumerableProperty = __webpack_require__("9112");
var defineBuiltIn = __webpack_require__("cb2d");
var wellKnownSymbol = __webpack_require__("b622");
var Iterators = __webpack_require__("3f8c");
var IteratorsCore = __webpack_require__("ae93");

var PROPER_FUNCTION_NAME = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (!isCallable(CurrentIteratorPrototype[ITERATOR])) {
          defineBuiltIn(CurrentIteratorPrototype, ITERATOR, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
      if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME && DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (!IS_PURE && CONFIGURABLE_FUNCTION_NAME) {
      createNonEnumerableProperty(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() { return call(nativeIterator, this); };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        defineBuiltIn(IterablePrototype, KEY, methods[KEY]);
      }
    } else $({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  // define iterator
  if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
    defineBuiltIn(IterablePrototype, ITERATOR, defaultIterator, { name: DEFAULT });
  }
  Iterators[NAME] = defaultIterator;

  return methods;
};


/***/ }),

/***/ "c8ba":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "ca84":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");
var hasOwn = __webpack_require__("1a2d");
var toIndexedObject = __webpack_require__("fc6a");
var indexOf = __webpack_require__("4d64").indexOf;
var hiddenKeys = __webpack_require__("d012");

var push = uncurryThis([].push);

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn(hiddenKeys, key) && hasOwn(O, key) && push(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn(O, key = names[i++])) {
    ~indexOf(result, key) || push(result, key);
  }
  return result;
};


/***/ }),

/***/ "cb2d":
/***/ (function(module, exports, __webpack_require__) {

var isCallable = __webpack_require__("1626");
var definePropertyModule = __webpack_require__("9bf2");
var makeBuiltIn = __webpack_require__("13d2");
var defineGlobalProperty = __webpack_require__("6374");

module.exports = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable(value)) makeBuiltIn(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;
    else defineGlobalProperty(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];
      else if (O[key]) simple = true;
    } catch (error) { /* empty */ }
    if (simple) O[key] = value;
    else definePropertyModule.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  } return O;
};


/***/ }),

/***/ "cc12":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var isObject = __webpack_require__("861d");

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),

/***/ "cc98":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var IS_PURE = __webpack_require__("c430");
var FORCED_PROMISE_CONSTRUCTOR = __webpack_require__("4738").CONSTRUCTOR;
var NativePromiseConstructor = __webpack_require__("d256");
var getBuiltIn = __webpack_require__("d066");
var isCallable = __webpack_require__("1626");
var defineBuiltIn = __webpack_require__("cb2d");

var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;

// `Promise.prototype.catch` method
// https://tc39.es/ecma262/#sec-promise.prototype.catch
$({ target: 'Promise', proto: true, forced: FORCED_PROMISE_CONSTRUCTOR, real: true }, {
  'catch': function (onRejected) {
    return this.then(undefined, onRejected);
  }
});

// makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
if (!IS_PURE && isCallable(NativePromiseConstructor)) {
  var method = getBuiltIn('Promise').prototype['catch'];
  if (NativePromisePrototype['catch'] !== method) {
    defineBuiltIn(NativePromisePrototype, 'catch', method, { unsafe: true });
  }
}


/***/ }),

/***/ "cdce":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var isCallable = __webpack_require__("1626");

var WeakMap = global.WeakMap;

module.exports = isCallable(WeakMap) && /native code/.test(String(WeakMap));


/***/ }),

/***/ "cdf9":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");
var isObject = __webpack_require__("861d");
var newPromiseCapability = __webpack_require__("f069");

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),

/***/ "d012":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "d039":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),

/***/ "d066":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var isCallable = __webpack_require__("1626");

var aFunction = function (argument) {
  return isCallable(argument) ? argument : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global[namespace]) : global[namespace] && global[namespace][method];
};


/***/ }),

/***/ "d1e7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;


/***/ }),

/***/ "d256":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");

module.exports = global.Promise;


/***/ }),

/***/ "d28b":
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__("e065");

// `Symbol.iterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.iterator
defineWellKnownSymbol('iterator');


/***/ }),

/***/ "d2bb":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable no-proto -- safe */
var uncurryThis = __webpack_require__("e330");
var anObject = __webpack_require__("825a");
var aPossiblePrototype = __webpack_require__("3bbe");

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    setter = uncurryThis(Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set);
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);


/***/ }),

/***/ "d3b7":
/***/ (function(module, exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__("00ee");
var defineBuiltIn = __webpack_require__("cb2d");
var toString = __webpack_require__("b041");

// `Object.prototype.toString` method
// https://tc39.es/ecma262/#sec-object.prototype.tostring
if (!TO_STRING_TAG_SUPPORT) {
  defineBuiltIn(Object.prototype, 'toString', toString, { unsafe: true });
}


/***/ }),

/***/ "d44e":
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__("9bf2").f;
var hasOwn = __webpack_require__("1a2d");
var wellKnownSymbol = __webpack_require__("b622");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');

module.exports = function (target, TAG, STATIC) {
  if (target && !STATIC) target = target.prototype;
  if (target && !hasOwn(target, TO_STRING_TAG)) {
    defineProperty(target, TO_STRING_TAG, { configurable: true, value: TAG });
  }
};


/***/ }),

/***/ "d4c3":
/***/ (function(module, exports, __webpack_require__) {

var userAgent = __webpack_require__("342f");
var global = __webpack_require__("da84");

module.exports = /ipad|iphone|ipod/i.test(userAgent) && global.Pebble !== undefined;


/***/ }),

/***/ "d6d6":
/***/ (function(module, exports) {

var $TypeError = TypeError;

module.exports = function (passed, required) {
  if (passed < required) throw $TypeError('Not enough arguments');
  return passed;
};


/***/ }),

/***/ "d9b5":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("d066");
var isCallable = __webpack_require__("1626");
var isPrototypeOf = __webpack_require__("3a9b");
var USE_SYMBOL_AS_UID = __webpack_require__("fdbf");

var $Object = Object;

module.exports = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn('Symbol');
  return isCallable($Symbol) && isPrototypeOf($Symbol.prototype, $Object(it));
};


/***/ }),

/***/ "d9e2":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable no-unused-vars -- required for functions `.length` */
var $ = __webpack_require__("23e7");
var global = __webpack_require__("da84");
var apply = __webpack_require__("2ba4");
var wrapErrorConstructorWithCause = __webpack_require__("e5cb");

var WEB_ASSEMBLY = 'WebAssembly';
var WebAssembly = global[WEB_ASSEMBLY];

var FORCED = Error('e', { cause: 7 }).cause !== 7;

var exportGlobalErrorCauseWrapper = function (ERROR_NAME, wrapper) {
  var O = {};
  O[ERROR_NAME] = wrapErrorConstructorWithCause(ERROR_NAME, wrapper, FORCED);
  $({ global: true, constructor: true, arity: 1, forced: FORCED }, O);
};

var exportWebAssemblyErrorCauseWrapper = function (ERROR_NAME, wrapper) {
  if (WebAssembly && WebAssembly[ERROR_NAME]) {
    var O = {};
    O[ERROR_NAME] = wrapErrorConstructorWithCause(WEB_ASSEMBLY + '.' + ERROR_NAME, wrapper, FORCED);
    $({ target: WEB_ASSEMBLY, stat: true, constructor: true, arity: 1, forced: FORCED }, O);
  }
};

// https://github.com/tc39/proposal-error-cause
exportGlobalErrorCauseWrapper('Error', function (init) {
  return function Error(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('EvalError', function (init) {
  return function EvalError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('RangeError', function (init) {
  return function RangeError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('ReferenceError', function (init) {
  return function ReferenceError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('SyntaxError', function (init) {
  return function SyntaxError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('TypeError', function (init) {
  return function TypeError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('URIError', function (init) {
  return function URIError(message) { return apply(init, this, arguments); };
});
exportWebAssemblyErrorCauseWrapper('CompileError', function (init) {
  return function CompileError(message) { return apply(init, this, arguments); };
});
exportWebAssemblyErrorCauseWrapper('LinkError', function (init) {
  return function LinkError(message) { return apply(init, this, arguments); };
});
exportWebAssemblyErrorCauseWrapper('RuntimeError', function (init) {
  return function RuntimeError(message) { return apply(init, this, arguments); };
});


/***/ }),

/***/ "d9f5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var global = __webpack_require__("da84");
var call = __webpack_require__("c65b");
var uncurryThis = __webpack_require__("e330");
var IS_PURE = __webpack_require__("c430");
var DESCRIPTORS = __webpack_require__("83ab");
var NATIVE_SYMBOL = __webpack_require__("04f8");
var fails = __webpack_require__("d039");
var hasOwn = __webpack_require__("1a2d");
var isPrototypeOf = __webpack_require__("3a9b");
var anObject = __webpack_require__("825a");
var toIndexedObject = __webpack_require__("fc6a");
var toPropertyKey = __webpack_require__("a04b");
var $toString = __webpack_require__("577e");
var createPropertyDescriptor = __webpack_require__("5c6c");
var nativeObjectCreate = __webpack_require__("7c73");
var objectKeys = __webpack_require__("df75");
var getOwnPropertyNamesModule = __webpack_require__("241c");
var getOwnPropertyNamesExternal = __webpack_require__("057f");
var getOwnPropertySymbolsModule = __webpack_require__("7418");
var getOwnPropertyDescriptorModule = __webpack_require__("06cf");
var definePropertyModule = __webpack_require__("9bf2");
var definePropertiesModule = __webpack_require__("37e8");
var propertyIsEnumerableModule = __webpack_require__("d1e7");
var defineBuiltIn = __webpack_require__("cb2d");
var shared = __webpack_require__("5692");
var sharedKey = __webpack_require__("f772");
var hiddenKeys = __webpack_require__("d012");
var uid = __webpack_require__("90e3");
var wellKnownSymbol = __webpack_require__("b622");
var wrappedWellKnownSymbolModule = __webpack_require__("e538");
var defineWellKnownSymbol = __webpack_require__("e065");
var defineSymbolToPrimitive = __webpack_require__("57b9");
var setToStringTag = __webpack_require__("d44e");
var InternalStateModule = __webpack_require__("69f3");
var $forEach = __webpack_require__("b727").forEach;

var HIDDEN = sharedKey('hidden');
var SYMBOL = 'Symbol';
var PROTOTYPE = 'prototype';

var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(SYMBOL);

var ObjectPrototype = Object[PROTOTYPE];
var $Symbol = global.Symbol;
var SymbolPrototype = $Symbol && $Symbol[PROTOTYPE];
var TypeError = global.TypeError;
var QObject = global.QObject;
var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
var nativeDefineProperty = definePropertyModule.f;
var nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
var nativePropertyIsEnumerable = propertyIsEnumerableModule.f;
var push = uncurryThis([].push);

var AllSymbols = shared('symbols');
var ObjectPrototypeSymbols = shared('op-symbols');
var WellKnownSymbolsStore = shared('wks');

// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDescriptor = DESCRIPTORS && fails(function () {
  return nativeObjectCreate(nativeDefineProperty({}, 'a', {
    get: function () { return nativeDefineProperty(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (O, P, Attributes) {
  var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype, P);
  if (ObjectPrototypeDescriptor) delete ObjectPrototype[P];
  nativeDefineProperty(O, P, Attributes);
  if (ObjectPrototypeDescriptor && O !== ObjectPrototype) {
    nativeDefineProperty(ObjectPrototype, P, ObjectPrototypeDescriptor);
  }
} : nativeDefineProperty;

var wrap = function (tag, description) {
  var symbol = AllSymbols[tag] = nativeObjectCreate(SymbolPrototype);
  setInternalState(symbol, {
    type: SYMBOL,
    tag: tag,
    description: description
  });
  if (!DESCRIPTORS) symbol.description = description;
  return symbol;
};

var $defineProperty = function defineProperty(O, P, Attributes) {
  if (O === ObjectPrototype) $defineProperty(ObjectPrototypeSymbols, P, Attributes);
  anObject(O);
  var key = toPropertyKey(P);
  anObject(Attributes);
  if (hasOwn(AllSymbols, key)) {
    if (!Attributes.enumerable) {
      if (!hasOwn(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, {}));
      O[HIDDEN][key] = true;
    } else {
      if (hasOwn(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
      Attributes = nativeObjectCreate(Attributes, { enumerable: createPropertyDescriptor(0, false) });
    } return setSymbolDescriptor(O, key, Attributes);
  } return nativeDefineProperty(O, key, Attributes);
};

var $defineProperties = function defineProperties(O, Properties) {
  anObject(O);
  var properties = toIndexedObject(Properties);
  var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
  $forEach(keys, function (key) {
    if (!DESCRIPTORS || call($propertyIsEnumerable, properties, key)) $defineProperty(O, key, properties[key]);
  });
  return O;
};

var $create = function create(O, Properties) {
  return Properties === undefined ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
};

var $propertyIsEnumerable = function propertyIsEnumerable(V) {
  var P = toPropertyKey(V);
  var enumerable = call(nativePropertyIsEnumerable, this, P);
  if (this === ObjectPrototype && hasOwn(AllSymbols, P) && !hasOwn(ObjectPrototypeSymbols, P)) return false;
  return enumerable || !hasOwn(this, P) || !hasOwn(AllSymbols, P) || hasOwn(this, HIDDEN) && this[HIDDEN][P]
    ? enumerable : true;
};

var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
  var it = toIndexedObject(O);
  var key = toPropertyKey(P);
  if (it === ObjectPrototype && hasOwn(AllSymbols, key) && !hasOwn(ObjectPrototypeSymbols, key)) return;
  var descriptor = nativeGetOwnPropertyDescriptor(it, key);
  if (descriptor && hasOwn(AllSymbols, key) && !(hasOwn(it, HIDDEN) && it[HIDDEN][key])) {
    descriptor.enumerable = true;
  }
  return descriptor;
};

var $getOwnPropertyNames = function getOwnPropertyNames(O) {
  var names = nativeGetOwnPropertyNames(toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (!hasOwn(AllSymbols, key) && !hasOwn(hiddenKeys, key)) push(result, key);
  });
  return result;
};

var $getOwnPropertySymbols = function (O) {
  var IS_OBJECT_PROTOTYPE = O === ObjectPrototype;
  var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (hasOwn(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || hasOwn(ObjectPrototype, key))) {
      push(result, AllSymbols[key]);
    }
  });
  return result;
};

// `Symbol` constructor
// https://tc39.es/ecma262/#sec-symbol-constructor
if (!NATIVE_SYMBOL) {
  $Symbol = function Symbol() {
    if (isPrototypeOf(SymbolPrototype, this)) throw TypeError('Symbol is not a constructor');
    var description = !arguments.length || arguments[0] === undefined ? undefined : $toString(arguments[0]);
    var tag = uid(description);
    var setter = function (value) {
      if (this === ObjectPrototype) call(setter, ObjectPrototypeSymbols, value);
      if (hasOwn(this, HIDDEN) && hasOwn(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDescriptor(this, tag, createPropertyDescriptor(1, value));
    };
    if (DESCRIPTORS && USE_SETTER) setSymbolDescriptor(ObjectPrototype, tag, { configurable: true, set: setter });
    return wrap(tag, description);
  };

  SymbolPrototype = $Symbol[PROTOTYPE];

  defineBuiltIn(SymbolPrototype, 'toString', function toString() {
    return getInternalState(this).tag;
  });

  defineBuiltIn($Symbol, 'withoutSetter', function (description) {
    return wrap(uid(description), description);
  });

  propertyIsEnumerableModule.f = $propertyIsEnumerable;
  definePropertyModule.f = $defineProperty;
  definePropertiesModule.f = $defineProperties;
  getOwnPropertyDescriptorModule.f = $getOwnPropertyDescriptor;
  getOwnPropertyNamesModule.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
  getOwnPropertySymbolsModule.f = $getOwnPropertySymbols;

  wrappedWellKnownSymbolModule.f = function (name) {
    return wrap(wellKnownSymbol(name), name);
  };

  if (DESCRIPTORS) {
    // https://github.com/tc39/proposal-Symbol-description
    nativeDefineProperty(SymbolPrototype, 'description', {
      configurable: true,
      get: function description() {
        return getInternalState(this).description;
      }
    });
    if (!IS_PURE) {
      defineBuiltIn(ObjectPrototype, 'propertyIsEnumerable', $propertyIsEnumerable, { unsafe: true });
    }
  }
}

$({ global: true, constructor: true, wrap: true, forced: !NATIVE_SYMBOL, sham: !NATIVE_SYMBOL }, {
  Symbol: $Symbol
});

$forEach(objectKeys(WellKnownSymbolsStore), function (name) {
  defineWellKnownSymbol(name);
});

$({ target: SYMBOL, stat: true, forced: !NATIVE_SYMBOL }, {
  useSetter: function () { USE_SETTER = true; },
  useSimple: function () { USE_SETTER = false; }
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL, sham: !DESCRIPTORS }, {
  // `Object.create` method
  // https://tc39.es/ecma262/#sec-object.create
  create: $create,
  // `Object.defineProperty` method
  // https://tc39.es/ecma262/#sec-object.defineproperty
  defineProperty: $defineProperty,
  // `Object.defineProperties` method
  // https://tc39.es/ecma262/#sec-object.defineproperties
  defineProperties: $defineProperties,
  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL }, {
  // `Object.getOwnPropertyNames` method
  // https://tc39.es/ecma262/#sec-object.getownpropertynames
  getOwnPropertyNames: $getOwnPropertyNames
});

// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
defineSymbolToPrimitive();

// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag($Symbol, SYMBOL);

hiddenKeys[HIDDEN] = true;


/***/ }),

/***/ "da84":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof global == 'object' && global) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "dbb4":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var DESCRIPTORS = __webpack_require__("83ab");
var ownKeys = __webpack_require__("56ef");
var toIndexedObject = __webpack_require__("fc6a");
var getOwnPropertyDescriptorModule = __webpack_require__("06cf");
var createProperty = __webpack_require__("8418");

// `Object.getOwnPropertyDescriptors` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
$({ target: 'Object', stat: true, sham: !DESCRIPTORS }, {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIndexedObject(object);
    var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
    var keys = ownKeys(O);
    var result = {};
    var index = 0;
    var key, descriptor;
    while (keys.length > index) {
      descriptor = getOwnPropertyDescriptor(O, key = keys[index++]);
      if (descriptor !== undefined) createProperty(result, key, descriptor);
    }
    return result;
  }
});


/***/ }),

/***/ "dc4a":
/***/ (function(module, exports, __webpack_require__) {

var aCallable = __webpack_require__("59ed");
var isNullOrUndefined = __webpack_require__("7234");

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
module.exports = function (V, P) {
  var func = V[P];
  return isNullOrUndefined(func) ? undefined : aCallable(func);
};


/***/ }),

/***/ "dcc3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var IteratorPrototype = __webpack_require__("ae93").IteratorPrototype;
var create = __webpack_require__("7c73");
var createPropertyDescriptor = __webpack_require__("5c6c");
var setToStringTag = __webpack_require__("d44e");
var Iterators = __webpack_require__("3f8c");

var returnThis = function () { return this; };

module.exports = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(+!ENUMERABLE_NEXT, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
  Iterators[TO_STRING_TAG] = returnThis;
  return IteratorConstructor;
};


/***/ }),

/***/ "ddb0":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var DOMIterables = __webpack_require__("fdbc");
var DOMTokenListPrototype = __webpack_require__("785a");
var ArrayIteratorMethods = __webpack_require__("e260");
var createNonEnumerableProperty = __webpack_require__("9112");
var wellKnownSymbol = __webpack_require__("b622");

var ITERATOR = wellKnownSymbol('iterator');
var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;

var handlePrototype = function (CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG]) {
      createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
    }
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  handlePrototype(global[COLLECTION_NAME] && global[COLLECTION_NAME].prototype, COLLECTION_NAME);
}

handlePrototype(DOMTokenListPrototype, 'DOMTokenList');


/***/ }),

/***/ "df75":
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__("ca84");
var enumBugKeys = __webpack_require__("7839");

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};


/***/ }),

/***/ "e01a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// `Symbol.prototype.description` getter
// https://tc39.es/ecma262/#sec-symbol.prototype.description

var $ = __webpack_require__("23e7");
var DESCRIPTORS = __webpack_require__("83ab");
var global = __webpack_require__("da84");
var uncurryThis = __webpack_require__("e330");
var hasOwn = __webpack_require__("1a2d");
var isCallable = __webpack_require__("1626");
var isPrototypeOf = __webpack_require__("3a9b");
var toString = __webpack_require__("577e");
var defineProperty = __webpack_require__("9bf2").f;
var copyConstructorProperties = __webpack_require__("e893");

var NativeSymbol = global.Symbol;
var SymbolPrototype = NativeSymbol && NativeSymbol.prototype;

if (DESCRIPTORS && isCallable(NativeSymbol) && (!('description' in SymbolPrototype) ||
  // Safari 12 bug
  NativeSymbol().description !== undefined
)) {
  var EmptyStringDescriptionStore = {};
  // wrap Symbol constructor for correct work with undefined description
  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : toString(arguments[0]);
    var result = isPrototypeOf(SymbolPrototype, this)
      ? new NativeSymbol(description)
      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
      : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };

  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  SymbolWrapper.prototype = SymbolPrototype;
  SymbolPrototype.constructor = SymbolWrapper;

  var NATIVE_SYMBOL = String(NativeSymbol('test')) == 'Symbol(test)';
  var thisSymbolValue = uncurryThis(SymbolPrototype.valueOf);
  var symbolDescriptiveString = uncurryThis(SymbolPrototype.toString);
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  var replace = uncurryThis(''.replace);
  var stringSlice = uncurryThis(''.slice);

  defineProperty(SymbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = thisSymbolValue(this);
      if (hasOwn(EmptyStringDescriptionStore, symbol)) return '';
      var string = symbolDescriptiveString(symbol);
      var desc = NATIVE_SYMBOL ? stringSlice(string, 7, -1) : replace(string, regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  $({ global: true, constructor: true, forced: true }, {
    Symbol: SymbolWrapper
  });
}


/***/ }),

/***/ "e065":
/***/ (function(module, exports, __webpack_require__) {

var path = __webpack_require__("428f");
var hasOwn = __webpack_require__("1a2d");
var wrappedWellKnownSymbolModule = __webpack_require__("e538");
var defineProperty = __webpack_require__("9bf2").f;

module.exports = function (NAME) {
  var Symbol = path.Symbol || (path.Symbol = {});
  if (!hasOwn(Symbol, NAME)) defineProperty(Symbol, NAME, {
    value: wrappedWellKnownSymbolModule.f(NAME)
  });
};


/***/ }),

/***/ "e163":
/***/ (function(module, exports, __webpack_require__) {

var hasOwn = __webpack_require__("1a2d");
var isCallable = __webpack_require__("1626");
var toObject = __webpack_require__("7b0b");
var sharedKey = __webpack_require__("f772");
var CORRECT_PROTOTYPE_GETTER = __webpack_require__("e177");

var IE_PROTO = sharedKey('IE_PROTO');
var $Object = Object;
var ObjectPrototype = $Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
module.exports = CORRECT_PROTOTYPE_GETTER ? $Object.getPrototypeOf : function (O) {
  var object = toObject(O);
  if (hasOwn(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof $Object ? ObjectPrototype : null;
};


/***/ }),

/***/ "e177":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

module.exports = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});


/***/ }),

/***/ "e260":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toIndexedObject = __webpack_require__("fc6a");
var addToUnscopables = __webpack_require__("44d2");
var Iterators = __webpack_require__("3f8c");
var InternalStateModule = __webpack_require__("69f3");
var defineProperty = __webpack_require__("9bf2").f;
var defineIterator = __webpack_require__("c6d2");
var createIterResultObject = __webpack_require__("4754");
var IS_PURE = __webpack_require__("c430");
var DESCRIPTORS = __webpack_require__("83ab");

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
module.exports = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return createIterResultObject(undefined, true);
  }
  if (kind == 'keys') return createIterResultObject(index, false);
  if (kind == 'values') return createIterResultObject(target[index], false);
  return createIterResultObject([index, target[index]], false);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var values = Iterators.Arguments = Iterators.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

// V8 ~ Chrome 45- bug
if (!IS_PURE && DESCRIPTORS && values.name !== 'values') try {
  defineProperty(values, 'name', { value: 'values' });
} catch (error) { /* empty */ }


/***/ }),

/***/ "e330":
/***/ (function(module, exports, __webpack_require__) {

var classofRaw = __webpack_require__("c6b6");
var uncurryThisRaw = __webpack_require__("7d7e");

module.exports = function (fn) {
  // Nashorn bug:
  //   https://github.com/zloirock/core-js/issues/1128
  //   https://github.com/zloirock/core-js/issues/1130
  if (classofRaw(fn) === 'Function') return uncurryThisRaw(fn);
};


/***/ }),

/***/ "e391":
/***/ (function(module, exports, __webpack_require__) {

var toString = __webpack_require__("577e");

module.exports = function (argument, $default) {
  return argument === undefined ? arguments.length < 2 ? '' : $default : toString(argument);
};


/***/ }),

/***/ "e439":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var fails = __webpack_require__("d039");
var toIndexedObject = __webpack_require__("fc6a");
var nativeGetOwnPropertyDescriptor = __webpack_require__("06cf").f;
var DESCRIPTORS = __webpack_require__("83ab");

var FAILS_ON_PRIMITIVES = fails(function () { nativeGetOwnPropertyDescriptor(1); });
var FORCED = !DESCRIPTORS || FAILS_ON_PRIMITIVES;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
$({ target: 'Object', stat: true, forced: FORCED, sham: !DESCRIPTORS }, {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(it, key) {
    return nativeGetOwnPropertyDescriptor(toIndexedObject(it), key);
  }
});


/***/ }),

/***/ "e538":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");

exports.f = wellKnownSymbol;


/***/ }),

/***/ "e5cb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__("d066");
var hasOwn = __webpack_require__("1a2d");
var createNonEnumerableProperty = __webpack_require__("9112");
var isPrototypeOf = __webpack_require__("3a9b");
var setPrototypeOf = __webpack_require__("d2bb");
var copyConstructorProperties = __webpack_require__("e893");
var proxyAccessor = __webpack_require__("aeb0");
var inheritIfRequired = __webpack_require__("7156");
var normalizeStringArgument = __webpack_require__("e391");
var installErrorCause = __webpack_require__("ab36");
var clearErrorStack = __webpack_require__("0d26");
var ERROR_STACK_INSTALLABLE = __webpack_require__("b980");
var DESCRIPTORS = __webpack_require__("83ab");
var IS_PURE = __webpack_require__("c430");

module.exports = function (FULL_NAME, wrapper, FORCED, IS_AGGREGATE_ERROR) {
  var STACK_TRACE_LIMIT = 'stackTraceLimit';
  var OPTIONS_POSITION = IS_AGGREGATE_ERROR ? 2 : 1;
  var path = FULL_NAME.split('.');
  var ERROR_NAME = path[path.length - 1];
  var OriginalError = getBuiltIn.apply(null, path);

  if (!OriginalError) return;

  var OriginalErrorPrototype = OriginalError.prototype;

  // V8 9.3- bug https://bugs.chromium.org/p/v8/issues/detail?id=12006
  if (!IS_PURE && hasOwn(OriginalErrorPrototype, 'cause')) delete OriginalErrorPrototype.cause;

  if (!FORCED) return OriginalError;

  var BaseError = getBuiltIn('Error');

  var WrappedError = wrapper(function (a, b) {
    var message = normalizeStringArgument(IS_AGGREGATE_ERROR ? b : a, undefined);
    var result = IS_AGGREGATE_ERROR ? new OriginalError(a) : new OriginalError();
    if (message !== undefined) createNonEnumerableProperty(result, 'message', message);
    if (ERROR_STACK_INSTALLABLE) createNonEnumerableProperty(result, 'stack', clearErrorStack(result.stack, 2));
    if (this && isPrototypeOf(OriginalErrorPrototype, this)) inheritIfRequired(result, this, WrappedError);
    if (arguments.length > OPTIONS_POSITION) installErrorCause(result, arguments[OPTIONS_POSITION]);
    return result;
  });

  WrappedError.prototype = OriginalErrorPrototype;

  if (ERROR_NAME !== 'Error') {
    if (setPrototypeOf) setPrototypeOf(WrappedError, BaseError);
    else copyConstructorProperties(WrappedError, BaseError, { name: true });
  } else if (DESCRIPTORS && STACK_TRACE_LIMIT in OriginalError) {
    proxyAccessor(WrappedError, OriginalError, STACK_TRACE_LIMIT);
    proxyAccessor(WrappedError, OriginalError, 'prepareStackTrace');
  }

  copyConstructorProperties(WrappedError, OriginalError);

  if (!IS_PURE) try {
    // Safari 13- bug: WebAssembly errors does not have a proper `.name`
    if (OriginalErrorPrototype.name !== ERROR_NAME) {
      createNonEnumerableProperty(OriginalErrorPrototype, 'name', ERROR_NAME);
    }
    OriginalErrorPrototype.constructor = WrappedError;
  } catch (error) { /* empty */ }

  return WrappedError;
};


/***/ }),

/***/ "e667":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};


/***/ }),

/***/ "e6cf":
/***/ (function(module, exports, __webpack_require__) {

// TODO: Remove this module from `core-js@4` since it's split to modules listed below
__webpack_require__("5e7e");
__webpack_require__("14e5");
__webpack_require__("cc98");
__webpack_require__("3529");
__webpack_require__("f22b");
__webpack_require__("7149");


/***/ }),

/***/ "e893":
/***/ (function(module, exports, __webpack_require__) {

var hasOwn = __webpack_require__("1a2d");
var ownKeys = __webpack_require__("56ef");
var getOwnPropertyDescriptorModule = __webpack_require__("06cf");
var definePropertyModule = __webpack_require__("9bf2");

module.exports = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn(target, key) && !(exceptions && hasOwn(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};


/***/ }),

/***/ "e8b5":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("c6b6");

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
module.exports = Array.isArray || function isArray(argument) {
  return classof(argument) == 'Array';
};


/***/ }),

/***/ "e95a":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");
var Iterators = __webpack_require__("3f8c");

var ITERATOR = wellKnownSymbol('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
};


/***/ }),

/***/ "e9c4":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var getBuiltIn = __webpack_require__("d066");
var apply = __webpack_require__("2ba4");
var call = __webpack_require__("c65b");
var uncurryThis = __webpack_require__("e330");
var fails = __webpack_require__("d039");
var isArray = __webpack_require__("e8b5");
var isCallable = __webpack_require__("1626");
var isObject = __webpack_require__("861d");
var isSymbol = __webpack_require__("d9b5");
var arraySlice = __webpack_require__("f36a");
var NATIVE_SYMBOL = __webpack_require__("04f8");

var $stringify = getBuiltIn('JSON', 'stringify');
var exec = uncurryThis(/./.exec);
var charAt = uncurryThis(''.charAt);
var charCodeAt = uncurryThis(''.charCodeAt);
var replace = uncurryThis(''.replace);
var numberToString = uncurryThis(1.0.toString);

var tester = /[\uD800-\uDFFF]/g;
var low = /^[\uD800-\uDBFF]$/;
var hi = /^[\uDC00-\uDFFF]$/;

var WRONG_SYMBOLS_CONVERSION = !NATIVE_SYMBOL || fails(function () {
  var symbol = getBuiltIn('Symbol')();
  // MS Edge converts symbol values to JSON as {}
  return $stringify([symbol]) != '[null]'
    // WebKit converts symbol values to JSON as null
    || $stringify({ a: symbol }) != '{}'
    // V8 throws on boxed symbols
    || $stringify(Object(symbol)) != '{}';
});

// https://github.com/tc39/proposal-well-formed-stringify
var ILL_FORMED_UNICODE = fails(function () {
  return $stringify('\uDF06\uD834') !== '"\\udf06\\ud834"'
    || $stringify('\uDEAD') !== '"\\udead"';
});

var stringifyWithSymbolsFix = function (it, replacer) {
  var args = arraySlice(arguments);
  var $replacer = replacer;
  if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
  if (!isArray(replacer)) replacer = function (key, value) {
    if (isCallable($replacer)) value = call($replacer, this, key, value);
    if (!isSymbol(value)) return value;
  };
  args[1] = replacer;
  return apply($stringify, null, args);
};

var fixIllFormed = function (match, offset, string) {
  var prev = charAt(string, offset - 1);
  var next = charAt(string, offset + 1);
  if ((exec(low, match) && !exec(hi, next)) || (exec(hi, match) && !exec(low, prev))) {
    return '\\u' + numberToString(charCodeAt(match, 0), 16);
  } return match;
};

if ($stringify) {
  // `JSON.stringify` method
  // https://tc39.es/ecma262/#sec-json.stringify
  $({ target: 'JSON', stat: true, arity: 3, forced: WRONG_SYMBOLS_CONVERSION || ILL_FORMED_UNICODE }, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    stringify: function stringify(it, replacer, space) {
      var args = arraySlice(arguments);
      var result = apply(WRONG_SYMBOLS_CONVERSION ? stringifyWithSymbolsFix : $stringify, null, args);
      return ILL_FORMED_UNICODE && typeof result == 'string' ? replace(result, tester, fixIllFormed) : result;
    }
  });
}


/***/ }),

/***/ "edd0":
/***/ (function(module, exports, __webpack_require__) {

var makeBuiltIn = __webpack_require__("13d2");
var defineProperty = __webpack_require__("9bf2");

module.exports = function (target, name, descriptor) {
  if (descriptor.get) makeBuiltIn(descriptor.get, name, { getter: true });
  if (descriptor.set) makeBuiltIn(descriptor.set, name, { setter: true });
  return defineProperty.f(target, name, descriptor);
};


/***/ }),

/***/ "f069":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aCallable = __webpack_require__("59ed");

var $TypeError = TypeError;

var PromiseCapability = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw $TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aCallable(resolve);
  this.reject = aCallable(reject);
};

// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),

/***/ "f22b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var call = __webpack_require__("c65b");
var newPromiseCapabilityModule = __webpack_require__("f069");
var FORCED_PROMISE_CONSTRUCTOR = __webpack_require__("4738").CONSTRUCTOR;

// `Promise.reject` method
// https://tc39.es/ecma262/#sec-promise.reject
$({ target: 'Promise', stat: true, forced: FORCED_PROMISE_CONSTRUCTOR }, {
  reject: function reject(r) {
    var capability = newPromiseCapabilityModule.f(this);
    call(capability.reject, undefined, r);
    return capability.promise;
  }
});


/***/ }),

/***/ "f36a":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");

module.exports = uncurryThis([].slice);


/***/ }),

/***/ "f5df":
/***/ (function(module, exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__("00ee");
var isCallable = __webpack_require__("1626");
var classofRaw = __webpack_require__("c6b6");
var wellKnownSymbol = __webpack_require__("b622");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var $Object = Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && isCallable(O.callee) ? 'Arguments' : result;
};


/***/ }),

/***/ "f772":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("5692");
var uid = __webpack_require__("90e3");

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),

/***/ "fb15":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "VisSignInPage", function() { return /* reexport */ vis_signin_page; });
__webpack_require__.d(__webpack_exports__, "VisSignInCallbackPage", function() { return /* reexport */ vis_signin_callback_page; });
__webpack_require__.d(__webpack_exports__, "VisSignOutCallbackPage", function() { return /* reexport */ vis_signout_callback_page; });
__webpack_require__.d(__webpack_exports__, "VisSignOutPage", function() { return /* reexport */ vis_signout_page; });
__webpack_require__.d(__webpack_exports__, "VisDialogs", function() { return /* reexport */ vis_dialogs; });
__webpack_require__.d(__webpack_exports__, "VisModal", function() { return /* reexport */ vis_modal; });
__webpack_require__.d(__webpack_exports__, "VisError", function() { return /* reexport */ vis_error; });
__webpack_require__.d(__webpack_exports__, "VisLoading", function() { return /* reexport */ vis_loading; });
__webpack_require__.d(__webpack_exports__, "VisSessionExpiredForm", function() { return /* reexport */ vis_session_expired_form; });
__webpack_require__.d(__webpack_exports__, "VisSignIn", function() { return /* reexport */ vis_signin; });
__webpack_require__.d(__webpack_exports__, "VisSignOut", function() { return /* reexport */ vis_signout; });
__webpack_require__.d(__webpack_exports__, "VisSignInCallback", function() { return /* reexport */ vis_signin_callback; });
__webpack_require__.d(__webpack_exports__, "VisSignOutCallback", function() { return /* reexport */ vis_signout_callback; });
__webpack_require__.d(__webpack_exports__, "VisDefaultError", function() { return /* reexport */ vis_default_error; });
__webpack_require__.d(__webpack_exports__, "VisDefaultLoading", function() { return /* reexport */ vis_default_loading; });
__webpack_require__.d(__webpack_exports__, "VisDefaultSessionExpiredDialog", function() { return /* reexport */ vis_default_session_expired_dialog; });
__webpack_require__.d(__webpack_exports__, "VisDefaultSessionExpiredFormContent", function() { return /* reexport */ vis_default_session_expired_form_content; });
__webpack_require__.d(__webpack_exports__, "VisDefaultSignInPageContent", function() { return /* reexport */ vis_default_signin_page_content; });
__webpack_require__.d(__webpack_exports__, "VisDefaultSignOutPageContent", function() { return /* reexport */ vis_default_signout_page_content; });
__webpack_require__.d(__webpack_exports__, "VisDefaultSignInCallbackPageContent", function() { return /* reexport */ vis_default_signin_callback_page_content; });
__webpack_require__.d(__webpack_exports__, "VisDefaultSignOutCallbackPageContent", function() { return /* reexport */ vis_default_signout_callback_page_content; });
__webpack_require__.d(__webpack_exports__, "authInterceptor", function() { return /* reexport */ auth_interceptor; });
__webpack_require__.d(__webpack_exports__, "authService", function() { return /* reexport */ auth_service; });
__webpack_require__.d(__webpack_exports__, "configureService", function() { return /* reexport */ configure_service; });
__webpack_require__.d(__webpack_exports__, "configureAxios", function() { return /* reexport */ configure_axios; });
__webpack_require__.d(__webpack_exports__, "configureRouter", function() { return /* reexport */ configure_router; });
__webpack_require__.d(__webpack_exports__, "createRoutes", function() { return /* reexport */ configure_router_createRoutes; });
__webpack_require__.d(__webpack_exports__, "configureRoutes", function() { return /* reexport */ configure_router_configureRoutes; });
__webpack_require__.d(__webpack_exports__, "configureSecurityRouter", function() { return /* reexport */ configure_router_configureSecurityRouter; });
__webpack_require__.d(__webpack_exports__, "configureRouteCheckAuth", function() { return /* reexport */ configureRouteCheckAuth; });
__webpack_require__.d(__webpack_exports__, "configureSignInDelegate", function() { return /* reexport */ signin_delegate; });
__webpack_require__.d(__webpack_exports__, "Const", function() { return /* reexport */ const_namespaceObject; });
__webpack_require__.d(__webpack_exports__, "messages", function() { return /* reexport */ utils_messages; });
__webpack_require__.d(__webpack_exports__, "returnPath", function() { return /* reexport */ return_path; });

// NAMESPACE OBJECT: ./src/lib/utils/const.js
var const_namespaceObject = {};
__webpack_require__.r(const_namespaceObject);
__webpack_require__.d(const_namespaceObject, "AUTH_HEADER", function() { return AUTH_HEADER; });
__webpack_require__.d(const_namespaceObject, "AUTH_TYPE", function() { return AUTH_TYPE; });
__webpack_require__.d(const_namespaceObject, "RETRY_REQUEST_PROP", function() { return RETRY_REQUEST_PROP; });
__webpack_require__.d(const_namespaceObject, "HTTP_UNAUTHORIZED", function() { return HTTP_UNAUTHORIZED; });
__webpack_require__.d(const_namespaceObject, "NO_AUTH_REQUEST_PARAM", function() { return NO_AUTH_REQUEST_PARAM; });
__webpack_require__.d(const_namespaceObject, "signInRoutePath", function() { return signInRoutePath; });
__webpack_require__.d(const_namespaceObject, "signOutRoutePath", function() { return signOutRoutePath; });
__webpack_require__.d(const_namespaceObject, "signInCallbackRoutePath", function() { return signInCallbackRoutePath; });
__webpack_require__.d(const_namespaceObject, "signOutCallbackRoutePath", function() { return signOutCallbackRoutePath; });
__webpack_require__.d(const_namespaceObject, "homeRoutePath", function() { return homeRoutePath; });
__webpack_require__.d(const_namespaceObject, "signInErrorRoutePath", function() { return signInErrorRoutePath; });
__webpack_require__.d(const_namespaceObject, "signInRouteName", function() { return signInRouteName; });
__webpack_require__.d(const_namespaceObject, "signOutRouteName", function() { return signOutRouteName; });
__webpack_require__.d(const_namespaceObject, "signInCallbackRouteName", function() { return signInCallbackRouteName; });
__webpack_require__.d(const_namespaceObject, "signOutCallbackRouteName", function() { return signOutCallbackRouteName; });
__webpack_require__.d(const_namespaceObject, "homeRouteName", function() { return const_homeRouteName; });
__webpack_require__.d(const_namespaceObject, "signInErrorRouteName", function() { return signInErrorRouteName; });
__webpack_require__.d(const_namespaceObject, "defaultRoutePaths", function() { return defaultRoutePaths; });
__webpack_require__.d(const_namespaceObject, "silentRenewRoutePath", function() { return silentRenewRoutePath; });
__webpack_require__.d(const_namespaceObject, "popupCallbackRoutePath", function() { return popupCallbackRoutePath; });
__webpack_require__.d(const_namespaceObject, "redirectUri", function() { return const_redirectUri; });
__webpack_require__.d(const_namespaceObject, "postLogoutRedirectUri", function() { return postLogoutRedirectUri; });
__webpack_require__.d(const_namespaceObject, "silentRedirectUri", function() { return silentRedirectUri; });
__webpack_require__.d(const_namespaceObject, "popupRedirectUri", function() { return popupRedirectUri; });
__webpack_require__.d(const_namespaceObject, "popupWindowRect", function() { return popupWindowRect; });
__webpack_require__.d(const_namespaceObject, "defaultLocale", function() { return defaultLocale; });
__webpack_require__.d(const_namespaceObject, "overrideComponentNames", function() { return overrideComponentNames; });
__webpack_require__.d(const_namespaceObject, "jwtTimeErrors", function() { return jwtTimeErrors; });

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (true) {
    var getCurrentScript = __webpack_require__("8875")
    currentScript = getCurrentScript()

    // for backward compatibility, because previously we directly included the polyfill
    if (!('currentScript' in document)) {
      Object.defineProperty(document, 'currentScript', { get: getCurrentScript })
    }
  }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("b64b");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("a4d3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("4de4");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("d3b7");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("e439");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.push.js
var es_array_push = __webpack_require__("14d9");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("159b");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("dbb4");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js









function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js


function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__("e01a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.iterator.js
var es_symbol_iterator = __webpack_require__("d28b");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__("e260");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__("3ca3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__("ddb0");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.async-iterator.js
var es_symbol_async_iterator = __webpack_require__("b636");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.to-string-tag.js
var es_symbol_to_string_tag = __webpack_require__("944a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.json.to-string-tag.js
var es_json_to_string_tag = __webpack_require__("0c47");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.math.to-string-tag.js
var es_math_to_string_tag = __webpack_require__("23dc");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-prototype-of.js
var es_object_get_prototype_of = __webpack_require__("3410");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.error.cause.js
var es_error_cause = __webpack_require__("d9e2");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("b0c0");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.set-prototype-of.js
var es_object_set_prototype_of = __webpack_require__("131a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.proto.js
var es_object_proto = __webpack_require__("1f68");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.promise.js
var es_promise = __webpack_require__("e6cf");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__("fb6a");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js







function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js





















function _regeneratorRuntime() {
  "use strict";

  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime = function _regeneratorRuntime() {
    return exports;
  };
  var exports = {},
    Op = Object.prototype,
    hasOwn = Op.hasOwnProperty,
    defineProperty = Object.defineProperty || function (obj, key, desc) {
      obj[key] = desc.value;
    },
    $Symbol = "function" == typeof Symbol ? Symbol : {},
    iteratorSymbol = $Symbol.iterator || "@@iterator",
    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }
  try {
    define({}, "");
  } catch (err) {
    define = function define(obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
      generator = Object.create(protoGenerator.prototype),
      context = new Context(tryLocsList || []);
    return defineProperty(generator, "_invoke", {
      value: makeInvokeMethod(innerFn, self, context)
    }), generator;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ("throw" !== record.type) {
        var result = record.arg,
          value = result.value;
        return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    defineProperty(this, "_invoke", {
      value: function value(method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(innerFn, self, context) {
    var state = "suspendedStart";
    return function (method, arg) {
      if ("executing" === state) throw new Error("Generator is already running");
      if ("completed" === state) {
        if ("throw" === method) throw arg;
        return doneResult();
      }
      for (context.method = method, context.arg = arg;;) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
          if ("suspendedStart" === state) throw state = "completed", context.arg;
          context.dispatchException(context.arg);
        } else "return" === context.method && context.abrupt("return", context.arg);
        state = "executing";
        var record = tryCatch(innerFn, self, context);
        if ("normal" === record.type) {
          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
          return {
            value: record.arg,
            done: context.done
          };
        }
        "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
      }
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (undefined === method) {
      if (context.delegate = null, "throw" === context.method) {
        if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
        context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }
      return ContinueSentinel;
    }
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            for (; ++i < iterable.length;) {
              if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
            }
            return next.value = undefined, next.done = !0, next;
          };
        return next.next = next;
      }
    }
    return {
      next: doneResult
    };
  }
  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), defineProperty(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (val) {
    var object = Object(val),
      keys = [];
    for (var key in object) {
      keys.push(key);
    }
    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) {
        "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
      }
    },
    stop: function stop() {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(exception) {
      if (this.done) throw exception;
      var context = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
          record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
            hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function complete(record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function finish(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    "catch": function _catch(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js


function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.sub.js
var es_string_sub = __webpack_require__("4c53");

// CONCATENATED MODULE: ./src/lib/utils/manage.js


var createHiddenInput = function createHiddenInput(name, value) {
  var input = document.createElement("input");
  input.type = "hidden";
  input.name = name;
  input.value = value;
  return input;
};
var createForm = function createForm(authority, redirectUri, idToken) {
  var state = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var form = document.createElement("form");
  form.style.position = "absolute";
  form.action = "".concat(authority, "/api/manage");
  form.method = "POST";
  form.enctype = "application/x-www-form-urlencoded";
  form.appendChild(createHiddenInput("redirect_uri", redirectUri));
  form.appendChild(createHiddenInput("id_token", idToken));
  if (state) {
    form.appendChild(createHiddenInput("state", state));
  }
  return form;
};
function manage_manageRedirect(authority, redirectUri, idToken) {
  var state = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  if (!authority) throw new Error("authority is required");
  if (!redirectUri) throw new Error("redirectUri is required");
  if (!idToken) throw new Error("idToken is required");
  if (!document.body) throw new Error("failed to redirect");
  var form = createForm(authority, redirectUri, idToken, state);
  document.body.appendChild(form);
  form.submit();
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("99af");

// EXTERNAL MODULE: ./src/lib/utils/oidc.js
var oidc = __webpack_require__("3dc2");
var oidc_default = /*#__PURE__*/__webpack_require__.n(oidc);

// CONCATENATED MODULE: ./src/lib/utils/const.js

var AUTH_HEADER = "Authorization";
var AUTH_TYPE = "Bearer";
var RETRY_REQUEST_PROP = "__isRetry__";
var HTTP_UNAUTHORIZED = 401;
var NO_AUTH_REQUEST_PARAM = "_noAuth";
var signInRoutePath = "/signin";
var signOutRoutePath = "/signout";
var signInCallbackRoutePath = "/signin-callback";
var signOutCallbackRoutePath = "/signout-callback";
var homeRoutePath = "/";
var signInErrorRoutePath = "/signin-error";
var signInRouteName = "signIn";
var signOutRouteName = "signOut";
var signInCallbackRouteName = "signInCallback";
var signOutCallbackRouteName = "signOutCallback";
var const_homeRouteName = "home";
var signInErrorRouteName = "signInError";
var defaultRoutePaths = {
  signIn: signInRoutePath,
  signInName: signInRouteName,
  signOut: signOutRoutePath,
  signOutName: signOutRouteName,
  signInCallback: signInCallbackRoutePath,
  signInCallbackName: signInCallbackRouteName,
  signOutCallback: signOutCallbackRoutePath,
  signOutCallbackName: signOutCallbackRouteName,
  unauthorized: null,
  unauthorizedName: null,
  home: homeRoutePath,
  homeName: const_homeRouteName,
  signInError: signInErrorRoutePath,
  signInErrorName: signInErrorRouteName
};
var silentRenewRoutePath = "/static/oidc-silent-renew.html";
var popupCallbackRoutePath = "/static/oidc-popup-callback.html";
var baseUrl = window.location.origin;
var const_redirectUri = "".concat(baseUrl).concat(signInCallbackRoutePath);
var postLogoutRedirectUri = "".concat(baseUrl).concat(signOutCallbackRoutePath);
var silentRedirectUri = "".concat(baseUrl).concat(silentRenewRoutePath);
var popupRedirectUri = "".concat(baseUrl).concat(popupCallbackRoutePath);
var popupWindowRect = {
  left: 300,
  top: 200,
  width: 640,
  height: 760
};
var defaultLocale = "ru";
var overrideComponentNames = {
  signInPageContent: {
    camelCase: "VisIdentitySigninPageContent",
    kebabCase: "vis-identity-signin-page-content"
  },
  signOutPageContent: {
    camelCase: "VisIdentitySignoutPageContent",
    kebabCase: "vis-identity-signout-page-content"
  },
  signOutCallbackPageContent: {
    camelCase: "VisIdentitySignoutCallbackPageContent",
    kebabCase: "vis-identity-signout-callback-page-content"
  },
  signInCallbackPageContent: {
    camelCase: "VisIdentitySigninCallbackPageContent",
    kebabCase: "vis-identity-signin-callback-page-content"
  },
  signInErrorPageContent: {
    camelCase: "VisIdentitySignInErrorPageContent",
    kebabCase: "vis-identity-signin-error-page-content"
  },
  loading: {
    camelCase: "VisIdentityLoading",
    kebabCase: "vis-identity-loading"
  },
  error: {
    camelCase: "VisIdentityError",
    kebabCase: "vis-identity-error"
  },
  modal: {
    camelCase: "VisIdentityModal",
    kebabCase: "vis-identity-modal"
  },
  sessionExpiredDialog: {
    camelCase: "VisIdentitySessionExpiredDialog",
    kebabCase: "vis-identity-session-expired-dialog"
  },
  sessionExpiredFormContent: {
    camelCase: "VisIdentitySessionExpiredFormContent",
    kebabCase: "vis-identity-session-expired-form-content"
  }
};
var jwtTimeErrors = ["iat is in the future", "nbf is in the future", "exp was not provided", "exp is in the past"];
// CONCATENATED MODULE: ./src/lib/utils/oidc-manager.js







var managerInstance = null;
var configureResolve = null;
var configurePromise = null;
var oidc_manager_getDefualtLoggerOptions = function getDefualtLoggerOptions() {
  return {
    logger: console,
    level:  true ? oidc_default.a.Log.INFO : undefined
  };
};
var oidc_manager_configureLogger = function configureLogger(_ref) {
  var logger = _ref.logger,
    level = _ref.level;
  oidc_default.a.Log.logger = logger;
  oidc_default.a.Log.level = level;
};
var oidc_manager_configure = function configure(_ref2) {
  var serverUrl = _ref2.serverUrl,
    clientId = _ref2.clientId,
    scope = _ref2.scope,
    _ref2$popupWindowSize = _ref2.popupWindowSize,
    popupWindowSize = _ref2$popupWindowSize === void 0 ? null : _ref2$popupWindowSize,
    _ref2$configureOption = _ref2.configureOptions,
    configureOptions = _ref2$configureOption === void 0 ? function (opt) {
      return opt;
    } : _ref2$configureOption,
    _ref2$configureLogger = _ref2.configureLoggerOptions,
    configureLoggerOptions = _ref2$configureLogger === void 0 ? function (opt) {
      return opt;
    } : _ref2$configureLogger;
  oidc_manager_configureLogger(configureLoggerOptions(oidc_manager_getDefualtLoggerOptions()));
  var wndRect = _objectSpread2(_objectSpread2({}, popupWindowRect), popupWindowSize);
  managerInstance = new oidc_default.a.UserManager(configureOptions({
    userStore: new oidc_default.a.WebStorageStateStore({
      store: window.localStorage
    }),
    authority: serverUrl,
    client_id: clientId,
    redirect_uri: const_redirectUri,
    response_type: "code",
    response_mode: "query",
    scope: scope,
    post_logout_redirect_uri: postLogoutRedirectUri,
    silent_redirect_uri: silentRedirectUri,
    popup_redirect_uri: popupRedirectUri,
    popupWindowFeatures: "location=no,toolbar=no,width=".concat(wndRect.width, ",height=").concat(wndRect.height, ",left=").concat(wndRect.left, ",top=").concat(wndRect.top),
    monitorSession: false
  }));
  if (configureResolve) {
    configureResolve(managerInstance);
  }
};
var oidcManager = {
  get instance() {
    if (!managerInstance) {
      throw new Error("This oidc manager not configured. Call configure method.");
    }
    return managerInstance;
  },
  configure: oidc_manager_configure,
  waitConfigure: function waitConfigure() {
    if (!configurePromise) {
      configurePromise = new Promise(function (resolve) {
        configureResolve = resolve;
      });
    }
    return configurePromise;
  }
};
/* harmony default export */ var oidc_manager = (oidcManager);
// CONCATENATED MODULE: ./src/lib/utils/auth-service.js







/* harmony default export */ var auth_service = ({
  configure: function configure(options) {
    oidc_manager.configure(options);
  },
  signInRedirect: function signInRedirect(returnPath) {
    var opts = returnPath ? {
      state: returnPath
    } : undefined;
    return oidc_manager.instance.signinRedirect(opts);
  },
  signOutRedirect: function signOutRedirect() {
    var showLogoutPrompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var extraQueryParams = {};
    if (showLogoutPrompt) {
      extraQueryParams.show_logout_prompt = !!showLogoutPrompt;
    }
    return oidc_manager.instance.signoutRedirect({
      extraQueryParams: extraQueryParams
    });
  },
  signOutIframe: function signOutIframe() {
    return new Promise(function (resolve, reject) {
      var singOutIframeTimeout = 1000;
      var cb = /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.prev = 0;
                  _context.next = 3;
                  return oidc_manager.instance.removeUser();
                case 3:
                  resolve();
                  _context.next = 9;
                  break;
                case 6:
                  _context.prev = 6;
                  _context.t0 = _context["catch"](0);
                  reject(_context.t0);
                case 9:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[0, 6]]);
        }));
        return function cb() {
          return _ref.apply(this, arguments);
        };
      }();
      setTimeout(cb, singOutIframeTimeout);
    });
  },
  signInCallback: function signInCallback() {
    return oidc_manager.instance.signinRedirectCallback();
  },
  signOutCallback: function signOutCallback() {
    return oidc_manager.instance.signoutRedirectCallback();
  },
  signInSilent: function signInSilent() {
    return oidc_manager.instance.signinSilent();
  },
  signInPopup: function signInPopup() {
    return oidc_manager.instance.signinPopup();
  },
  clearStaleState: function clearStaleState() {
    oidc_manager.instance.clearStaleState();
  },
  getOidcManager: function getOidcManager() {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var manager;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              return _context2.abrupt("return", oidc_manager.instance);
            case 4:
              _context2.prev = 4;
              _context2.t0 = _context2["catch"](0);
              _context2.next = 8;
              return oidc_manager.waitConfigure();
            case 8:
              manager = _context2.sent;
              return _context2.abrupt("return", manager);
            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 4]]);
    }))();
  },
  getIdentityUser: function getIdentityUser() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var manager, user;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this.getOidcManager();
            case 2:
              manager = _context3.sent;
              _context3.next = 5;
              return manager.getUser();
            case 5:
              user = _context3.sent;
              return _context3.abrupt("return", user);
            case 7:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  },
  getAccessToken: function getAccessToken() {
    var _this2 = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      var identityUser;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return _this2.getIdentityUser();
            case 2:
              identityUser = _context4.sent;
              return _context4.abrupt("return", identityUser ? identityUser.access_token : null);
            case 4:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }))();
  },
  getUserId: function getUserId() {
    var _this3 = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
      var identityUser;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return _this3.getIdentityUser();
            case 2:
              identityUser = _context5.sent;
              return _context5.abrupt("return", identityUser && identityUser.profile ? identityUser.profile.sub : null);
            case 4:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }))();
  },
  removeUser: function removeUser() {
    var _this4 = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
      var manager;
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return _this4.getOidcManager();
            case 2:
              manager = _context6.sent;
              _context6.next = 5;
              return manager.removeUser();
            case 5:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }))();
  },
  manageRedirect: function manageRedirect() {
    var _arguments = arguments,
      _this5 = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
      var state, manager, user, authority, redirectUri, idToken;
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              state = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : null;
              _context7.next = 3;
              return _this5.getOidcManager();
            case 3:
              manager = _context7.sent;
              _context7.next = 6;
              return manager.getUser();
            case 6:
              user = _context7.sent;
              authority = manager.settings.authority;
              redirectUri = manager.settings.redirect_uri;
              idToken = user.id_token;
              manage_manageRedirect(authority, redirectUri, idToken, state);
            case 11:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }))();
  }
});
// CONCATENATED MODULE: ./src/lib/utils/auth-util.js



var auth_util_createAuthHeaderValue = function createAuthHeaderValue(accessToken) {
  return "".concat(AUTH_TYPE, " ").concat(accessToken);
};
var auth_util_createAuthHeader = function createAuthHeader(accessToken) {
  return _defineProperty({}, AUTH_HEADER, auth_util_createAuthHeaderValue(accessToken));
};
var auth_util_isUnauthorized = function isUnauthorized(httpStatus) {
  return httpStatus === HTTP_UNAUTHORIZED;
};
var httpErrorIsUnauthorized = function httpErrorIsUnauthorized(error) {
  return error && error.response && error.response.status && auth_util_isUnauthorized(error.response.status);
};
// CONCATENATED MODULE: ./src/lib/utils/auth-interceptor.js









var isAlreadyFetchingAccessToken = false;
var subscribers = [];
var fetchAndSaveTokensDelegate = null;
var auth_interceptor_setAuthHeader = function setAuthHeader(config, accessToken) {
  config.headers.common[AUTH_HEADER] = auth_util_createAuthHeaderValue(accessToken);
};
var auth_interceptor_removeAuthHeader = function removeAuthHeader(config) {
  if (config.headers) {
    delete config.headers[AUTH_HEADER];
  }
};
var onAccessTokenFetched = function onAccessTokenFetched() {
  subscribers.forEach(function (entry) {
    return entry.successCallback();
  });
  subscribers = [];
};
var onAccessTokenFailed = function onAccessTokenFailed() {
  subscribers.forEach(function (entry) {
    return entry.errorCallback();
  });
  subscribers = [];
};
var addSubscriber = function addSubscriber(successCallback, errorCallback) {
  subscribers.push({
    successCallback: successCallback,
    errorCallback: errorCallback
  });
};
var tryFetchAccessToken = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!isAlreadyFetchingAccessToken) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return");
          case 2:
            if (!(typeof fetchAndSaveTokensDelegate !== "function")) {
              _context.next = 5;
              break;
            }
            onAccessTokenFailed();
            return _context.abrupt("return");
          case 5:
            isAlreadyFetchingAccessToken = true;
            _context.prev = 6;
            _context.next = 9;
            return fetchAndSaveTokensDelegate();
          case 9:
            onAccessTokenFetched();
            _context.next = 15;
            break;
          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](6);
            onAccessTokenFailed();
          case 15:
            _context.prev = 15;
            isAlreadyFetchingAccessToken = false;
            return _context.finish(15);
          case 18:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[6, 12, 15, 18]]);
  }));
  return function tryFetchAccessToken() {
    return _ref.apply(this, arguments);
  };
}();
var auth_interceptor_addToQueueRetryOriginalRequest = function addToQueueRetryOriginalRequest(axios, originalRequest, originalError) {
  return new Promise(function (resolve, reject) {
    addSubscriber(function () {
      auth_interceptor_removeAuthHeader(originalRequest);
      originalRequest[RETRY_REQUEST_PROP] = true;
      resolve(axios(originalRequest));
    }, function () {
      reject(originalError);
    });
  });
};
var auth_interceptor_createRequestInterceptor = function createRequestInterceptor(axios) {
  axios.interceptors.request.use( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(config) {
      var accessToken;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!config[NO_AUTH_REQUEST_PARAM]) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return", config);
            case 2:
              if (!(config.params && config.params[NO_AUTH_REQUEST_PARAM])) {
                _context2.next = 6;
                break;
              }
              config[NO_AUTH_REQUEST_PARAM] = config.params[NO_AUTH_REQUEST_PARAM];
              delete config.params[NO_AUTH_REQUEST_PARAM];
              return _context2.abrupt("return", config);
            case 6:
              _context2.next = 8;
              return auth_service.getAccessToken();
            case 8:
              accessToken = _context2.sent;
              if (accessToken) {
                auth_interceptor_setAuthHeader(config, accessToken);
              }
              return _context2.abrupt("return", config);
            case 11:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), function (error) {
    return Promise.reject(error);
  });
};
var auth_interceptor_createResponseInterceptor = function createResponseInterceptor(axios) {
  axios.interceptors.response.use(function (response) {
    return response;
  }, function (error) {
    var originalRequest = error.config;
    if (!originalRequest || originalRequest[NO_AUTH_REQUEST_PARAM]) {
      return Promise.reject(error);
    }
    if (httpErrorIsUnauthorized(error) && !originalRequest[RETRY_REQUEST_PROP]) {
      var retryOriginalRequest = auth_interceptor_addToQueueRetryOriginalRequest(axios, originalRequest, error);
      tryFetchAccessToken();
      return retryOriginalRequest;
    }
    return Promise.reject(error);
  });
};
/* harmony default export */ var auth_interceptor = ({
  use: function use(axios) {
    auth_interceptor_createRequestInterceptor(axios);
    auth_interceptor_createResponseInterceptor(axios);
  },
  setFetchAndSaveTokensDelegate: function setFetchAndSaveTokensDelegate(delegate) {
    fetchAndSaveTokensDelegate = delegate;
  },
  getFetchAndSaveTokensDelegate: function getFetchAndSaveTokensDelegate() {
    return fetchAndSaveTokensDelegate;
  }
});
// CONCATENATED MODULE: ./src/lib/utils/configure-axios.js

/* harmony default export */ var configure_axios = (function (axios) {
  auth_interceptor.use(axios);
});
// CONCATENATED MODULE: ./src/lib/utils/return-path.js
var savedPath = null;
/* harmony default export */ var return_path = (function (path) {
  if (path === undefined) return savedPath;
  var prevPath = savedPath;
  savedPath = path;
  return prevPath;
});
// CONCATENATED MODULE: ./src/lib/utils/logger.js
/* harmony default export */ var utils_logger = ({
  error: function error(messageOrError) {
    if (console.error) {
      console.error(messageOrError);
    } else if (console.log) {
      console.log(messageOrError);
    }
  }
});
// CONCATENATED MODULE: ./src/lib/utils/security-router.js






/* harmony default export */ var security_router = ({
  use: function use(router) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    router.beforeEach( /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(to, from, next) {
        var identityUser, requiresAuth;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return auth_service.getIdentityUser();
              case 3:
                identityUser = _context.sent;
                if (identityUser) {
                  next();
                } else {
                  requiresAuth = to.matched.some(function (record) {
                    return record.meta && record.meta.requiresAuth;
                  });
                  if (requiresAuth) {
                    return_path(to.fullPath);
                    if (options.signInRoutePath || options.signInRouteName) {
                      if (options.signInRouteName) {
                        next({
                          name: options.signInRouteName
                        });
                      } else {
                        next(options.signInRoutePath);
                      }
                    } else if (options.unauthorizedRoutePath || options.unauthorizedRouteName) {
                      if (options.unauthorizedRouteName) {
                        next({
                          name: options.unauthorizedRouteName
                        });
                      } else {
                        next(options.unauthorizedRoutePath);
                      }
                    }
                  } else {
                    next();
                  }
                }
                _context.next = 11;
                break;
              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);
                utils_logger.error(_context.t0);
                next(_context.t0);
              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 7]]);
      }));
      return function (_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      };
    }());
  }
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c32f5738-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/components/vis-signin-page.vue?vue&type=template&id=21086b02&
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(_vm.componentName, {
    tag: "component"
  });
};
var staticRenderFns = [];

// CONCATENATED MODULE: ./src/lib/components/vis-signin-page.vue?vue&type=template&id=21086b02&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c32f5738-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/components/vis-default-signin-page-content.vue?vue&type=template&id=02cb35f6&
var vis_default_signin_page_contentvue_type_template_id_02cb35f6_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('vis-signin', {
    staticClass: "vis-identity-page",
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var loading = _ref.loading,
          error = _ref.error,
          message = _ref.message,
          onRepeat = _ref.onRepeat;
        return [loading ? _c('vis-loading', {
          attrs: {
            "size": "lg"
          }
        }, [_vm._v(_vm._s(message))]) : error ? _c('vis-error', {
          attrs: {
            "size": "lg",
            "show-repeat-btn": _vm.$visIdentity.showRepeatBtnOnError,
            "show-back-to-home": _vm.$visIdentity.showBackToHomeOnError
          },
          on: {
            "repeat": onRepeat
          }
        }, [_vm._v(_vm._s(message))]) : _vm._e()];
      }
    }])
  });
};
var vis_default_signin_page_contentvue_type_template_id_02cb35f6_staticRenderFns = [];

// CONCATENATED MODULE: ./src/lib/components/vis-default-signin-page-content.vue?vue&type=template&id=02cb35f6&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c32f5738-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/components/vis-signin.vue?vue&type=template&id=75b07107&
var vis_signinvue_type_template_id_75b07107_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_vm._t("default", null, {
    "loading": _vm.loading,
    "error": _vm.error,
    "message": _vm.message,
    "onRepeat": _vm.onRepeat
  })], 2);
};
var vis_signinvue_type_template_id_75b07107_staticRenderFns = [];

// CONCATENATED MODULE: ./src/lib/components/vis-signin.vue?vue&type=template&id=75b07107&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/components/vis-signin.vue?vue&type=script&lang=js&






/* harmony default export */ var vis_signinvue_type_script_lang_js_ = ({
  name: "vis-signin",
  data: function data() {
    return {
      loading: false,
      error: false
    };
  },
  computed: {
    message: function message() {
      if (this.loading) {
        return this.$visIdentity.getMessage("signInLoading");
      } else if (this.error) {
        return this.$visIdentity.getMessage("signInError");
      } else {
        return null;
      }
    }
  },
  created: function created() {
    this.signIn();
  },
  methods: {
    signIn: function signIn() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _this.clearReturnPathIfCurrent();
                _this.loading = true;
                _this.error = false;
                _context.next = 6;
                return auth_service.signInSilent();
              case 6:
                _this.redirectToReturnPath();
                _context.next = 28;
                break;
              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](0);
                utils_logger.error(_context.t0.message);
                _context.prev = 12;
                if (!_this.$visIdentity.useSignInPopup) {
                  _context.next = 19;
                  break;
                }
                _context.next = 16;
                return auth_service.signInPopup();
              case 16:
                _this.redirectToReturnPath();
                _context.next = 21;
                break;
              case 19:
                _context.next = 21;
                return auth_service.signInRedirect(return_path());
              case 21:
                _context.next = 28;
                break;
              case 23:
                _context.prev = 23;
                _context.t1 = _context["catch"](12);
                utils_logger.error(_context.t1);
                _this.loading = false;
                _this.error = true;
              case 28:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 9], [12, 23]]);
      }))();
    },
    clearReturnPathIfCurrent: function clearReturnPathIfCurrent() {
      if (return_path() === this.$route.fullPath) {
        return_path(null);
      }
    },
    redirectToReturnPath: function redirectToReturnPath() {
      if (return_path()) {
        this.$router.push({
          path: return_path()
        });
      } else {
        this.$visIdentity.navigateToHome(this.$router);
      }
    },
    onRepeat: function onRepeat() {
      this.signIn();
    }
  }
});
// CONCATENATED MODULE: ./src/lib/components/vis-signin.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_vis_signinvue_type_script_lang_js_ = (vis_signinvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent(
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */,
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options =
    typeof scriptExports === 'function' ? scriptExports.options : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) {
    // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
          injectStyles.call(
            this,
            (options.functional ? this.parent : this).$root.$options.shadowRoot
          )
        }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

// CONCATENATED MODULE: ./src/lib/components/vis-signin.vue





/* normalize component */

var component = normalizeComponent(
  components_vis_signinvue_type_script_lang_js_,
  vis_signinvue_type_template_id_75b07107_render,
  vis_signinvue_type_template_id_75b07107_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var vis_signin = (component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c32f5738-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/components/vis-loading.vue?vue&type=template&id=2037315c&
var vis_loadingvue_type_template_id_2037315c_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(_vm.componentName, _vm._b({
    tag: "component"
  }, 'component', _vm.$props, false), [_vm._t("default")], 2);
};
var vis_loadingvue_type_template_id_2037315c_staticRenderFns = [];

// CONCATENATED MODULE: ./src/lib/components/vis-loading.vue?vue&type=template&id=2037315c&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c32f5738-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/components/vis-default-loading.vue?vue&type=template&id=ca4e1798&
var vis_default_loadingvue_type_template_id_ca4e1798_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "vis-identity-loading",
    class: {
      'vis-identity-loading--padding': !_vm.noPadding
    }
  }, [_c('div', {
    staticClass: "vis-identity-loading__spinner",
    class: _vm.sizeClass
  }, [_c('svg', {
    staticClass: "vis-identity-loading__spinner__circle",
    attrs: {
      "viewBox": "25 25 50 50"
    }
  }, [_c('circle', {
    staticClass: "vis-identity-loading__spinner__path",
    class: _vm.color,
    attrs: {
      "cx": "50",
      "cy": "50",
      "r": "20",
      "fill": "none",
      "stroke-width": "2",
      "stroke-miterlimit": "10"
    }
  })])]), _vm.hasDefaultSlot ? _c('span', {
    staticClass: "vis-identity-loading__message"
  }, [_vm._t("default")], 2) : _vm._e()]);
};
var vis_default_loadingvue_type_template_id_ca4e1798_staticRenderFns = [];

// CONCATENATED MODULE: ./src/lib/components/vis-default-loading.vue?vue&type=template&id=ca4e1798&

// CONCATENATED MODULE: ./src/lib/utils/prop-array-validator.js
/* harmony default export */ var prop_array_validator = (function (array) {
  return function (value) {
    return array.indexOf(value) !== -1;
  };
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/components/vis-default-loading.vue?vue&type=script&lang=js&

/* harmony default export */ var vis_default_loadingvue_type_script_lang_js_ = ({
  name: "vis-default-loading",
  props: {
    size: {
      type: String,
      default: "md",
      validator: prop_array_validator(["xs", "sm", "md", "lg", "auto"])
    },
    noPadding: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: null
    }
  },
  computed: {
    sizeClass: function sizeClass() {
      switch (this.size) {
        case "lg":
          return "vis-identity-loading__spinner--lg";
        case "sm":
          return "vis-identity-loading__spinner--sm";
        case "xs":
          return "vis-identity-loading__spinner--xs";
        case "auto":
          return "vis-identity-loading__spinner--auto";
        default:
          return "vis-identity-loading__spinner--md";
      }
    },
    hasDefaultSlot: function hasDefaultSlot() {
      return !!this.$slots.default;
    }
  }
});
// CONCATENATED MODULE: ./src/lib/components/vis-default-loading.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_vis_default_loadingvue_type_script_lang_js_ = (vis_default_loadingvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/lib/components/vis-default-loading.vue





/* normalize component */

var vis_default_loading_component = normalizeComponent(
  components_vis_default_loadingvue_type_script_lang_js_,
  vis_default_loadingvue_type_template_id_ca4e1798_render,
  vis_default_loadingvue_type_template_id_ca4e1798_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var vis_default_loading = (vis_default_loading_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/components/vis-loading.vue?vue&type=script&lang=js&


var defaultComponentName = "vis-default-loading";
/* harmony default export */ var vis_loadingvue_type_script_lang_js_ = ({
  name: "vis-loading",
  components: {
    VisDefaultLoading: vis_default_loading
  },
  props: {
    size: {
      type: String,
      default: null
    }
  },
  computed: {
    componentName: function componentName() {
      return this.isCustomComponent ? overrideComponentNames.loading.kebabCase : defaultComponentName;
    },
    isCustomComponent: function isCustomComponent() {
      return !!(this.$options.components[overrideComponentNames.loading.camelCase] || this.$options.components[overrideComponentNames.loading.kebabCase]);
    }
  }
});
// CONCATENATED MODULE: ./src/lib/components/vis-loading.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_vis_loadingvue_type_script_lang_js_ = (vis_loadingvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/lib/components/vis-loading.vue





/* normalize component */

var vis_loading_component = normalizeComponent(
  components_vis_loadingvue_type_script_lang_js_,
  vis_loadingvue_type_template_id_2037315c_render,
  vis_loadingvue_type_template_id_2037315c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var vis_loading = (vis_loading_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c32f5738-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/components/vis-error.vue?vue&type=template&id=57596d4c&
var vis_errorvue_type_template_id_57596d4c_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(_vm.componentName, _vm._g(_vm._b({
    tag: "component",
    scopedSlots: _vm._u([_vm.$slots.descr ? {
      key: "descr",
      fn: function fn() {
        return [_vm._t("descr")];
      },
      proxy: true
    } : null], null, true)
  }, 'component', _vm.$props, false), _vm.$listeners), [_vm._t("default")], 2);
};
var vis_errorvue_type_template_id_57596d4c_staticRenderFns = [];

// CONCATENATED MODULE: ./src/lib/components/vis-error.vue?vue&type=template&id=57596d4c&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c32f5738-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/components/vis-default-error.vue?vue&type=template&id=7394da55&
var vis_default_errorvue_type_template_id_7394da55_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "vis-identity-error"
  }, [_c('span', {
    staticClass: "vis-identity-error__icon",
    class: _vm.sizeClass
  }, [_c('vis-error-icon')], 1), _vm.hasDefaultSlot ? _c('span', {
    staticClass: "vis-identity-error__message"
  }, [_vm._t("default")], 2) : _vm._e(), _vm.$slots.descr ? _c('span', {
    staticClass: "vis-identity-error__description"
  }, [_vm._t("descr")], 2) : _vm._e(), _vm.showRepeatBtn ? _c('button', {
    staticClass: "vis-identity-error__repeat-btn vis-identity-button vis-identity-button--outline",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.onRepeat.apply(null, arguments);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.repeatButtonTitle) + " ")]) : _vm._e(), _vm.showBackToHome ? _c('router-link', {
    staticClass: "vis-identity-error__back-to-home vis-identity-link",
    attrs: {
      "to": {
        name: _vm.$visIdentity.routePaths.homeName
      }
    }
  }, [_vm._v(_vm._s(_vm.backToHomeText))]) : _vm._e()], 1);
};
var vis_default_errorvue_type_template_id_7394da55_staticRenderFns = [];

// CONCATENATED MODULE: ./src/lib/components/vis-default-error.vue?vue&type=template&id=7394da55&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c32f5738-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/components/vis-error-icon.vue?vue&type=template&id=2ff11064&functional=true&
var vis_error_iconvue_type_template_id_2ff11064_functional_true_render = function render(_c, _vm) {
  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 576 512",
      "fill": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "d": "M270.2 160h35.5c3.4 0 6.1 2.8 6 6.2l-7.5 196c-.1 3.2-2.8 5.8-6 5.8h-20.5c-3.2 0-5.9-2.5-6-5.8l-7.5-196c-.1-3.4 2.6-6.2 6-6.2zM288 388c-15.5 0-28 12.5-28 28s12.5 28 28 28 28-12.5 28-28-12.5-28-28-28zm281.5 52L329.6 24c-18.4-32-64.7-32-83.2 0L6.5 440c-18.4 31.9 4.6 72 41.6 72H528c36.8 0 60-40 41.5-72zM528 480H48c-12.3 0-20-13.3-13.9-24l240-416c6.1-10.6 21.6-10.7 27.7 0l240 416c6.2 10.6-1.5 24-13.8 24z"
    }
  })]);
};
var vis_error_iconvue_type_template_id_2ff11064_functional_true_staticRenderFns = [];

// CONCATENATED MODULE: ./src/lib/components/vis-error-icon.vue?vue&type=template&id=2ff11064&functional=true&

// CONCATENATED MODULE: ./src/lib/components/vis-error-icon.vue

var script = {}


/* normalize component */

var vis_error_icon_component = normalizeComponent(
  script,
  vis_error_iconvue_type_template_id_2ff11064_functional_true_render,
  vis_error_iconvue_type_template_id_2ff11064_functional_true_staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* harmony default export */ var vis_error_icon = (vis_error_icon_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/components/vis-default-error.vue?vue&type=script&lang=js&


/* harmony default export */ var vis_default_errorvue_type_script_lang_js_ = ({
  name: "vis-default-error",
  components: {
    VisErrorIcon: vis_error_icon
  },
  props: {
    size: {
      type: String,
      default: "md",
      validator: prop_array_validator(["sm", "md", "lg"])
    },
    showRepeatBtn: {
      type: Boolean,
      default: false
    },
    showBackToHome: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    sizeClass: function sizeClass() {
      switch (this.size) {
        case "lg":
          return "vis-identity-error__icon--lg";
        case "sm":
          return "vis-identity-error__icon--sm";
        default:
          return "vis-identity-error__icon--md";
      }
    },
    hasDefaultSlot: function hasDefaultSlot() {
      return !!this.$slots.default;
    },
    repeatButtonTitle: function repeatButtonTitle() {
      return this.$visIdentity.getMessage("repeatBtn");
    },
    backToHomeText: function backToHomeText() {
      return this.$visIdentity.getMessage("backToHome");
    }
  },
  methods: {
    onRepeat: function onRepeat() {
      this.$emit("repeat");
    }
  }
});
// CONCATENATED MODULE: ./src/lib/components/vis-default-error.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_vis_default_errorvue_type_script_lang_js_ = (vis_default_errorvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/lib/components/vis-default-error.vue





/* normalize component */

var vis_default_error_component = normalizeComponent(
  components_vis_default_errorvue_type_script_lang_js_,
  vis_default_errorvue_type_template_id_7394da55_render,
  vis_default_errorvue_type_template_id_7394da55_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var vis_default_error = (vis_default_error_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/components/vis-error.vue?vue&type=script&lang=js&


var vis_errorvue_type_script_lang_js_defaultComponentName = "vis-default-error";
/* harmony default export */ var vis_errorvue_type_script_lang_js_ = ({
  name: "vis-error",
  components: {
    VisDefaultError: vis_default_error
  },
  props: {
    size: {
      type: String,
      default: null
    },
    showRepeatBtn: {
      type: Boolean,
      default: false
    },
    showBackToHome: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    componentName: function componentName() {
      return this.isCustomComponent ? overrideComponentNames.error.kebabCase : vis_errorvue_type_script_lang_js_defaultComponentName;
    },
    isCustomComponent: function isCustomComponent() {
      return !!(this.$options.components[overrideComponentNames.error.camelCase] || this.$options.components[overrideComponentNames.error.kebabCase]);
    }
  }
});
// CONCATENATED MODULE: ./src/lib/components/vis-error.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_vis_errorvue_type_script_lang_js_ = (vis_errorvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/lib/components/vis-error.vue





/* normalize component */

var vis_error_component = normalizeComponent(
  components_vis_errorvue_type_script_lang_js_,
  vis_errorvue_type_template_id_57596d4c_render,
  vis_errorvue_type_template_id_57596d4c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var vis_error = (vis_error_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/components/vis-default-signin-page-content.vue?vue&type=script&lang=js&



/* harmony default export */ var vis_default_signin_page_contentvue_type_script_lang_js_ = ({
  name: "vis-default-signin-page-content",
  components: {
    VisSignin: vis_signin,
    VisLoading: vis_loading,
    VisError: vis_error
  }
});
// CONCATENATED MODULE: ./src/lib/components/vis-default-signin-page-content.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_vis_default_signin_page_contentvue_type_script_lang_js_ = (vis_default_signin_page_contentvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/lib/components/vis-default-signin-page-content.vue





/* normalize component */

var vis_default_signin_page_content_component = normalizeComponent(
  components_vis_default_signin_page_contentvue_type_script_lang_js_,
  vis_default_signin_page_contentvue_type_template_id_02cb35f6_render,
  vis_default_signin_page_contentvue_type_template_id_02cb35f6_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var vis_default_signin_page_content = (vis_default_signin_page_content_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/components/vis-signin-page.vue?vue&type=script&lang=js&


var vis_signin_pagevue_type_script_lang_js_defaultComponentName = "vis-default-signin-page-content";
/* harmony default export */ var vis_signin_pagevue_type_script_lang_js_ = ({
  name: "vis-signin-page",
  components: {
    VisDefaultSigninPageContent: vis_default_signin_page_content
  },
  computed: {
    componentName: function componentName() {
      return this.isCustomComponent ? overrideComponentNames.signInPageContent.kebabCase : vis_signin_pagevue_type_script_lang_js_defaultComponentName;
    },
    isCustomComponent: function isCustomComponent() {
      return !!(this.$options.components[overrideComponentNames.signInPageContent.camelCase] || this.$options.components[overrideComponentNames.signInPageContent.kebabCase]);
    }
  }
});
// CONCATENATED MODULE: ./src/lib/components/vis-signin-page.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_vis_signin_pagevue_type_script_lang_js_ = (vis_signin_pagevue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/lib/components/vis-signin-page.vue





/* normalize component */

var vis_signin_page_component = normalizeComponent(
  components_vis_signin_pagevue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var vis_signin_page = (vis_signin_page_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c32f5738-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/components/vis-signin-callback-page.vue?vue&type=template&id=1a69a5c6&
var vis_signin_callback_pagevue_type_template_id_1a69a5c6_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(_vm.componentName, {
    tag: "component"
  });
};
var vis_signin_callback_pagevue_type_template_id_1a69a5c6_staticRenderFns = [];

// CONCATENATED MODULE: ./src/lib/components/vis-signin-callback-page.vue?vue&type=template&id=1a69a5c6&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c32f5738-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/components/vis-default-signin-callback-page-content.vue?vue&type=template&id=2c893c7f&
var vis_default_signin_callback_page_contentvue_type_template_id_2c893c7f_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('vis-signin-callback', {
    staticClass: "vis-identity-page",
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var loading = _ref.loading,
          message = _ref.message;
        return [loading ? _c('vis-loading', {
          attrs: {
            "size": "lg"
          }
        }, [_vm._v(_vm._s(message))]) : _vm._e()];
      }
    }])
  });
};
var vis_default_signin_callback_page_contentvue_type_template_id_2c893c7f_staticRenderFns = [];

// CONCATENATED MODULE: ./src/lib/components/vis-default-signin-callback-page-content.vue?vue&type=template&id=2c893c7f&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c32f5738-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/components/vis-signin-callback.vue?vue&type=template&id=4d7afb72&
var vis_signin_callbackvue_type_template_id_4d7afb72_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_vm._t("default", null, {
    "loading": _vm.loading,
    "message": _vm.message
  })], 2);
};
var vis_signin_callbackvue_type_template_id_4d7afb72_staticRenderFns = [];

// CONCATENATED MODULE: ./src/lib/components/vis-signin-callback.vue?vue&type=template&id=4d7afb72&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/components/vis-signin-callback.vue?vue&type=script&lang=js&







/* harmony default export */ var vis_signin_callbackvue_type_script_lang_js_ = ({
  name: "vis-signin-callback",
  data: function data() {
    return {
      loading: true
    };
  },
  computed: {
    message: function message() {
      return this.$visIdentity.getMessage("signInCallbackLoading");
    }
  },
  created: function created() {
    this.signInCallback();
  },
  methods: {
    signInCallback: function signInCallback() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var result, returnPath;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return auth_service.signInCallback();
              case 3:
                result = _context.sent;
                auth_service.clearStaleState();
                returnPath = result && result.state ? result.state : null;
                if (returnPath) {
                  _this.$router.push({
                    path: returnPath
                  });
                } else {
                  _this.$visIdentity.navigateToHome(_this.$router);
                }
                _context.next = 24;
                break;
              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](0);
                utils_logger.error(_context.t0);
                _context.prev = 12;
                _context.next = 15;
                return auth_service.signInSilent();
              case 15:
                _this.$visIdentity.navigateToHome(_this.$router);
                _context.next = 24;
                break;
              case 18:
                _context.prev = 18;
                _context.t1 = _context["catch"](12);
                utils_logger.error(_context.t1);
                if (!_this.tryHandleError(_context.t1)) {
                  _context.next = 23;
                  break;
                }
                return _context.abrupt("return");
              case 23:
                if (_this.$visIdentity.redirectToSignInOnError) {
                  _this.$visIdentity.navigateToSignIn(_this.$router);
                } else {
                  _this.$visIdentity.navigateToSignInError(_this.$router);
                }
              case 24:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 9], [12, 18]]);
      }))();
    },
    tryHandleError: function tryHandleError(err) {
      if (!err || typeof err.message !== "string") {
        return false;
      }
      if (jwtTimeErrors.some(function (terr) {
        return err.message.indexOf(terr) !== -1;
      })) {
        this.$visIdentity.navigateToSignInError(this.$router, "local-time");
        return true;
      } else if (err.message === "login_required" || err.message === "consent_required" || err.message === "interaction_required" || err.message === "account_selection_required") {
        this.$visIdentity.authService.removeUser();
        this.$visIdentity.navigateToSignInError(this.$router, err.message);
        return true;
      }
      return false;
    }
  }
});
// CONCATENATED MODULE: ./src/lib/components/vis-signin-callback.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_vis_signin_callbackvue_type_script_lang_js_ = (vis_signin_callbackvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/lib/components/vis-signin-callback.vue





/* normalize component */

var vis_signin_callback_component = normalizeComponent(
  components_vis_signin_callbackvue_type_script_lang_js_,
  vis_signin_callbackvue_type_template_id_4d7afb72_render,
  vis_signin_callbackvue_type_template_id_4d7afb72_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var vis_signin_callback = (vis_signin_callback_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/components/vis-default-signin-callback-page-content.vue?vue&type=script&lang=js&


/* harmony default export */ var vis_default_signin_callback_page_contentvue_type_script_lang_js_ = ({
  name: "vis-default-signin-callback-page-content",
  components: {
    VisSigninCallback: vis_signin_callback,
    VisLoading: vis_loading
  }
});
// CONCATENATED MODULE: ./src/lib/components/vis-default-signin-callback-page-content.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_vis_default_signin_callback_page_contentvue_type_script_lang_js_ = (vis_default_signin_callback_page_contentvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/lib/components/vis-default-signin-callback-page-content.vue





/* normalize component */

var vis_default_signin_callback_page_content_component = normalizeComponent(
  components_vis_default_signin_callback_page_contentvue_type_script_lang_js_,
  vis_default_signin_callback_page_contentvue_type_template_id_2c893c7f_render,
  vis_default_signin_callback_page_contentvue_type_template_id_2c893c7f_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var vis_default_signin_callback_page_content = (vis_default_signin_callback_page_content_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/components/vis-signin-callback-page.vue?vue&type=script&lang=js&


var vis_signin_callback_pagevue_type_script_lang_js_defaultComponentName = "vis-default-signin-callback-page-content";
/* harmony default export */ var vis_signin_callback_pagevue_type_script_lang_js_ = ({
  name: "vis-signin-callback-page",
  components: {
    VisDefaultSigninCallbackPageContent: vis_default_signin_callback_page_content
  },
  computed: {
    componentName: function componentName() {
      return this.isCustomComponent ? overrideComponentNames.signInCallbackPageContent.kebabCase : vis_signin_callback_pagevue_type_script_lang_js_defaultComponentName;
    },
    isCustomComponent: function isCustomComponent() {
      return !!(this.$options.components[overrideComponentNames.signInCallbackPageContent.camelCase] || this.$options.components[overrideComponentNames.signInCallbackPageContent.kebabCase]);
    }
  }
});
// CONCATENATED MODULE: ./src/lib/components/vis-signin-callback-page.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_vis_signin_callback_pagevue_type_script_lang_js_ = (vis_signin_callback_pagevue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/lib/components/vis-signin-callback-page.vue





/* normalize component */

var vis_signin_callback_page_component = normalizeComponent(
  components_vis_signin_callback_pagevue_type_script_lang_js_,
  vis_signin_callback_pagevue_type_template_id_1a69a5c6_render,
  vis_signin_callback_pagevue_type_template_id_1a69a5c6_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var vis_signin_callback_page = (vis_signin_callback_page_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c32f5738-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/components/vis-signout-callback-page.vue?vue&type=template&id=59ee3b5a&
var vis_signout_callback_pagevue_type_template_id_59ee3b5a_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(_vm.componentName, {
    tag: "component"
  });
};
var vis_signout_callback_pagevue_type_template_id_59ee3b5a_staticRenderFns = [];

// CONCATENATED MODULE: ./src/lib/components/vis-signout-callback-page.vue?vue&type=template&id=59ee3b5a&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c32f5738-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/components/vis-default-signout-callback-page-content.vue?vue&type=template&id=23f0be00&
var vis_default_signout_callback_page_contentvue_type_template_id_23f0be00_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('vis-signout-callback', {
    staticClass: "vis-identity-page",
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var loading = _ref.loading,
          message = _ref.message;
        return [loading ? _c('vis-loading', {
          attrs: {
            "size": "lg"
          }
        }, [_vm._v(_vm._s(message))]) : _vm._e()];
      }
    }])
  });
};
var vis_default_signout_callback_page_contentvue_type_template_id_23f0be00_staticRenderFns = [];

// CONCATENATED MODULE: ./src/lib/components/vis-default-signout-callback-page-content.vue?vue&type=template&id=23f0be00&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c32f5738-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/components/vis-signout-callback.vue?vue&type=template&id=d8ffbd48&
var vis_signout_callbackvue_type_template_id_d8ffbd48_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_vm._t("default", null, {
    "loading": _vm.loading,
    "message": _vm.message
  })], 2);
};
var vis_signout_callbackvue_type_template_id_d8ffbd48_staticRenderFns = [];

// CONCATENATED MODULE: ./src/lib/components/vis-signout-callback.vue?vue&type=template&id=d8ffbd48&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/components/vis-signout-callback.vue?vue&type=script&lang=js&




/* harmony default export */ var vis_signout_callbackvue_type_script_lang_js_ = ({
  name: "vis-signout-callback",
  data: function data() {
    return {
      loading: true
    };
  },
  computed: {
    message: function message() {
      return this.$visIdentity.getMessage("signOutCallbackLoading");
    }
  },
  created: function created() {
    this.signOutCallback();
  },
  methods: {
    signOutCallback: function signOutCallback() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return auth_service.signOutCallback();
              case 3:
                _this.$visIdentity.navigateToHome(_this.$router);
                _context.next = 10;
                break;
              case 6:
                _context.prev = 6;
                _context.t0 = _context["catch"](0);
                utils_logger.error(_context.t0);
                _this.$visIdentity.navigateToHome(_this.$router);
              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 6]]);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./src/lib/components/vis-signout-callback.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_vis_signout_callbackvue_type_script_lang_js_ = (vis_signout_callbackvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/lib/components/vis-signout-callback.vue





/* normalize component */

var vis_signout_callback_component = normalizeComponent(
  components_vis_signout_callbackvue_type_script_lang_js_,
  vis_signout_callbackvue_type_template_id_d8ffbd48_render,
  vis_signout_callbackvue_type_template_id_d8ffbd48_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var vis_signout_callback = (vis_signout_callback_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/components/vis-default-signout-callback-page-content.vue?vue&type=script&lang=js&


/* harmony default export */ var vis_default_signout_callback_page_contentvue_type_script_lang_js_ = ({
  name: "vis-default-signout-callback-page-content",
  components: {
    VisSignoutCallback: vis_signout_callback,
    VisLoading: vis_loading
  }
});
// CONCATENATED MODULE: ./src/lib/components/vis-default-signout-callback-page-content.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_vis_default_signout_callback_page_contentvue_type_script_lang_js_ = (vis_default_signout_callback_page_contentvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/lib/components/vis-default-signout-callback-page-content.vue





/* normalize component */

var vis_default_signout_callback_page_content_component = normalizeComponent(
  components_vis_default_signout_callback_page_contentvue_type_script_lang_js_,
  vis_default_signout_callback_page_contentvue_type_template_id_23f0be00_render,
  vis_default_signout_callback_page_contentvue_type_template_id_23f0be00_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var vis_default_signout_callback_page_content = (vis_default_signout_callback_page_content_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/components/vis-signout-callback-page.vue?vue&type=script&lang=js&


var vis_signout_callback_pagevue_type_script_lang_js_defaultComponentName = "vis-default-signout-callback-page-content";
/* harmony default export */ var vis_signout_callback_pagevue_type_script_lang_js_ = ({
  name: "vis-signout-callback-page",
  components: {
    VisDefaultSignoutCallbackPageContent: vis_default_signout_callback_page_content
  },
  computed: {
    componentName: function componentName() {
      return this.isCustomComponent ? overrideComponentNames.signOutCallbackPageContent.kebabCase : vis_signout_callback_pagevue_type_script_lang_js_defaultComponentName;
    },
    isCustomComponent: function isCustomComponent() {
      return !!(this.$options.components[overrideComponentNames.signOutCallbackPageContent.camelCase] || this.$options.components[overrideComponentNames.signOutCallbackPageContent.kebabCase]);
    }
  }
});
// CONCATENATED MODULE: ./src/lib/components/vis-signout-callback-page.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_vis_signout_callback_pagevue_type_script_lang_js_ = (vis_signout_callback_pagevue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/lib/components/vis-signout-callback-page.vue





/* normalize component */

var vis_signout_callback_page_component = normalizeComponent(
  components_vis_signout_callback_pagevue_type_script_lang_js_,
  vis_signout_callback_pagevue_type_template_id_59ee3b5a_render,
  vis_signout_callback_pagevue_type_template_id_59ee3b5a_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var vis_signout_callback_page = (vis_signout_callback_page_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c32f5738-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/components/vis-signout-page.vue?vue&type=template&id=66ca879c&
var vis_signout_pagevue_type_template_id_66ca879c_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(_vm.componentName, {
    tag: "component"
  });
};
var vis_signout_pagevue_type_template_id_66ca879c_staticRenderFns = [];

// CONCATENATED MODULE: ./src/lib/components/vis-signout-page.vue?vue&type=template&id=66ca879c&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c32f5738-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/components/vis-default-signout-page-content.vue?vue&type=template&id=3a7750d9&
var vis_default_signout_page_contentvue_type_template_id_3a7750d9_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('vis-signout', {
    staticClass: "vis-identity-page",
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var loading = _ref.loading,
          error = _ref.error,
          message = _ref.message,
          onRepeat = _ref.onRepeat;
        return [loading ? _c('vis-loading', {
          attrs: {
            "size": "lg"
          }
        }, [_vm._v(_vm._s(message))]) : error ? _c('vis-error', {
          attrs: {
            "size": "lg",
            "show-repeat-btn": _vm.$visIdentity.showRepeatBtnOnError,
            "show-back-to-home": _vm.$visIdentity.showBackToHomeOnError
          },
          on: {
            "repeat": onRepeat
          }
        }, [_vm._v(_vm._s(message))]) : _vm._e()];
      }
    }])
  });
};
var vis_default_signout_page_contentvue_type_template_id_3a7750d9_staticRenderFns = [];

// CONCATENATED MODULE: ./src/lib/components/vis-default-signout-page-content.vue?vue&type=template&id=3a7750d9&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c32f5738-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/components/vis-signout.vue?vue&type=template&id=5ca22d2c&
var vis_signoutvue_type_template_id_5ca22d2c_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_vm._t("default", null, {
    "loading": _vm.loading,
    "error": _vm.error,
    "message": _vm.message,
    "onRepeat": _vm.onRepeat
  })], 2);
};
var vis_signoutvue_type_template_id_5ca22d2c_staticRenderFns = [];

// CONCATENATED MODULE: ./src/lib/components/vis-signout.vue?vue&type=template&id=5ca22d2c&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/components/vis-signout.vue?vue&type=script&lang=js&




/* harmony default export */ var vis_signoutvue_type_script_lang_js_ = ({
  name: "vis-signout",
  created: function created() {
    this.signOut();
  },
  data: function data() {
    return {
      loading: true,
      error: false
    };
  },
  computed: {
    message: function message() {
      if (this.loading) {
        return this.$visIdentity.getMessage("signOutLoading");
      } else if (this.error) {
        return this.$visIdentity.getMessage("signOutError");
      } else {
        return null;
      }
    }
  },
  methods: {
    signOut: function signOut() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _this.loading = true;
                _this.error = false;
                if (!_this.$visIdentity.useSignOutIframe) {
                  _context.next = 9;
                  break;
                }
                _context.next = 6;
                return auth_service.signOutIframe();
              case 6:
                _this.$visIdentity.navigateToHome(_this.$router);
                _context.next = 11;
                break;
              case 9:
                _context.next = 11;
                return auth_service.signOutRedirect(_this.$visIdentity.showLogoutPrompt);
              case 11:
                _context.next = 18;
                break;
              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](0);
                utils_logger.error(_context.t0);
                _this.loading = false;
                _this.error = true;
              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 13]]);
      }))();
    },
    onRepeat: function onRepeat() {
      this.signOut();
    }
  }
});
// CONCATENATED MODULE: ./src/lib/components/vis-signout.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_vis_signoutvue_type_script_lang_js_ = (vis_signoutvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/lib/components/vis-signout.vue





/* normalize component */

var vis_signout_component = normalizeComponent(
  components_vis_signoutvue_type_script_lang_js_,
  vis_signoutvue_type_template_id_5ca22d2c_render,
  vis_signoutvue_type_template_id_5ca22d2c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var vis_signout = (vis_signout_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/components/vis-default-signout-page-content.vue?vue&type=script&lang=js&



/* harmony default export */ var vis_default_signout_page_contentvue_type_script_lang_js_ = ({
  name: "vis-default-signout-page-content",
  components: {
    VisSignout: vis_signout,
    VisLoading: vis_loading,
    VisError: vis_error
  }
});
// CONCATENATED MODULE: ./src/lib/components/vis-default-signout-page-content.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_vis_default_signout_page_contentvue_type_script_lang_js_ = (vis_default_signout_page_contentvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/lib/components/vis-default-signout-page-content.vue





/* normalize component */

var vis_default_signout_page_content_component = normalizeComponent(
  components_vis_default_signout_page_contentvue_type_script_lang_js_,
  vis_default_signout_page_contentvue_type_template_id_3a7750d9_render,
  vis_default_signout_page_contentvue_type_template_id_3a7750d9_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var vis_default_signout_page_content = (vis_default_signout_page_content_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/components/vis-signout-page.vue?vue&type=script&lang=js&


var vis_signout_pagevue_type_script_lang_js_defaultComponentName = "vis-default-signout-page-content";
/* harmony default export */ var vis_signout_pagevue_type_script_lang_js_ = ({
  name: "vis-signout-page",
  components: {
    VisDefaultSignoutPageContent: vis_default_signout_page_content
  },
  computed: {
    componentName: function componentName() {
      return this.isCustomComponent ? overrideComponentNames.signOutPageContent.kebabCase : vis_signout_pagevue_type_script_lang_js_defaultComponentName;
    },
    isCustomComponent: function isCustomComponent() {
      return !!(this.$options.components[overrideComponentNames.signOutPageContent.camelCase] || this.$options.components[overrideComponentNames.signOutPageContent.kebabCase]);
    }
  }
});
// CONCATENATED MODULE: ./src/lib/components/vis-signout-page.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_vis_signout_pagevue_type_script_lang_js_ = (vis_signout_pagevue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/lib/components/vis-signout-page.vue





/* normalize component */

var vis_signout_page_component = normalizeComponent(
  components_vis_signout_pagevue_type_script_lang_js_,
  vis_signout_pagevue_type_template_id_66ca879c_render,
  vis_signout_pagevue_type_template_id_66ca879c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var vis_signout_page = (vis_signout_page_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c32f5738-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/components/vis-signin-error-page.vue?vue&type=template&id=71798f83&
var vis_signin_error_pagevue_type_template_id_71798f83_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(_vm.componentName, {
    tag: "component"
  });
};
var vis_signin_error_pagevue_type_template_id_71798f83_staticRenderFns = [];

// CONCATENATED MODULE: ./src/lib/components/vis-signin-error-page.vue?vue&type=template&id=71798f83&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c32f5738-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/components/vis-default-signin-error-page-content.vue?vue&type=template&id=65fdc1cd&


var vis_default_signin_error_page_contentvue_type_template_id_65fdc1cd_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "vis-identity-page"
  }, [_c('div', [_c('vis-error', {
    attrs: {
      "size": "lg",
      "show-repeat-btn": _vm.$visIdentity.showRepeatBtnOnError,
      "show-back-to-home": _vm.$visIdentity.showBackToHomeOnError
    },
    on: {
      "repeat": _vm.onRepeat
    },
    scopedSlots: _vm._u([_vm.description ? {
      key: "descr",
      fn: function fn() {
        return [_vm._v(_vm._s(_vm.description))];
      },
      proxy: true
    } : null], null, true)
  }, [_vm._v(" " + _vm._s(_vm.message) + " ")])], 1)]);
};
var vis_default_signin_error_page_contentvue_type_template_id_65fdc1cd_staticRenderFns = [];

// CONCATENATED MODULE: ./src/lib/components/vis-default-signin-error-page-content.vue?vue&type=template&id=65fdc1cd&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/components/vis-default-signin-error-page-content.vue?vue&type=script&lang=js&



/* harmony default export */ var vis_default_signin_error_page_contentvue_type_script_lang_js_ = ({
  name: "vis-default-signin-error-page-content",
  components: {
    VisError: vis_error
  },
  data: function data() {
    return {
      signInRoutePath: signInRoutePath,
      signInRouteName: signInRouteName
    };
  },
  computed: {
    message: function message() {
      return this.isSessionEnd ? this.$visIdentity.getMessage("sessionEnd") : this.$visIdentity.getMessage("signInError");
    },
    description: function description() {
      var type = this.$route.query.type;
      var suffix = this.isSessionEnd ? "session-end" : type;
      return type ? this.$visIdentity.getMessage("signInErrorDescr_".concat(suffix)) : null;
    },
    isSessionEnd: function isSessionEnd() {
      var type = this.$route.query.type;
      return type === "login_required" || type === "consent_required" || type === "interaction_required" || type === "account_selection_required";
    }
  },
  methods: {
    onRepeat: function onRepeat() {
      this.$router.push({
        name: this.signInRouteName
      });
    }
  }
});
// CONCATENATED MODULE: ./src/lib/components/vis-default-signin-error-page-content.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_vis_default_signin_error_page_contentvue_type_script_lang_js_ = (vis_default_signin_error_page_contentvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/lib/components/vis-default-signin-error-page-content.vue





/* normalize component */

var vis_default_signin_error_page_content_component = normalizeComponent(
  components_vis_default_signin_error_page_contentvue_type_script_lang_js_,
  vis_default_signin_error_page_contentvue_type_template_id_65fdc1cd_render,
  vis_default_signin_error_page_contentvue_type_template_id_65fdc1cd_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var vis_default_signin_error_page_content = (vis_default_signin_error_page_content_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/components/vis-signin-error-page.vue?vue&type=script&lang=js&


var vis_signin_error_pagevue_type_script_lang_js_defaultComponentName = "vis-default-signin-error-page-content";
/* harmony default export */ var vis_signin_error_pagevue_type_script_lang_js_ = ({
  name: "vis-signin-error-page",
  components: {
    VisDefaultSigninErrorPageContent: vis_default_signin_error_page_content
  },
  computed: {
    componentName: function componentName() {
      return this.isCustomComponent ? overrideComponentNames.signInErrorPageContent.kebabCase : vis_signin_error_pagevue_type_script_lang_js_defaultComponentName;
    },
    isCustomComponent: function isCustomComponent() {
      return !!(this.$options.components[overrideComponentNames.signInErrorPageContent.camelCase] || this.$options.components[overrideComponentNames.signInErrorPageContent.kebabCase]);
    }
  }
});
// CONCATENATED MODULE: ./src/lib/components/vis-signin-error-page.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_vis_signin_error_pagevue_type_script_lang_js_ = (vis_signin_error_pagevue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/lib/components/vis-signin-error-page.vue





/* normalize component */

var vis_signin_error_page_component = normalizeComponent(
  components_vis_signin_error_pagevue_type_script_lang_js_,
  vis_signin_error_pagevue_type_template_id_71798f83_render,
  vis_signin_error_pagevue_type_template_id_71798f83_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var vis_signin_error_page = (vis_signin_error_page_component.exports);
// CONCATENATED MODULE: ./src/lib/utils/merge-route-paths.js


/* harmony default export */ var merge_route_paths = (function (routePaths) {
  return _objectSpread2(_objectSpread2({}, defaultRoutePaths), routePaths);
});
// CONCATENATED MODULE: ./src/lib/utils/configure-router.js







var currentRouter = null;
var getCurrentRouter = function getCurrentRouter() {
  return currentRouter;
};
var setCurrentRouter = function setCurrentRouter(router) {
  currentRouter = router;
};
var configure_router_createRoutes = function createRoutes(routePaths) {
  return [{
    path: routePaths.signIn,
    name: routePaths.signInName,
    component: vis_signin_page
  }, {
    path: routePaths.signOut,
    name: routePaths.signOutName,
    component: vis_signout_page
  }, {
    path: routePaths.signInCallback,
    name: routePaths.signInCallbackName,
    component: vis_signin_callback_page
  }, {
    path: routePaths.signOutCallback,
    name: routePaths.signOutCallbackName,
    component: vis_signout_callback_page
  }, {
    path: routePaths.signInError,
    name: routePaths.signInErrorName,
    component: vis_signin_error_page
  }];
};
var configure_router_configureRoutes = function configureRoutes(router, routePaths) {
  var mergedRoutePaths = merge_route_paths(routePaths);
  router.addRoutes(configure_router_createRoutes(mergedRoutePaths));
};
var configure_router_configureSecurityRouter = function configureSecurityRouter(router, routePaths) {
  var redirectToUnauthorizedRoute = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var mergedRoutePaths = merge_route_paths(routePaths);
  security_router.use(router, {
    signInRouteName: redirectToUnauthorizedRoute ? null : mergedRoutePaths.signInName,
    unauthorizedRouteName: mergedRoutePaths.unauthorizedName
  });
};
var configureRouteCheckAuth = function configureRouteCheckAuth(router) {
  router.afterEach(function (to, from) {
    if (router.app && router.app.$visIdentity) {
      router.app.$visIdentity.checkAuth();
    }
  });
};
/* harmony default export */ var configure_router = (function (router, routePaths) {
  var routeCheckAuth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var redirectToUnauthorizedRoute = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  setCurrentRouter(router);
  configure_router_configureRoutes(router, routePaths);
  configure_router_configureSecurityRouter(router, routePaths, redirectToUnauthorizedRoute);
  if (routeCheckAuth) {
    configureRouteCheckAuth(router);
  }
});
// CONCATENATED MODULE: ./src/lib/utils/messages.ru.js
/* harmony default export */ var messages_ru = ({
  signInLoading: "Выполняется вход пользователя…",
  signInError: "Ошибка при входе пользователя",
  signInCallbackLoading: "Ожидание входа…",
  signOutLoading: "Выполняется выход пользователя…",
  signOutError: "Ошибка при выходе пользователя",
  signOutCallbackLoading: "Выполняется выход пользователя…",
  sessionEnd: "Сессия завершена",
  modalCloseButton: "Закрыть",
  sessionExpiredDialogTitle: "Сессия истекла",
  sessionExpiredFormLoading: "Ожидание входа…",
  sessionExpiredFormOutLoading: "Выполняется выход пользователя…",
  sessionExpiredFormError: "Ошибка входа. Попробуйте еще раз.",
  sessionExpiredFormOutError: "Ошибка выхода. Попробуйте еще раз.",
  sessionExpiredFormText: "Время сеанса истекло. Пожалуйста, войдите снова.",
  sessionExpiredFormSignInBtn: "Войти",
  sessionExpiredFormSignOutBtn: "Выйти",
  signInErrorRepeatBtn: "Повторить вход",
  repeatBtn: "Повторить вход",
  backToHome: "Вернуться на главную",
  "signInErrorDescr_local-time": "Ваше локальное время отличается от времени сервера авторизации. Установите правильное локальное время на Вашем устройстве и повторите попытку входа еще раз.",
  "signInErrorDescr_session-end": "Ваша сессия завершена. Повторите попытку входа еще раз."
});
// CONCATENATED MODULE: ./src/lib/utils/messages.en.js
/* harmony default export */ var messages_en = ({
  signInLoading: "User is logged in…",
  signInError: "User login error",
  signInCallbackLoading: "Waiting login…",
  signOutLoading: "User is logged out…",
  signOutError: "User logout error",
  signOutCallbackLoading: "User is logged out…",
  sessionEnd: "Session ended",
  modalCloseButton: "Close",
  sessionExpiredDialogTitle: "Session expired",
  sessionExpiredFormLoading: "Waiting login…",
  sessionExpiredFormOutLoading: "User is logged out…",
  sessionExpiredFormError: "Login failed. Try again.",
  sessionExpiredFormOutError: "Logout failed. Try again.",
  sessionExpiredFormText: "The session has timed out. Please login again.",
  sessionExpiredFormSignInBtn: "Log In",
  sessionExpiredFormSignOutBtn: "Log Out",
  signInErrorRepeatBtn: "Repeat login",
  repeatBtn: "Repeat login",
  backToHome: "Back to home",
  "signInErrorDescr_local-time": "Your local time is different from the time of the authorization server. Set the correct local time on your device and try logging in again.",
  "signInErrorDescr_session-end": "Your session has ended. Please try to logging in again."
});
// CONCATENATED MODULE: ./src/lib/utils/messages.js


/* harmony default export */ var utils_messages = ({
  ru: messages_ru,
  en: messages_en
});
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
// CONCATENATED MODULE: ./src/lib/utils/signin-delegate.js







var signin_delegate_SignInDelegate = /*#__PURE__*/function () {
  function SignInDelegate(showDialog) {
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
    _classCallCheck(this, SignInDelegate);
    this.showDialog = showDialog;
    this.authReady = null;
    this.callback = callback;
    this.setup();
  }
  _createClass(SignInDelegate, [{
    key: "setup",
    value: function setup() {
      auth_interceptor.setFetchAndSaveTokensDelegate(this.authDelegate.bind(this));
    }
  }, {
    key: "destroy",
    value: function destroy() {
      auth_interceptor.setFetchAndSaveTokensDelegate(null);
      this.showDialog = null;
      this.authReady = null;
    }
  }, {
    key: "authDelegate",
    value: function authDelegate() {
      if (!this.authReady) {
        this.authReady = this.auth();
      }
      return this.authReady;
    }
  }, {
    key: "auth",
    value: function () {
      var _auth = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return auth_service.signInSilent();
              case 3:
                this.callback(null);
                _context.next = 20;
                break;
              case 6:
                _context.prev = 6;
                _context.t0 = _context["catch"](0);
                utils_logger.error(_context.t0.message);
                _context.prev = 9;
                _context.next = 12;
                return this.showDialog();
              case 12:
                this.callback(null);
                _context.next = 20;
                break;
              case 15:
                _context.prev = 15;
                _context.t1 = _context["catch"](9);
                utils_logger.error(_context.t1.message);
                this.callback(_context.t1);
                throw _context.t1;
              case 20:
                _context.prev = 20;
                this.clear();
                return _context.finish(20);
              case 23:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 6, 20, 23], [9, 15]]);
      }));
      function auth() {
        return _auth.apply(this, arguments);
      }
      return auth;
    }()
  }, {
    key: "clear",
    value: function clear() {
      this.authReady = null;
    }
  }]);
  return SignInDelegate;
}();
var signin_delegate_configure = function configure(showDialog, callback) {
  return new signin_delegate_SignInDelegate(showDialog, callback);
};
/* harmony default export */ var signin_delegate = (signin_delegate_configure);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c32f5738-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/components/vis-dialogs.vue?vue&type=template&id=30bb1133&
var vis_dialogsvue_type_template_id_30bb1133_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(_vm.componentName, {
    tag: "component",
    model: {
      value: _vm.$visIdentity.sessionExpiredDialogShown,
      callback: function callback($$v) {
        _vm.$set(_vm.$visIdentity, "sessionExpiredDialogShown", $$v);
      },
      expression: "$visIdentity.sessionExpiredDialogShown"
    }
  });
};
var vis_dialogsvue_type_template_id_30bb1133_staticRenderFns = [];

// CONCATENATED MODULE: ./src/lib/components/vis-dialogs.vue?vue&type=template&id=30bb1133&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c32f5738-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/components/vis-default-session-expired-dialog.vue?vue&type=template&id=7f5eb750&
var vis_default_session_expired_dialogvue_type_template_id_7f5eb750_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('vis-modal', {
    attrs: {
      "no-close-on-backdrop": "",
      "hide-close-button": ""
    },
    on: {
      "close": _vm.onClose
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function fn() {
        return [_vm._v(_vm._s(_vm.title))];
      },
      proxy: true
    }]),
    model: {
      value: _vm.showModal,
      callback: function callback($$v) {
        _vm.showModal = $$v;
      },
      expression: "showModal"
    }
  }, [_c('vis-session-expired-form', {
    on: {
      "ok": _vm.onOk,
      "cancel": _vm.onCancel
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var signInLoading = _ref.signInLoading,
          signInError = _ref.signInError,
          signOutLoading = _ref.signOutLoading,
          signOutError = _ref.signOutError,
          messages = _ref.messages,
          signInCallback = _ref.signInCallback,
          signOutCallback = _ref.signOutCallback;
        return [_c(_vm.componentName, {
          tag: "component",
          attrs: {
            "sign-in-loading": signInLoading,
            "sign-in-error": signInError,
            "sign-out-loading": signOutLoading,
            "sign-out-error": signOutError,
            "sign-in-callback": signInCallback,
            "sign-out-callback": signOutCallback,
            "messages": messages
          }
        })];
      }
    }])
  })], 1);
};
var vis_default_session_expired_dialogvue_type_template_id_7f5eb750_staticRenderFns = [];

// CONCATENATED MODULE: ./src/lib/components/vis-default-session-expired-dialog.vue?vue&type=template&id=7f5eb750&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c32f5738-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/components/vis-modal.vue?vue&type=template&id=10719278&
var vis_modalvue_type_template_id_10719278_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(_vm.componentName, _vm._b({
    tag: "component",
    on: {
      "input": _vm.onInput
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function fn() {
        return [_vm._t("title")];
      },
      proxy: true
    }, {
      key: "default",
      fn: function fn() {
        return [_vm._t("default")];
      },
      proxy: true
    }], null, true)
  }, 'component', _vm.$props, false));
};
var vis_modalvue_type_template_id_10719278_staticRenderFns = [];

// CONCATENATED MODULE: ./src/lib/components/vis-modal.vue?vue&type=template&id=10719278&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c32f5738-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/components/vis-default-modal.vue?vue&type=template&id=2ddf8854&
var vis_default_modalvue_type_template_id_2ddf8854_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.visible ? _c('div', {
    staticClass: "vis-identity-modal"
  }, [_c('div', {
    ref: "wrapper",
    staticClass: "vis-identity-modal__wrap",
    on: {
      "click": _vm.onClickWrap
    }
  }, [_c('div', {
    staticClass: "vis-identity-modal__body"
  }, [_c('header', {
    staticClass: "vis-identity-modal__header"
  }, [_c('span', [_vm._t("title")], 2), !_vm.hideCloseButton ? _c('span', {
    staticClass: "vis-identity-modal__close-icon",
    attrs: {
      "title": _vm.closeButtonTitle
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.onClose.apply(null, arguments);
      }
    }
  }, [_c('vis-times-icon')], 1) : _vm._e()]), _c('div', {
    staticClass: "vis-identity-modal__content"
  }, [_vm._t("default")], 2)])]), _c('div', {
    staticClass: "vis-identity-modal__backdrop",
    on: {
      "click": _vm.onClickBackdrop
    }
  })]) : _vm._e();
};
var vis_default_modalvue_type_template_id_2ddf8854_staticRenderFns = [];

// CONCATENATED MODULE: ./src/lib/components/vis-default-modal.vue?vue&type=template&id=2ddf8854&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c32f5738-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/components/vis-times-icon.vue?vue&type=template&id=59c0b87f&functional=true&
var vis_times_iconvue_type_template_id_59c0b87f_functional_true_render = function render(_c, _vm) {
  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 320 512",
      "fill": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "d": "M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z"
    }
  })]);
};
var vis_times_iconvue_type_template_id_59c0b87f_functional_true_staticRenderFns = [];

// CONCATENATED MODULE: ./src/lib/components/vis-times-icon.vue?vue&type=template&id=59c0b87f&functional=true&

// CONCATENATED MODULE: ./src/lib/components/vis-times-icon.vue

var vis_times_icon_script = {}


/* normalize component */

var vis_times_icon_component = normalizeComponent(
  vis_times_icon_script,
  vis_times_iconvue_type_template_id_59c0b87f_functional_true_render,
  vis_times_iconvue_type_template_id_59c0b87f_functional_true_staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* harmony default export */ var vis_times_icon = (vis_times_icon_component.exports);
// CONCATENATED MODULE: ./src/lib/utils/prevent-scroll-mixin.js
/* harmony default export */ var prevent_scroll_mixin = ({
  methods: {
    addPreventScroll: function addPreventScroll() {
      var body = document.body;
      var overflowY = window.getComputedStyle(body).overflowY;
      if (overflowY !== 'hidden' && (overflowY === 'scroll' || body.scrollHeight > window.innerHeight)) {
        body.classList.add('vis-identity-body--force-scrollbar');
      }
      body.classList.add('vis-identity-body--prevent-scroll');
    },
    removePreventScroll: function removePreventScroll() {
      var body = document.body;
      body.classList.remove('vis-identity-body--prevent-scroll');
      body.classList.remove('vis-identity-body--force-scrollbar');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/components/vis-default-modal.vue?vue&type=script&lang=js&


/* harmony default export */ var vis_default_modalvue_type_script_lang_js_ = ({
  name: "vis-modal",
  components: {
    VisTimesIcon: vis_times_icon
  },
  mixins: [prevent_scroll_mixin],
  model: {
    prop: "visible"
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    noCloseOnBackdrop: {
      type: Boolean,
      default: false
    },
    hideCloseButton: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    closeButtonTitle: function closeButtonTitle() {
      return this.$visIdentity.getMessage("modalCloseButton");
    }
  },
  watch: {
    visible: function visible() {
      if (this.visible) {
        this.addPreventScroll();
      } else {
        this.removePreventScroll();
      }
    }
  },
  mounted: function mounted() {
    document.body.appendChild(this.$el);
  },
  beforeDestroy: function beforeDestroy() {
    if (this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
  },
  methods: {
    onClose: function onClose() {
      this.$emit("input", false);
      this.$emit("close");
    },
    onClickBackdrop: function onClickBackdrop(_ref) {
      var target = _ref.target;
      this.onClose();
    },
    onClickWrap: function onClickWrap(_ref2) {
      var target = _ref2.target;
      if (this.noCloseOnBackdrop) return;
      if (target === this.$refs.wrapper) this.onClose();
    }
  }
});
// CONCATENATED MODULE: ./src/lib/components/vis-default-modal.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_vis_default_modalvue_type_script_lang_js_ = (vis_default_modalvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/lib/components/vis-default-modal.vue





/* normalize component */

var vis_default_modal_component = normalizeComponent(
  components_vis_default_modalvue_type_script_lang_js_,
  vis_default_modalvue_type_template_id_2ddf8854_render,
  vis_default_modalvue_type_template_id_2ddf8854_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var vis_default_modal = (vis_default_modal_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/components/vis-modal.vue?vue&type=script&lang=js&


var vis_modalvue_type_script_lang_js_defaultComponentName = "vis-default-modal";
/* harmony default export */ var vis_modalvue_type_script_lang_js_ = ({
  name: "vis-modal",
  components: {
    VisDefaultModal: vis_default_modal
  },
  model: {
    prop: "visible"
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    noCloseOnBackdrop: {
      type: Boolean,
      default: false
    },
    hideCloseButton: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    componentName: function componentName() {
      return this.isCustomComponent ? overrideComponentNames.modal.kebabCase : vis_modalvue_type_script_lang_js_defaultComponentName;
    },
    isCustomComponent: function isCustomComponent() {
      return !!(this.$options.components[overrideComponentNames.modal.camelCase] || this.$options.components[overrideComponentNames.modal.kebabCase]);
    }
  },
  methods: {
    onInput: function onInput(e) {
      this.$emit("input", e);
    }
  }
});
// CONCATENATED MODULE: ./src/lib/components/vis-modal.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_vis_modalvue_type_script_lang_js_ = (vis_modalvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/lib/components/vis-modal.vue





/* normalize component */

var vis_modal_component = normalizeComponent(
  components_vis_modalvue_type_script_lang_js_,
  vis_modalvue_type_template_id_10719278_render,
  vis_modalvue_type_template_id_10719278_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var vis_modal = (vis_modal_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c32f5738-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/components/vis-session-expired-form.vue?vue&type=template&id=58c10a8e&
var vis_session_expired_formvue_type_template_id_58c10a8e_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_vm._t("default", null, {
    "signInLoading": _vm.signInLoading,
    "signInError": _vm.signInError,
    "signOutLoading": _vm.signOutLoading,
    "signOutError": _vm.signOutError,
    "messages": _vm.messages,
    "signInCallback": _vm.signIn,
    "signOutCallback": _vm.signOut
  })], 2);
};
var vis_session_expired_formvue_type_template_id_58c10a8e_staticRenderFns = [];

// CONCATENATED MODULE: ./src/lib/components/vis-session-expired-form.vue?vue&type=template&id=58c10a8e&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/components/vis-session-expired-form.vue?vue&type=script&lang=js&






/* harmony default export */ var vis_session_expired_formvue_type_script_lang_js_ = ({
  name: "vis-session-expired-form",
  data: function data() {
    return {
      signInLoading: false,
      signInError: false,
      signOutLoading: false,
      signOutError: false
    };
  },
  computed: {
    messages: function messages() {
      return this.$visIdentity.getMessages();
    }
  },
  methods: {
    signIn: function signIn() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var router;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _this.signInLoading = true;
                _this.signInError = false;
                _context.next = 5;
                return auth_service.signInSilent();
              case 5:
                _this.$visIdentity._sessionExpiredDialogOk();
                _this.$emit("ok");
                _context.next = 24;
                break;
              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](0);
                utils_logger.error(_context.t0);
                _context.prev = 12;
                _context.next = 15;
                return auth_service.signInPopup();
              case 15:
                auth_service.clearStaleState();
                _this.$visIdentity._sessionExpiredDialogOk();
                _this.$emit("ok");
                _context.next = 24;
                break;
              case 20:
                _context.prev = 20;
                _context.t1 = _context["catch"](12);
                utils_logger.error(_context.t1);
                if (_this.$visIdentity.redirectToSignInOnDialogError) {
                  router = _this.$visIdentity.currentRouter;
                  if (router && router.currentRoute) {
                    return_path(router.currentRoute.fullPath);
                    _this.$visIdentity.navigateToSignIn(router);
                  }
                  _this.$visIdentity._sessionExpiredDialogFailed(_context.t1);
                  _this.$emit("cancel");
                } else {
                  _this.signInError = true;
                  _this.signInLoading = false;
                }
              case 24:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 9], [12, 20]]);
      }))();
    },
    signOut: function signOut() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var router;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _this2.signOutLoading = true;
                _this2.signOutError = false;
                if (!_this2.$visIdentity.useSignOutIframe) {
                  _context2.next = 12;
                  break;
                }
                _context2.next = 6;
                return auth_service.signOutIframe();
              case 6:
                router = _this2.$visIdentity.currentRouter;
                if (router) {
                  _this2.$visIdentity.navigateToHome(router);
                }
                _this2.$visIdentity._sessionExpiredDialogFailed(new Error("Sign out"));
                _this2.$emit("cancel");
                _context2.next = 14;
                break;
              case 12:
                _context2.next = 14;
                return auth_service.signOutRedirect(_this2.$visIdentity.showLogoutPrompt);
              case 14:
                _context2.next = 21;
                break;
              case 16:
                _context2.prev = 16;
                _context2.t0 = _context2["catch"](0);
                utils_logger.error(_context2.t0);
                _this2.signOutLoading = false;
                _this2.signOutError = true;
              case 21:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 16]]);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./src/lib/components/vis-session-expired-form.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_vis_session_expired_formvue_type_script_lang_js_ = (vis_session_expired_formvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/lib/components/vis-session-expired-form.vue





/* normalize component */

var vis_session_expired_form_component = normalizeComponent(
  components_vis_session_expired_formvue_type_script_lang_js_,
  vis_session_expired_formvue_type_template_id_58c10a8e_render,
  vis_session_expired_formvue_type_template_id_58c10a8e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var vis_session_expired_form = (vis_session_expired_form_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c32f5738-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/components/vis-default-session-expired-form-content.vue?vue&type=template&id=79b106b2&
var vis_default_session_expired_form_contentvue_type_template_id_79b106b2_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.signInLoading || _vm.signOutLoading ? _c('div', {
    staticClass: "vis-identity-session-expired-form__loading"
  }, [_c('vis-loading', {
    attrs: {
      "size": "lg"
    }
  }, [_vm._v(_vm._s(_vm.signInLoading ? _vm.messages["sessionExpiredFormLoading"] : _vm.messages["sessionExpiredFormOutLoading"]))])], 1) : _c('div', {
    staticClass: "vis-identity-session-expired-form__content"
  }, [_vm.signInError || _vm.signOutError ? _c('div', {
    staticClass: "vis-identity-session-expired-form__error"
  }, [_c('vis-error', {
    attrs: {
      "size": "lg"
    }
  }, [_vm._v(_vm._s(_vm.signInError ? _vm.messages["sessionExpiredFormError"] : _vm.messages["sessionExpiredFormOutError"]))])], 1) : _c('div', {
    staticClass: "vis-identity-session-expired-form__text"
  }, [_vm._v(_vm._s(_vm.messages["sessionExpiredFormText"]))]), _c('div', {
    staticClass: "vis-identity-session-expired-form__buttons"
  }, [_c('button', {
    staticClass: "vis-identity-button vis-identity-button--primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.signInCallback.apply(null, arguments);
      }
    }
  }, [_vm._v(_vm._s(_vm.messages['sessionExpiredFormSignInBtn']))]), _c('button', {
    staticClass: "vis-identity-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.signOutCallback.apply(null, arguments);
      }
    }
  }, [_vm._v(_vm._s(_vm.messages['sessionExpiredFormSignOutBtn']))])])]);
};
var vis_default_session_expired_form_contentvue_type_template_id_79b106b2_staticRenderFns = [];

// CONCATENATED MODULE: ./src/lib/components/vis-default-session-expired-form-content.vue?vue&type=template&id=79b106b2&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/components/vis-default-session-expired-form-content.vue?vue&type=script&lang=js&


/* harmony default export */ var vis_default_session_expired_form_contentvue_type_script_lang_js_ = ({
  name: "vis-default-session-expired-form-content",
  components: {
    VisLoading: vis_loading,
    VisError: vis_error
  },
  props: {
    signInLoading: {
      type: Boolean,
      default: false
    },
    signInError: {
      type: Boolean,
      default: false
    },
    signOutLoading: {
      type: Boolean,
      default: false
    },
    signOutError: {
      type: Boolean,
      default: false
    },
    signInCallback: {
      type: Function,
      default: function _default() {}
    },
    signOutCallback: {
      type: Function,
      default: function _default() {}
    },
    messages: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
});
// CONCATENATED MODULE: ./src/lib/components/vis-default-session-expired-form-content.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_vis_default_session_expired_form_contentvue_type_script_lang_js_ = (vis_default_session_expired_form_contentvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/lib/components/vis-default-session-expired-form-content.vue





/* normalize component */

var vis_default_session_expired_form_content_component = normalizeComponent(
  components_vis_default_session_expired_form_contentvue_type_script_lang_js_,
  vis_default_session_expired_form_contentvue_type_template_id_79b106b2_render,
  vis_default_session_expired_form_contentvue_type_template_id_79b106b2_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var vis_default_session_expired_form_content = (vis_default_session_expired_form_content_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/components/vis-default-session-expired-dialog.vue?vue&type=script&lang=js&





var vis_default_session_expired_dialogvue_type_script_lang_js_defaultComponentName = "vis-default-session-expired-form-content";
/* harmony default export */ var vis_default_session_expired_dialogvue_type_script_lang_js_ = ({
  name: "vis-default-session-expired-dialog",
  components: {
    VisModal: vis_modal,
    VisSessionExpiredForm: vis_session_expired_form,
    VisDefaultSessionExpiredFormContent: vis_default_session_expired_form_content
  },
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    title: function title() {
      return this.$visIdentity.getMessage("sessionExpiredDialogTitle");
    },
    showModal: {
      get: function get() {
        return this.value;
      },
      set: function set(value) {
        this.$emit("input", value);
      }
    },
    componentName: function componentName() {
      return this.isCustomComponent ? overrideComponentNames.sessionExpiredFormContent.kebabCase : vis_default_session_expired_dialogvue_type_script_lang_js_defaultComponentName;
    },
    isCustomComponent: function isCustomComponent() {
      return !!(this.$options.components[overrideComponentNames.sessionExpiredFormContent.camelCase] || this.$options.components[overrideComponentNames.sessionExpiredFormContent.kebabCase]);
    }
  },
  methods: {
    onOk: function onOk() {
      this.showModal = false;
    },
    onCancel: function onCancel() {
      this.showModal = false;
    },
    onClose: function onClose() {
      this.$visIdentity._sessionExpiredDialogFailed(new Error("Session expired dialog canceled."));
    }
  }
});
// CONCATENATED MODULE: ./src/lib/components/vis-default-session-expired-dialog.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_vis_default_session_expired_dialogvue_type_script_lang_js_ = (vis_default_session_expired_dialogvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/lib/components/vis-default-session-expired-dialog.vue





/* normalize component */

var vis_default_session_expired_dialog_component = normalizeComponent(
  components_vis_default_session_expired_dialogvue_type_script_lang_js_,
  vis_default_session_expired_dialogvue_type_template_id_7f5eb750_render,
  vis_default_session_expired_dialogvue_type_template_id_7f5eb750_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var vis_default_session_expired_dialog = (vis_default_session_expired_dialog_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/components/vis-dialogs.vue?vue&type=script&lang=js&


var vis_dialogsvue_type_script_lang_js_defaultComponentName = "vis-default-session-expired-dialog";
/* harmony default export */ var vis_dialogsvue_type_script_lang_js_ = ({
  name: "vis-dialogs",
  components: {
    VisDefaultSessionExpiredDialog: vis_default_session_expired_dialog
  },
  computed: {
    componentName: function componentName() {
      return this.isCustomComponent ? overrideComponentNames.sessionExpiredDialog.kebabCase : vis_dialogsvue_type_script_lang_js_defaultComponentName;
    },
    isCustomComponent: function isCustomComponent() {
      return !!(this.$options.components[overrideComponentNames.sessionExpiredDialog.camelCase] || this.$options.components[overrideComponentNames.sessionExpiredDialog.kebabCase]);
    }
  }
});
// CONCATENATED MODULE: ./src/lib/components/vis-dialogs.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_vis_dialogsvue_type_script_lang_js_ = (vis_dialogsvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/lib/components/vis-dialogs.vue





/* normalize component */

var vis_dialogs_component = normalizeComponent(
  components_vis_dialogsvue_type_script_lang_js_,
  vis_dialogsvue_type_template_id_30bb1133_render,
  vis_dialogsvue_type_template_id_30bb1133_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var vis_dialogs = (vis_dialogs_component.exports);
// EXTERNAL MODULE: ./src/lib/assets/scss/style.scss
var style = __webpack_require__("8713");

// CONCATENATED MODULE: ./src/lib/components/index.js






















// CONCATENATED MODULE: ./src/lib/utils/configure-service.js

/* harmony default export */ var configure_service = (function (options) {
  return auth_service.configure(options);
});
// CONCATENATED MODULE: ./src/lib/utils/index.js










// CONCATENATED MODULE: ./src/lib/index.js





var _excluded = ["router", "axios", "routePaths", "routeCheckAuth", "messages", "locale", "showLogoutPrompt", "useDelegate", "useCustomSessionExpiredDialog", "redirectToSignInOnDialogError", "redirectToSignInOnError", "homeRouteName", "unauthorizedRouteName", "redirectToUnauthorizedRoute", "showRepeatBtnOnError", "showBackToHomeOnError", "useSignInPopup", "useSignOutIframe"];












var lib_plugin = {
  isAuth: null,
  routePaths: {},
  messages: {},
  locale: null,
  showLogoutPrompt: false,
  signInDelegate: null,
  sessionExpiredDialogShown: false,
  sessionExpiredDialogResult: null,
  dialogContainerClass: null,
  dialogContainerInstance: null,
  redirectToSignInOnDialogError: true,
  redirectToSignInOnError: false,
  showRepeatBtnOnError: true,
  showBackToHomeOnError: true,
  useSignInPopup: false,
  useSignOutIframe: false,
  checkAuth: function checkAuth() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var identityUser;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return auth_service.getIdentityUser();
            case 2:
              identityUser = _context.sent;
              _this.isAuth = !!identityUser;
              return _context.abrupt("return", _this.isAuth);
            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  get authService() {
    return auth_service;
  },
  get currentRouter() {
    return getCurrentRouter();
  },
  configure: function configure(options) {
    auth_service.configure(options);
  },
  configureDelegate: function configureDelegate() {
    var _this2 = this;
    this.destroyDelegate();
    this.signInDelegate = signin_delegate(function () {
      return _this2._showSessionExpiredDialog();
    }, function () {
      _this2.checkAuth();
    });
  },
  destroyDelegate: function destroyDelegate() {
    if (this.signInDelegate) {
      this.signInDelegate.destroy();
      this.signInDelegate = null;
    }
  },
  navigateToHome: function navigateToHome(router) {
    var _this$routePaths = this.routePaths,
      homeName = _this$routePaths.homeName,
      home = _this$routePaths.home;
    return this.navigateTo(router, homeName, home);
  },
  navigateToSignIn: function navigateToSignIn(router) {
    var _this$routePaths2 = this.routePaths,
      signInName = _this$routePaths2.signInName,
      signIn = _this$routePaths2.signIn;
    return this.navigateTo(router, signInName, signIn);
  },
  navigateToSignOut: function navigateToSignOut(router) {
    var _this$routePaths3 = this.routePaths,
      signOutName = _this$routePaths3.signOutName,
      signOut = _this$routePaths3.signOut;
    return this.navigateTo(router, signOutName, signOut);
  },
  navigateToUnauthorized: function navigateToUnauthorized(router) {
    var _this$routePaths4 = this.routePaths,
      unauthorizedName = _this$routePaths4.unauthorizedName,
      unauthorized = _this$routePaths4.unauthorized;
    return this.navigateTo(router, unauthorizedName, unauthorized);
  },
  navigateToSignInError: function navigateToSignInError(router) {
    var errorType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var _this$routePaths5 = this.routePaths,
      signInErrorName = _this$routePaths5.signInErrorName,
      signInError = _this$routePaths5.signInError;
    return this.navigateTo(router, signInErrorName, signInError, errorType ? {
      type: errorType
    } : null);
  },
  navigateTo: function navigateTo(router) {
    var routeName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var routePath = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var query = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    if (routeName || routePath) {
      var _router$push;
      var routeProp = routeName ? "name" : "path";
      router.push((_router$push = {}, _defineProperty(_router$push, routeProp, routeName || routePath), _defineProperty(_router$push, "query", query), _router$push));
      return true;
    }
    return false;
  },
  getMessage: function getMessage(key) {
    return this.messages[this.locale] ? this.messages[this.locale][key] : null;
  },
  getMessages: function getMessages() {
    return this.messages[this.locale] ? this.messages[this.locale] : {};
  },
  createDialogContainer: function createDialogContainer() {
    if (this.dialogContainerClass) {
      var DialogContainerClass = this.dialogContainerClass;
      this.dialogContainerInstance = new DialogContainerClass();
      this.dialogContainerInstance.$mount();
    }
  },
  destroyDialogContainer: function destroyDialogContainer() {
    if (this.dialogContainerInstance) {
      this.dialogContainerInstance.$destroy();
      this.dialogContainerInstance = null;
    }
  },
  _showSessionExpiredDialog: function _showSessionExpiredDialog() {
    var _this3 = this;
    this.sessionExpiredDialogShown = true;
    return new Promise(function (resolve, reject) {
      _this3.sessionExpiredDialogResult = {
        resolve: resolve,
        reject: reject
      };
    });
  },
  _closeSessionExpiredDialog: function _closeSessionExpiredDialog() {
    this.sessionExpiredDialogShown = false;
  },
  _sessionExpiredDialogOk: function _sessionExpiredDialogOk() {
    if (this.sessionExpiredDialogResult) {
      this.sessionExpiredDialogResult.resolve();
      this.sessionExpiredDialogResult = null;
    }
  },
  _sessionExpiredDialogFailed: function _sessionExpiredDialogFailed(error) {
    if (this.sessionExpiredDialogResult) {
      this.sessionExpiredDialogResult.reject(error);
      this.sessionExpiredDialogResult = null;
    }
  },
  install: function install(Vue, options) {
    Vue.prototype.$visIdentity = this;
    var _ref = options || {},
      router = _ref.router,
      axios = _ref.axios,
      routePaths = _ref.routePaths,
      routeCheckAuth = _ref.routeCheckAuth,
      messages = _ref.messages,
      locale = _ref.locale,
      showLogoutPrompt = _ref.showLogoutPrompt,
      useDelegate = _ref.useDelegate,
      useCustomSessionExpiredDialog = _ref.useCustomSessionExpiredDialog,
      redirectToSignInOnDialogError = _ref.redirectToSignInOnDialogError,
      redirectToSignInOnError = _ref.redirectToSignInOnError,
      homeRouteName = _ref.homeRouteName,
      unauthorizedRouteName = _ref.unauthorizedRouteName,
      redirectToUnauthorizedRoute = _ref.redirectToUnauthorizedRoute,
      showRepeatBtnOnError = _ref.showRepeatBtnOnError,
      showBackToHomeOnError = _ref.showBackToHomeOnError,
      useSignInPopup = _ref.useSignInPopup,
      useSignOutIframe = _ref.useSignOutIframe,
      identityOptions = _objectWithoutProperties(_ref, _excluded);
    routeCheckAuth = routeCheckAuth === undefined ? true : routeCheckAuth;
    useDelegate = useDelegate === undefined ? true : useDelegate;
    if (homeRouteName) {
      routePaths = _objectSpread2(_objectSpread2({}, routePaths), {}, {
        homeName: homeRouteName
      });
    }
    if (unauthorizedRouteName) {
      routePaths = _objectSpread2(_objectSpread2({}, routePaths), {}, {
        unauthorizedName: unauthorizedRouteName
      });
    }
    if (identityOptions.serverUrl) {
      this.configure(identityOptions);
    }
    if (axios) {
      configure_axios(axios);
    }
    if (router) {
      configure_router(router, routePaths, routeCheckAuth, redirectToUnauthorizedRoute);
    }
    if (useDelegate) {
      this.configureDelegate();
    }
    this.routePaths = merge_route_paths(routePaths);
    this.messages = _objectSpread2(_objectSpread2({}, utils_messages), messages);
    this.locale = locale || defaultLocale;
    if (showLogoutPrompt !== undefined) {
      this.showLogoutPrompt = showLogoutPrompt;
    }
    if (redirectToSignInOnDialogError !== undefined) {
      this.redirectToSignInOnDialogError = redirectToSignInOnDialogError;
    }
    if (redirectToSignInOnError !== undefined) {
      this.redirectToSignInOnError = redirectToSignInOnError;
    }
    if (showRepeatBtnOnError !== undefined) {
      this.showRepeatBtnOnError = showRepeatBtnOnError;
    }
    if (showBackToHomeOnError !== undefined) {
      this.showBackToHomeOnError = showBackToHomeOnError;
    }
    if (useSignInPopup !== undefined) {
      this.useSignInPopup = useSignInPopup;
    }
    if (useSignOutIframe !== undefined) {
      this.useSignOutIframe = useSignOutIframe;
    }
    Vue.util.defineReactive(this, "isAuth", this.isAuth);
    Vue.util.defineReactive(this, "messages", this.messages);
    Vue.util.defineReactive(this, "locale", this.locale);
    Vue.util.defineReactive(this, "sessionExpiredDialogShown", this.sessionExpiredDialogShown);
    if (!useCustomSessionExpiredDialog) {
      this.dialogContainerClass = Vue.extend(vis_dialogs);
      this.createDialogContainer();
    }
  }
};
if (typeof window !== 'undefined' && window.Vue) {
  lib_plugin.install(window.Vue);
}
/* harmony default export */ var lib = (lib_plugin);


// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ var entry_lib = __webpack_exports__["default"] = (lib);



/***/ }),

/***/ "fb6a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var isArray = __webpack_require__("e8b5");
var isConstructor = __webpack_require__("68ee");
var isObject = __webpack_require__("861d");
var toAbsoluteIndex = __webpack_require__("23cb");
var lengthOfArrayLike = __webpack_require__("07fa");
var toIndexedObject = __webpack_require__("fc6a");
var createProperty = __webpack_require__("8418");
var wellKnownSymbol = __webpack_require__("b622");
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");
var nativeSlice = __webpack_require__("f36a");

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('slice');

var SPECIES = wellKnownSymbol('species');
var $Array = Array;
var max = Math.max;

// `Array.prototype.slice` method
// https://tc39.es/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  slice: function slice(start, end) {
    var O = toIndexedObject(this);
    var length = lengthOfArrayLike(O);
    var k = toAbsoluteIndex(start, length);
    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
    // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
    var Constructor, result, n;
    if (isArray(O)) {
      Constructor = O.constructor;
      // cross-realm fallback
      if (isConstructor(Constructor) && (Constructor === $Array || isArray(Constructor.prototype))) {
        Constructor = undefined;
      } else if (isObject(Constructor)) {
        Constructor = Constructor[SPECIES];
        if (Constructor === null) Constructor = undefined;
      }
      if (Constructor === $Array || Constructor === undefined) {
        return nativeSlice(O, k, fin);
      }
    }
    result = new (Constructor === undefined ? $Array : Constructor)(max(fin - k, 0));
    for (n = 0; k < fin; k++, n++) if (k in O) createProperty(result, n, O[k]);
    result.length = n;
    return result;
  }
});


/***/ }),

/***/ "fc6a":
/***/ (function(module, exports, __webpack_require__) {

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__("44ad");
var requireObjectCoercible = __webpack_require__("1d80");

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),

/***/ "fdbc":
/***/ (function(module, exports) {

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};


/***/ }),

/***/ "fdbf":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL = __webpack_require__("04f8");

module.exports = NATIVE_SYMBOL
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';


/***/ })

/******/ });
//# sourceMappingURL=visary-identity-vue.common.js.map